@charset "UTF-8";
/** This file is used for including a bootstrap component on a non-bootstrap page.
      It will force bootstrap classes to remain in a local scope.
       Usage: Put all bootstrap html inside a div with class 'bootstrap'
       Assuming the classes are loaded into "styles", refer to classes as styles['container-fluid']
**/
:global(.bootstrap) {
  /*!
   * Bootstrap  v5.3.2 (https://getbootstrap.com/)
   * Copyright 2011-2023 The Bootstrap Authors
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   */
  /* rtl:raw:
  [type="tel"],
  [type="url"],
  [type="email"],
  [type="number"] {
    direction: ltr;
  }
  */
  /* rtl:begin:ignore */
  /* rtl:end:ignore */
  /* rtl:begin:ignore */
  /* rtl:end:ignore */
  /* rtl:begin:ignore */
  /* rtl:end:ignore */
  /* rtl:begin:ignore */
  /* rtl:end:ignore */
  /* rtl:options: {
    "autoRename": true,
    "stringMap":[ {
      "name"    : "prev-next",
      "search"  : "prev",
      "replace" : "next"
    } ]
  } */
  /* rtl:begin:remove */
  /* rtl:end:remove */
  /* The typewriter blinking cursor effect */
  /* various animations */
  /** Usage:
     * Add .sticky to the block that should stick to the top
     * Set data-stick-after to determine when the element should stick
   */
  /** Usage:
     * Add .collapsible to the block
     * Customizable variables (defaults set above in :root):
     *    --collapsible-more
     *    --collapsible-less
     *    --collapsible-show-lines
     *    --collapsible-line-height
     *    --collapsible-overlay-height
     *    --collapsible-overlay-color-start
     *    --collapsible-overlay-color-end
     * Add .collapsible-by-height to avoid using line-clamp (for long content, with images, videos, etc..) using --collapsible-overlay-height
     * Add .collapsible-end to position the collapsible toggle on the right side with the overlay at the end
     * Add .collapsible-center to position the collapsible toggle in the center of the overlay
     * Add .collapsible-toggle-button to display a button instead of a link
     * Add .collapsible-hide-toggle to hide the "after" (Read more) link. Used for when the toggle is controlled by the html, not css
     * Accepts data-scroll-to-on-close` on the collapsible element
   */
  /**
    Filters
  */
  /** used on "The Q" LP **/
  /* border-between styles */
  /* changes for mobile */
}
:global(.bootstrap) :root,
:global(.bootstrap) [data-bs-theme=light] {
  --bs-blue: #36627F;
  --bs-blue-hover: #0a4d78;
  --bs-blue-link: #2a8ecf;
  --bs-indigo: #785CA7;
  --bs-purple: #785CA7;
  --bs-pink: #E94A7E;
  --bs-red: #FF0000;
  --bs-reddark: #bc0505;
  --bs-orange: #FD964C;
  --bs-yellow: #FFD700;
  --bs-yellowdark: #FFCC00;
  --bs-green: #70CACA;
  --bs-teal: #70CACA;
  --bs-cyan: #70CACA;
  --bs-white: #fff;
  --bs-gray: #E5E6E1;
  --bs-gray-dark: #848484;
  --bs-gray-100: #FAFAFA;
  --bs-gray-200: #F5F5F5;
  --bs-gray-300: #ededed;
  --bs-gray-400: #E5E6E1;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #A9A9A9;
  --bs-gray-700: #848484;
  --bs-gray-800: #666560;
  --bs-gray-900: #4D4D4D;
  --bs-primary: #FFD700;
  --bs-secondary: #08090D;
  --bs-success: #07C960;
  --bs-info: #785CA7;
  --bs-warning: #FD964C;
  --bs-danger: #bc0505;
  --bs-light: #F5F5F5;
  --bs-medium: #848484;
  --bs-dark: #4D4D4D;
  --bs-pro: #07C960;
  --bs-con: #bc0505;
  --bs-primary-rgb: 255, 215, 0;
  --bs-secondary-rgb: 8, 9, 13;
  --bs-success-rgb: 7, 201, 96;
  --bs-info-rgb: 120, 92, 167;
  --bs-warning-rgb: 253, 150, 76;
  --bs-danger-rgb: 188, 5, 5;
  --bs-light-rgb: 245, 245, 245;
  --bs-medium-rgb: 132, 132, 132;
  --bs-dark-rgb: 77, 77, 77;
  --bs-pro-rgb: 7, 201, 96;
  --bs-con-rgb: 188, 5, 5;
  --bs-primary-text-emphasis: #665600;
  --bs-secondary-text-emphasis: #030405;
  --bs-success-text-emphasis: #035026;
  --bs-info-text-emphasis: #302543;
  --bs-warning-text-emphasis: #653c1e;
  --bs-danger-text-emphasis: #4b0202;
  --bs-light-text-emphasis: #848484;
  --bs-dark-text-emphasis: #848484;
  --bs-primary-bg-subtle: #fff7cc;
  --bs-secondary-bg-subtle: #cececf;
  --bs-success-bg-subtle: #cdf4df;
  --bs-info-bg-subtle: #e4deed;
  --bs-warning-bg-subtle: #ffeadb;
  --bs-danger-bg-subtle: #f2cdcd;
  --bs-light-bg-subtle: #fdfdfd;
  --bs-dark-bg-subtle: #E5E6E1;
  --bs-primary-border-subtle: #ffef99;
  --bs-secondary-border-subtle: #9c9d9e;
  --bs-success-border-subtle: #9ce9bf;
  --bs-info-border-subtle: #c9bedc;
  --bs-warning-border-subtle: #fed5b7;
  --bs-danger-border-subtle: #e49b9b;
  --bs-light-border-subtle: #F5F5F5;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 8, 9, 13;
  --bs-font-sans-serif: "Lato", sans-serif;
  --bs-font-monospace: "Martel", serif;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: "Lato", sans-serif;
  --bs-body-font-size: 0.875rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #848484;
  --bs-body-color-rgb: 132, 132, 132;
  --bs-body-bg: #f5f6f8;
  --bs-body-bg-rgb: 245, 246, 248;
  --bs-emphasis-color: #08090D;
  --bs-emphasis-color-rgb: 8, 9, 13;
  --bs-secondary-color: rgba(132, 132, 132, 0.75);
  --bs-secondary-color-rgb: 132, 132, 132;
  --bs-secondary-bg: #F5F5F5;
  --bs-secondary-bg-rgb: 245, 245, 245;
  --bs-tertiary-color: rgba(132, 132, 132, 0.5);
  --bs-tertiary-color-rgb: 132, 132, 132;
  --bs-tertiary-bg: #FAFAFA;
  --bs-tertiary-bg-rgb: 250, 250, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #FFD700;
  --bs-link-color-rgb: 255, 215, 0;
  --bs-link-decoration: none;
  --bs-link-hover-color: #b39700;
  --bs-link-hover-color-rgb: 179, 151, 0;
  --bs-link-hover-decoration: none;
  --bs-code-color: #E94A7E;
  --bs-highlight-color: #848484;
  --bs-highlight-bg: #fcf8e3;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #f3f3f3;
  --bs-border-color-translucent: rgba(8, 9, 13, 0.175);
  --bs-border-radius: 0.25rem;
  --bs-border-radius-sm: 0.2rem;
  --bs-border-radius-lg: 0.3rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
  --bs-box-shadow-sm: 0 0.75rem 6rem rgba(56, 65, 74, 0.03);
  --bs-box-shadow-lg: 0 0 45px 0 rgba(0, 0, 0, 0.12);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(8, 9, 13, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(255, 215, 0, 0.25);
  --bs-form-valid-color: #07C960;
  --bs-form-valid-border-color: #07C960;
  --bs-form-invalid-color: #bc0505;
  --bs-form-invalid-border-color: #bc0505;
}
:global(.bootstrap) [data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #ededed;
  --bs-body-color-rgb: 237, 237, 237;
  --bs-body-bg: #4D4D4D;
  --bs-body-bg-rgb: 77, 77, 77;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(237, 237, 237, 0.75);
  --bs-secondary-color-rgb: 237, 237, 237;
  --bs-secondary-bg: #666560;
  --bs-secondary-bg-rgb: 102, 101, 96;
  --bs-tertiary-color: rgba(237, 237, 237, 0.5);
  --bs-tertiary-color-rgb: 237, 237, 237;
  --bs-tertiary-bg: #5a5957;
  --bs-tertiary-bg-rgb: 90, 89, 87;
  --bs-primary-text-emphasis: #ffe766;
  --bs-secondary-text-emphasis: #6b6b6e;
  --bs-success-text-emphasis: #6adfa0;
  --bs-info-text-emphasis: #ae9dca;
  --bs-warning-text-emphasis: #fec094;
  --bs-danger-text-emphasis: #d76969;
  --bs-light-text-emphasis: #FAFAFA;
  --bs-dark-text-emphasis: #ededed;
  --bs-primary-bg-subtle: #332b00;
  --bs-secondary-bg-subtle: #020203;
  --bs-success-bg-subtle: #012813;
  --bs-info-bg-subtle: #181221;
  --bs-warning-bg-subtle: #331e0f;
  --bs-danger-bg-subtle: #260101;
  --bs-light-bg-subtle: #666560;
  --bs-dark-bg-subtle: #373737;
  --bs-primary-border-subtle: #998100;
  --bs-secondary-border-subtle: #050508;
  --bs-success-border-subtle: #04793a;
  --bs-info-border-subtle: #483764;
  --bs-warning-border-subtle: #985a2e;
  --bs-danger-border-subtle: #710303;
  --bs-light-border-subtle: #848484;
  --bs-dark-border-subtle: #666560;
  --bs-heading-color: inherit;
  --bs-link-color: #ffe766;
  --bs-link-hover-color: #ffec85;
  --bs-link-color-rgb: 255, 231, 102;
  --bs-link-hover-color-rgb: 255, 236, 133;
  --bs-code-color: #f292b2;
  --bs-highlight-color: #ededed;
  --bs-highlight-bg: #665600;
  --bs-border-color: #848484;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #a9dfdf;
  --bs-form-valid-border-color: #a9dfdf;
  --bs-form-invalid-color: #ff6666;
  --bs-form-invalid-border-color: #ff6666;
}
:global(.bootstrap) *,
:global(.bootstrap) *::before,
:global(.bootstrap) *::after {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: no-preference) {
  :global(.bootstrap) :root {
    scroll-behavior: smooth;
  }
}
:global(.bootstrap) body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(8, 9, 13, 0);
}
:global(.bootstrap) hr {
  margin: 1.5rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid #f3f3f3;
  opacity: 0.25;
}
:global(.bootstrap) h6, :global(.bootstrap) .h6, :global(.bootstrap) h5, :global(.bootstrap) .h5, :global(.bootstrap) h4, :global(.bootstrap) .h4, :global(.bootstrap) h3, :global(.bootstrap) .h3, :global(.bootstrap) h2, :global(.bootstrap) .h2, :global(.bootstrap) h1, :global(.bootstrap) .h1 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  font-weight: 400;
  line-height: 1.1;
  color: var(--bs-heading-color);
}
:global(.bootstrap) h1, :global(.bootstrap) .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  :global(.bootstrap) h1, :global(.bootstrap) .h1 {
    font-size: 2.5rem;
  }
}
:global(.bootstrap) h2, :global(.bootstrap) .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  :global(.bootstrap) h2, :global(.bootstrap) .h2 {
    font-size: 2rem;
  }
}
:global(.bootstrap) h3, :global(.bootstrap) .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  :global(.bootstrap) h3, :global(.bootstrap) .h3 {
    font-size: 1.75rem;
  }
}
:global(.bootstrap) h4, :global(.bootstrap) .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  :global(.bootstrap) h4, :global(.bootstrap) .h4 {
    font-size: 1.5rem;
  }
}
:global(.bootstrap) h5, :global(.bootstrap) .h5 {
  font-size: 1.25rem;
}
:global(.bootstrap) h6, :global(.bootstrap) .h6 {
  font-size: 1rem;
}
:global(.bootstrap) p {
  margin-top: 0;
  margin-bottom: 1rem;
}
:global(.bootstrap) abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}
:global(.bootstrap) address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}
:global(.bootstrap) ol,
:global(.bootstrap) ul {
  padding-left: 2rem;
}
:global(.bootstrap) ol,
:global(.bootstrap) ul,
:global(.bootstrap) dl {
  margin-top: 0;
  margin-bottom: 1rem;
}
:global(.bootstrap) ol ol,
:global(.bootstrap) ul ul,
:global(.bootstrap) ol ul,
:global(.bootstrap) ul ol {
  margin-bottom: 0;
}
:global(.bootstrap) dt {
  font-weight: 700;
}
:global(.bootstrap) dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}
:global(.bootstrap) blockquote {
  margin: 0 0 1rem;
}
:global(.bootstrap) b,
:global(.bootstrap) strong {
  font-weight: bolder;
}
:global(.bootstrap) small, :global(.bootstrap) .small {
  font-size: 0.75rem;
}
:global(.bootstrap) mark, :global(.bootstrap) .mark {
  padding: 0.2em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}
:global(.bootstrap) sub,
:global(.bootstrap) sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}
:global(.bootstrap) sub {
  bottom: -0.25em;
}
:global(.bootstrap) sup {
  top: -0.5em;
}
:global(.bootstrap) a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none;
}
:global(.bootstrap) a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
  text-decoration: none;
}
:global(.bootstrap) a:not([href]):not([class]), :global(.bootstrap) a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}
:global(.bootstrap) pre,
:global(.bootstrap) code,
:global(.bootstrap) kbd,
:global(.bootstrap) samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}
:global(.bootstrap) pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 87.5%;
  color: #4D4D4D;
}
:global(.bootstrap) pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}
:global(.bootstrap) code {
  font-size: 87.5%;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > :global(.bootstrap) code {
  color: inherit;
}
:global(.bootstrap) kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #4D4D4D;
  border-radius: 0.2rem;
}
:global(.bootstrap) kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 700;
}
:global(.bootstrap) figure {
  margin: 0 0 1rem;
}
:global(.bootstrap) img,
:global(.bootstrap) svg {
  vertical-align: middle;
}
:global(.bootstrap) table {
  caption-side: bottom;
  border-collapse: collapse;
}
:global(.bootstrap) caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #A9A9A9;
  text-align: left;
}
:global(.bootstrap) th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}
:global(.bootstrap) thead,
:global(.bootstrap) tbody,
:global(.bootstrap) tfoot,
:global(.bootstrap) tr,
:global(.bootstrap) td,
:global(.bootstrap) th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}
:global(.bootstrap) label {
  display: inline-block;
}
:global(.bootstrap) button {
  border-radius: 0;
}
:global(.bootstrap) button:focus:not(:focus-visible) {
  outline: 0;
}
:global(.bootstrap) input,
:global(.bootstrap) button,
:global(.bootstrap) select,
:global(.bootstrap) optgroup,
:global(.bootstrap) textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
:global(.bootstrap) button,
:global(.bootstrap) select {
  text-transform: none;
}
:global(.bootstrap) [role=button] {
  cursor: pointer;
}
:global(.bootstrap) select {
  word-wrap: normal;
}
:global(.bootstrap) select:disabled {
  opacity: 1;
}
:global(.bootstrap) [list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}
:global(.bootstrap) button,
:global(.bootstrap) [type=button],
:global(.bootstrap) [type=reset],
:global(.bootstrap) [type=submit] {
  -webkit-appearance: button;
}
:global(.bootstrap) button:not(:disabled),
:global(.bootstrap) [type=button]:not(:disabled),
:global(.bootstrap) [type=reset]:not(:disabled),
:global(.bootstrap) [type=submit]:not(:disabled) {
  cursor: pointer;
}
:global(.bootstrap) ::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
:global(.bootstrap) textarea {
  resize: vertical;
}
:global(.bootstrap) fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
:global(.bootstrap) legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  :global(.bootstrap) legend {
    font-size: 1.5rem;
  }
}
:global(.bootstrap) legend + * {
  clear: left;
}
:global(.bootstrap) ::-webkit-datetime-edit-fields-wrapper,
:global(.bootstrap) ::-webkit-datetime-edit-text,
:global(.bootstrap) ::-webkit-datetime-edit-minute,
:global(.bootstrap) ::-webkit-datetime-edit-hour-field,
:global(.bootstrap) ::-webkit-datetime-edit-day-field,
:global(.bootstrap) ::-webkit-datetime-edit-month-field,
:global(.bootstrap) ::-webkit-datetime-edit-year-field {
  padding: 0;
}
:global(.bootstrap) ::-webkit-inner-spin-button {
  height: auto;
}
:global(.bootstrap) [type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
:global(.bootstrap) ::-webkit-search-decoration {
  -webkit-appearance: none;
}
:global(.bootstrap) ::-webkit-color-swatch-wrapper {
  padding: 0;
}
:global(.bootstrap) ::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}
:global(.bootstrap) output {
  display: inline-block;
}
:global(.bootstrap) iframe {
  border: 0;
}
:global(.bootstrap) summary {
  display: list-item;
  cursor: pointer;
}
:global(.bootstrap) progress {
  vertical-align: baseline;
}
:global(.bootstrap) [hidden] {
  display: none !important;
}
:global(.bootstrap) .lead {
  font-size: 1.09375rem;
  font-weight: 300;
}
:global(.bootstrap) .display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.1;
}
@media (min-width: 1200px) {
  :global(.bootstrap) .display-1 {
    font-size: 5rem;
  }
}
:global(.bootstrap) .display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.1;
}
@media (min-width: 1200px) {
  :global(.bootstrap) .display-2 {
    font-size: 4.5rem;
  }
}
:global(.bootstrap) .display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.1;
}
@media (min-width: 1200px) {
  :global(.bootstrap) .display-3 {
    font-size: 4rem;
  }
}
:global(.bootstrap) .display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.1;
}
@media (min-width: 1200px) {
  :global(.bootstrap) .display-4 {
    font-size: 3.5rem;
  }
}
:global(.bootstrap) .display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.1;
}
@media (min-width: 1200px) {
  :global(.bootstrap) .display-5 {
    font-size: 3rem;
  }
}
:global(.bootstrap) .display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.1;
}
@media (min-width: 1200px) {
  :global(.bootstrap) .display-6 {
    font-size: 2.5rem;
  }
}
:global(.bootstrap) .list-unstyled {
  padding-left: 0;
  list-style: none;
}
:global(.bootstrap) .list-inline {
  padding-left: 0;
  list-style: none;
}
:global(.bootstrap) .list-inline-item {
  display: inline-block;
}
:global(.bootstrap) .list-inline-item:not(:last-child) {
  margin-right: 6px;
}
:global(.bootstrap) .initialism {
  font-size: 0.75rem;
  text-transform: uppercase;
}
:global(.bootstrap) .blockquote {
  margin-bottom: 1.5rem;
  font-size: 1.09375rem;
}
:global(.bootstrap) .blockquote > :last-child {
  margin-bottom: 0;
}
:global(.bootstrap) .blockquote-footer {
  margin-top: -1.5rem;
  margin-bottom: 1.5rem;
  font-size: 0.75rem;
  color: #A9A9A9;
}
:global(.bootstrap) .blockquote-footer::before {
  content: "— ";
}
:global(.bootstrap) .img-fluid {
  max-width: 100%;
  height: auto;
}
:global(.bootstrap) .img-thumbnail {
  padding: 0.25rem;
  background-color: #f5f6f8;
  border: 1px solid #ededed;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}
:global(.bootstrap) .figure {
  display: inline-block;
}
:global(.bootstrap) .figure-img {
  margin-bottom: 0.75rem;
  line-height: 1;
}
:global(.bootstrap) .figure-caption {
  font-size: 90%;
  color: #A9A9A9;
}
:global(.bootstrap) .container,
:global(.bootstrap) .container-fluid,
:global(.bootstrap) .container-xxl,
:global(.bootstrap) .container-xl,
:global(.bootstrap) .container-lg,
:global(.bootstrap) .container-md,
:global(.bootstrap) .container-sm {
  --bs-gutter-x: 24px;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  :global(.bootstrap) .container-sm, :global(.bootstrap) .container {
    max-width: 540px;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .container-md, :global(.bootstrap) .container-sm, :global(.bootstrap) .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  :global(.bootstrap) .container-lg, :global(.bootstrap) .container-md, :global(.bootstrap) .container-sm, :global(.bootstrap) .container {
    max-width: 960px;
  }
}
@media (min-width: 1367px) {
  :global(.bootstrap) .container-xl, :global(.bootstrap) .container-lg, :global(.bootstrap) .container-md, :global(.bootstrap) .container-sm, :global(.bootstrap) .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  :global(.bootstrap) .container-xxl, :global(.bootstrap) .container-xl, :global(.bootstrap) .container-lg, :global(.bootstrap) .container-md, :global(.bootstrap) .container-sm, :global(.bootstrap) .container {
    max-width: 1320px;
  }
}
:global(.bootstrap) :root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 813px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1367px;
  --bs-breakpoint-xxl: 1400px;
}
:global(.bootstrap) .row {
  --bs-gutter-x: 24px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
:global(.bootstrap) .row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}
:global(.bootstrap) .col {
  flex: 1 0 0%;
}
:global(.bootstrap) .row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}
:global(.bootstrap) .row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}
:global(.bootstrap) .row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}
:global(.bootstrap) .row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}
:global(.bootstrap) .row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}
:global(.bootstrap) .row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}
:global(.bootstrap) .row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}
:global(.bootstrap) .col-auto {
  flex: 0 0 auto;
  width: auto;
}
:global(.bootstrap) .col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}
:global(.bootstrap) .col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}
:global(.bootstrap) .col-3 {
  flex: 0 0 auto;
  width: 25%;
}
:global(.bootstrap) .col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}
:global(.bootstrap) .col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}
:global(.bootstrap) .col-6 {
  flex: 0 0 auto;
  width: 50%;
}
:global(.bootstrap) .col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}
:global(.bootstrap) .col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}
:global(.bootstrap) .col-9 {
  flex: 0 0 auto;
  width: 75%;
}
:global(.bootstrap) .col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}
:global(.bootstrap) .col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}
:global(.bootstrap) .col-12 {
  flex: 0 0 auto;
  width: 100%;
}
:global(.bootstrap) .offset-1 {
  margin-left: 8.33333333%;
}
:global(.bootstrap) .offset-2 {
  margin-left: 16.66666667%;
}
:global(.bootstrap) .offset-3 {
  margin-left: 25%;
}
:global(.bootstrap) .offset-4 {
  margin-left: 33.33333333%;
}
:global(.bootstrap) .offset-5 {
  margin-left: 41.66666667%;
}
:global(.bootstrap) .offset-6 {
  margin-left: 50%;
}
:global(.bootstrap) .offset-7 {
  margin-left: 58.33333333%;
}
:global(.bootstrap) .offset-8 {
  margin-left: 66.66666667%;
}
:global(.bootstrap) .offset-9 {
  margin-left: 75%;
}
:global(.bootstrap) .offset-10 {
  margin-left: 83.33333333%;
}
:global(.bootstrap) .offset-11 {
  margin-left: 91.66666667%;
}
:global(.bootstrap) .g-0,
:global(.bootstrap) .gx-0 {
  --bs-gutter-x: 0;
}
:global(.bootstrap) .g-0,
:global(.bootstrap) .gy-0 {
  --bs-gutter-y: 0;
}
:global(.bootstrap) .g-1,
:global(.bootstrap) .gx-1 {
  --bs-gutter-x: 0.375rem;
}
:global(.bootstrap) .g-1,
:global(.bootstrap) .gy-1 {
  --bs-gutter-y: 0.375rem;
}
:global(.bootstrap) .g-2,
:global(.bootstrap) .gx-2 {
  --bs-gutter-x: 0.75rem;
}
:global(.bootstrap) .g-2,
:global(.bootstrap) .gy-2 {
  --bs-gutter-y: 0.75rem;
}
:global(.bootstrap) .g-3,
:global(.bootstrap) .gx-3 {
  --bs-gutter-x: 1.5rem;
}
:global(.bootstrap) .g-3,
:global(.bootstrap) .gy-3 {
  --bs-gutter-y: 1.5rem;
}
:global(.bootstrap) .g-4,
:global(.bootstrap) .gx-4 {
  --bs-gutter-x: 2.25rem;
}
:global(.bootstrap) .g-4,
:global(.bootstrap) .gy-4 {
  --bs-gutter-y: 2.25rem;
}
:global(.bootstrap) .g-5,
:global(.bootstrap) .gx-5 {
  --bs-gutter-x: 4.5rem;
}
:global(.bootstrap) .g-5,
:global(.bootstrap) .gy-5 {
  --bs-gutter-y: 4.5rem;
}
@media (min-width: 576px) {
  :global(.bootstrap) .col-sm {
    flex: 1 0 0%;
  }
  :global(.bootstrap) .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  :global(.bootstrap) .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  :global(.bootstrap) .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  :global(.bootstrap) .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  :global(.bootstrap) .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  :global(.bootstrap) .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  :global(.bootstrap) .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  :global(.bootstrap) .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  :global(.bootstrap) .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  :global(.bootstrap) .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  :global(.bootstrap) .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  :global(.bootstrap) .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  :global(.bootstrap) .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  :global(.bootstrap) .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  :global(.bootstrap) .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  :global(.bootstrap) .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  :global(.bootstrap) .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  :global(.bootstrap) .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  :global(.bootstrap) .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  :global(.bootstrap) .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  :global(.bootstrap) .offset-sm-0 {
    margin-left: 0;
  }
  :global(.bootstrap) .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  :global(.bootstrap) .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  :global(.bootstrap) .offset-sm-3 {
    margin-left: 25%;
  }
  :global(.bootstrap) .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  :global(.bootstrap) .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  :global(.bootstrap) .offset-sm-6 {
    margin-left: 50%;
  }
  :global(.bootstrap) .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  :global(.bootstrap) .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  :global(.bootstrap) .offset-sm-9 {
    margin-left: 75%;
  }
  :global(.bootstrap) .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  :global(.bootstrap) .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  :global(.bootstrap) .g-sm-0,
  :global(.bootstrap) .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  :global(.bootstrap) .g-sm-0,
  :global(.bootstrap) .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  :global(.bootstrap) .g-sm-1,
  :global(.bootstrap) .gx-sm-1 {
    --bs-gutter-x: 0.375rem;
  }
  :global(.bootstrap) .g-sm-1,
  :global(.bootstrap) .gy-sm-1 {
    --bs-gutter-y: 0.375rem;
  }
  :global(.bootstrap) .g-sm-2,
  :global(.bootstrap) .gx-sm-2 {
    --bs-gutter-x: 0.75rem;
  }
  :global(.bootstrap) .g-sm-2,
  :global(.bootstrap) .gy-sm-2 {
    --bs-gutter-y: 0.75rem;
  }
  :global(.bootstrap) .g-sm-3,
  :global(.bootstrap) .gx-sm-3 {
    --bs-gutter-x: 1.5rem;
  }
  :global(.bootstrap) .g-sm-3,
  :global(.bootstrap) .gy-sm-3 {
    --bs-gutter-y: 1.5rem;
  }
  :global(.bootstrap) .g-sm-4,
  :global(.bootstrap) .gx-sm-4 {
    --bs-gutter-x: 2.25rem;
  }
  :global(.bootstrap) .g-sm-4,
  :global(.bootstrap) .gy-sm-4 {
    --bs-gutter-y: 2.25rem;
  }
  :global(.bootstrap) .g-sm-5,
  :global(.bootstrap) .gx-sm-5 {
    --bs-gutter-x: 4.5rem;
  }
  :global(.bootstrap) .g-sm-5,
  :global(.bootstrap) .gy-sm-5 {
    --bs-gutter-y: 4.5rem;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .col-md {
    flex: 1 0 0%;
  }
  :global(.bootstrap) .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  :global(.bootstrap) .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  :global(.bootstrap) .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  :global(.bootstrap) .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  :global(.bootstrap) .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  :global(.bootstrap) .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  :global(.bootstrap) .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  :global(.bootstrap) .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  :global(.bootstrap) .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  :global(.bootstrap) .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  :global(.bootstrap) .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  :global(.bootstrap) .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  :global(.bootstrap) .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  :global(.bootstrap) .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  :global(.bootstrap) .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  :global(.bootstrap) .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  :global(.bootstrap) .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  :global(.bootstrap) .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  :global(.bootstrap) .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  :global(.bootstrap) .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  :global(.bootstrap) .offset-md-0 {
    margin-left: 0;
  }
  :global(.bootstrap) .offset-md-1 {
    margin-left: 8.33333333%;
  }
  :global(.bootstrap) .offset-md-2 {
    margin-left: 16.66666667%;
  }
  :global(.bootstrap) .offset-md-3 {
    margin-left: 25%;
  }
  :global(.bootstrap) .offset-md-4 {
    margin-left: 33.33333333%;
  }
  :global(.bootstrap) .offset-md-5 {
    margin-left: 41.66666667%;
  }
  :global(.bootstrap) .offset-md-6 {
    margin-left: 50%;
  }
  :global(.bootstrap) .offset-md-7 {
    margin-left: 58.33333333%;
  }
  :global(.bootstrap) .offset-md-8 {
    margin-left: 66.66666667%;
  }
  :global(.bootstrap) .offset-md-9 {
    margin-left: 75%;
  }
  :global(.bootstrap) .offset-md-10 {
    margin-left: 83.33333333%;
  }
  :global(.bootstrap) .offset-md-11 {
    margin-left: 91.66666667%;
  }
  :global(.bootstrap) .g-md-0,
  :global(.bootstrap) .gx-md-0 {
    --bs-gutter-x: 0;
  }
  :global(.bootstrap) .g-md-0,
  :global(.bootstrap) .gy-md-0 {
    --bs-gutter-y: 0;
  }
  :global(.bootstrap) .g-md-1,
  :global(.bootstrap) .gx-md-1 {
    --bs-gutter-x: 0.375rem;
  }
  :global(.bootstrap) .g-md-1,
  :global(.bootstrap) .gy-md-1 {
    --bs-gutter-y: 0.375rem;
  }
  :global(.bootstrap) .g-md-2,
  :global(.bootstrap) .gx-md-2 {
    --bs-gutter-x: 0.75rem;
  }
  :global(.bootstrap) .g-md-2,
  :global(.bootstrap) .gy-md-2 {
    --bs-gutter-y: 0.75rem;
  }
  :global(.bootstrap) .g-md-3,
  :global(.bootstrap) .gx-md-3 {
    --bs-gutter-x: 1.5rem;
  }
  :global(.bootstrap) .g-md-3,
  :global(.bootstrap) .gy-md-3 {
    --bs-gutter-y: 1.5rem;
  }
  :global(.bootstrap) .g-md-4,
  :global(.bootstrap) .gx-md-4 {
    --bs-gutter-x: 2.25rem;
  }
  :global(.bootstrap) .g-md-4,
  :global(.bootstrap) .gy-md-4 {
    --bs-gutter-y: 2.25rem;
  }
  :global(.bootstrap) .g-md-5,
  :global(.bootstrap) .gx-md-5 {
    --bs-gutter-x: 4.5rem;
  }
  :global(.bootstrap) .g-md-5,
  :global(.bootstrap) .gy-md-5 {
    --bs-gutter-y: 4.5rem;
  }
}
@media (min-width: 992px) {
  :global(.bootstrap) .col-lg {
    flex: 1 0 0%;
  }
  :global(.bootstrap) .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  :global(.bootstrap) .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  :global(.bootstrap) .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  :global(.bootstrap) .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  :global(.bootstrap) .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  :global(.bootstrap) .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  :global(.bootstrap) .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  :global(.bootstrap) .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  :global(.bootstrap) .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  :global(.bootstrap) .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  :global(.bootstrap) .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  :global(.bootstrap) .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  :global(.bootstrap) .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  :global(.bootstrap) .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  :global(.bootstrap) .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  :global(.bootstrap) .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  :global(.bootstrap) .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  :global(.bootstrap) .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  :global(.bootstrap) .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  :global(.bootstrap) .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  :global(.bootstrap) .offset-lg-0 {
    margin-left: 0;
  }
  :global(.bootstrap) .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  :global(.bootstrap) .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  :global(.bootstrap) .offset-lg-3 {
    margin-left: 25%;
  }
  :global(.bootstrap) .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  :global(.bootstrap) .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  :global(.bootstrap) .offset-lg-6 {
    margin-left: 50%;
  }
  :global(.bootstrap) .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  :global(.bootstrap) .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  :global(.bootstrap) .offset-lg-9 {
    margin-left: 75%;
  }
  :global(.bootstrap) .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  :global(.bootstrap) .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  :global(.bootstrap) .g-lg-0,
  :global(.bootstrap) .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  :global(.bootstrap) .g-lg-0,
  :global(.bootstrap) .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  :global(.bootstrap) .g-lg-1,
  :global(.bootstrap) .gx-lg-1 {
    --bs-gutter-x: 0.375rem;
  }
  :global(.bootstrap) .g-lg-1,
  :global(.bootstrap) .gy-lg-1 {
    --bs-gutter-y: 0.375rem;
  }
  :global(.bootstrap) .g-lg-2,
  :global(.bootstrap) .gx-lg-2 {
    --bs-gutter-x: 0.75rem;
  }
  :global(.bootstrap) .g-lg-2,
  :global(.bootstrap) .gy-lg-2 {
    --bs-gutter-y: 0.75rem;
  }
  :global(.bootstrap) .g-lg-3,
  :global(.bootstrap) .gx-lg-3 {
    --bs-gutter-x: 1.5rem;
  }
  :global(.bootstrap) .g-lg-3,
  :global(.bootstrap) .gy-lg-3 {
    --bs-gutter-y: 1.5rem;
  }
  :global(.bootstrap) .g-lg-4,
  :global(.bootstrap) .gx-lg-4 {
    --bs-gutter-x: 2.25rem;
  }
  :global(.bootstrap) .g-lg-4,
  :global(.bootstrap) .gy-lg-4 {
    --bs-gutter-y: 2.25rem;
  }
  :global(.bootstrap) .g-lg-5,
  :global(.bootstrap) .gx-lg-5 {
    --bs-gutter-x: 4.5rem;
  }
  :global(.bootstrap) .g-lg-5,
  :global(.bootstrap) .gy-lg-5 {
    --bs-gutter-y: 4.5rem;
  }
}
@media (min-width: 1367px) {
  :global(.bootstrap) .col-xl {
    flex: 1 0 0%;
  }
  :global(.bootstrap) .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  :global(.bootstrap) .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  :global(.bootstrap) .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  :global(.bootstrap) .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  :global(.bootstrap) .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  :global(.bootstrap) .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  :global(.bootstrap) .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  :global(.bootstrap) .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  :global(.bootstrap) .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  :global(.bootstrap) .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  :global(.bootstrap) .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  :global(.bootstrap) .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  :global(.bootstrap) .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  :global(.bootstrap) .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  :global(.bootstrap) .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  :global(.bootstrap) .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  :global(.bootstrap) .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  :global(.bootstrap) .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  :global(.bootstrap) .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  :global(.bootstrap) .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  :global(.bootstrap) .offset-xl-0 {
    margin-left: 0;
  }
  :global(.bootstrap) .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  :global(.bootstrap) .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  :global(.bootstrap) .offset-xl-3 {
    margin-left: 25%;
  }
  :global(.bootstrap) .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  :global(.bootstrap) .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  :global(.bootstrap) .offset-xl-6 {
    margin-left: 50%;
  }
  :global(.bootstrap) .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  :global(.bootstrap) .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  :global(.bootstrap) .offset-xl-9 {
    margin-left: 75%;
  }
  :global(.bootstrap) .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  :global(.bootstrap) .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  :global(.bootstrap) .g-xl-0,
  :global(.bootstrap) .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  :global(.bootstrap) .g-xl-0,
  :global(.bootstrap) .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  :global(.bootstrap) .g-xl-1,
  :global(.bootstrap) .gx-xl-1 {
    --bs-gutter-x: 0.375rem;
  }
  :global(.bootstrap) .g-xl-1,
  :global(.bootstrap) .gy-xl-1 {
    --bs-gutter-y: 0.375rem;
  }
  :global(.bootstrap) .g-xl-2,
  :global(.bootstrap) .gx-xl-2 {
    --bs-gutter-x: 0.75rem;
  }
  :global(.bootstrap) .g-xl-2,
  :global(.bootstrap) .gy-xl-2 {
    --bs-gutter-y: 0.75rem;
  }
  :global(.bootstrap) .g-xl-3,
  :global(.bootstrap) .gx-xl-3 {
    --bs-gutter-x: 1.5rem;
  }
  :global(.bootstrap) .g-xl-3,
  :global(.bootstrap) .gy-xl-3 {
    --bs-gutter-y: 1.5rem;
  }
  :global(.bootstrap) .g-xl-4,
  :global(.bootstrap) .gx-xl-4 {
    --bs-gutter-x: 2.25rem;
  }
  :global(.bootstrap) .g-xl-4,
  :global(.bootstrap) .gy-xl-4 {
    --bs-gutter-y: 2.25rem;
  }
  :global(.bootstrap) .g-xl-5,
  :global(.bootstrap) .gx-xl-5 {
    --bs-gutter-x: 4.5rem;
  }
  :global(.bootstrap) .g-xl-5,
  :global(.bootstrap) .gy-xl-5 {
    --bs-gutter-y: 4.5rem;
  }
}
@media (min-width: 1400px) {
  :global(.bootstrap) .col-xxl {
    flex: 1 0 0%;
  }
  :global(.bootstrap) .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  :global(.bootstrap) .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  :global(.bootstrap) .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  :global(.bootstrap) .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  :global(.bootstrap) .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  :global(.bootstrap) .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  :global(.bootstrap) .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  :global(.bootstrap) .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  :global(.bootstrap) .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  :global(.bootstrap) .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  :global(.bootstrap) .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  :global(.bootstrap) .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  :global(.bootstrap) .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  :global(.bootstrap) .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  :global(.bootstrap) .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  :global(.bootstrap) .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  :global(.bootstrap) .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  :global(.bootstrap) .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  :global(.bootstrap) .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  :global(.bootstrap) .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  :global(.bootstrap) .offset-xxl-0 {
    margin-left: 0;
  }
  :global(.bootstrap) .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  :global(.bootstrap) .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  :global(.bootstrap) .offset-xxl-3 {
    margin-left: 25%;
  }
  :global(.bootstrap) .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  :global(.bootstrap) .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  :global(.bootstrap) .offset-xxl-6 {
    margin-left: 50%;
  }
  :global(.bootstrap) .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  :global(.bootstrap) .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  :global(.bootstrap) .offset-xxl-9 {
    margin-left: 75%;
  }
  :global(.bootstrap) .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  :global(.bootstrap) .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  :global(.bootstrap) .g-xxl-0,
  :global(.bootstrap) .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  :global(.bootstrap) .g-xxl-0,
  :global(.bootstrap) .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  :global(.bootstrap) .g-xxl-1,
  :global(.bootstrap) .gx-xxl-1 {
    --bs-gutter-x: 0.375rem;
  }
  :global(.bootstrap) .g-xxl-1,
  :global(.bootstrap) .gy-xxl-1 {
    --bs-gutter-y: 0.375rem;
  }
  :global(.bootstrap) .g-xxl-2,
  :global(.bootstrap) .gx-xxl-2 {
    --bs-gutter-x: 0.75rem;
  }
  :global(.bootstrap) .g-xxl-2,
  :global(.bootstrap) .gy-xxl-2 {
    --bs-gutter-y: 0.75rem;
  }
  :global(.bootstrap) .g-xxl-3,
  :global(.bootstrap) .gx-xxl-3 {
    --bs-gutter-x: 1.5rem;
  }
  :global(.bootstrap) .g-xxl-3,
  :global(.bootstrap) .gy-xxl-3 {
    --bs-gutter-y: 1.5rem;
  }
  :global(.bootstrap) .g-xxl-4,
  :global(.bootstrap) .gx-xxl-4 {
    --bs-gutter-x: 2.25rem;
  }
  :global(.bootstrap) .g-xxl-4,
  :global(.bootstrap) .gy-xxl-4 {
    --bs-gutter-y: 2.25rem;
  }
  :global(.bootstrap) .g-xxl-5,
  :global(.bootstrap) .gx-xxl-5 {
    --bs-gutter-x: 4.5rem;
  }
  :global(.bootstrap) .g-xxl-5,
  :global(.bootstrap) .gy-xxl-5 {
    --bs-gutter-y: 4.5rem;
  }
}
:global(.bootstrap) .table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: #848484;
  --bs-table-bg: transparent;
  --bs-table-border-color: #ededed;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #848484;
  --bs-table-striped-bg: #FAFAFA;
  --bs-table-active-color: #848484;
  --bs-table-active-bg: #FAFAFA;
  --bs-table-hover-color: #848484;
  --bs-table-hover-bg: #FAFAFA;
  width: 100%;
  margin-bottom: 1.5rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
:global(.bootstrap) .table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
:global(.bootstrap) .table > tbody {
  vertical-align: inherit;
}
:global(.bootstrap) .table > thead {
  vertical-align: bottom;
}
:global(.bootstrap) .table-group-divider {
  border-top: calc(1px * 2) solid currentcolor;
}
:global(.bootstrap) .caption-top {
  caption-side: top;
}
:global(.bootstrap) .table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}
:global(.bootstrap) .table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
:global(.bootstrap) .table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}
:global(.bootstrap) .table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
:global(.bootstrap) .table-borderless > :not(:first-child) {
  border-top-width: 0;
}
:global(.bootstrap) .table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}
:global(.bootstrap) .table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}
:global(.bootstrap) .table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}
:global(.bootstrap) .table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}
:global(.bootstrap) .table-primary {
  --bs-table-color: #666560;
  --bs-table-bg: #fff7cc;
  --bs-table-border-color: #e0dab6;
  --bs-table-striped-bg: #f7f0c7;
  --bs-table-striped-color: #666560;
  --bs-table-active-bg: #f0e8c1;
  --bs-table-active-color: #666560;
  --bs-table-hover-bg: #f4ecc4;
  --bs-table-hover-color: #666560;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
:global(.bootstrap) .table-secondary {
  --bs-table-color: #08090D;
  --bs-table-bg: #cececf;
  --bs-table-border-color: #a6a7a8;
  --bs-table-striped-bg: #c4c4c5;
  --bs-table-striped-color: #08090D;
  --bs-table-active-bg: #bababc;
  --bs-table-active-color: #08090D;
  --bs-table-hover-bg: #bfbfc0;
  --bs-table-hover-color: #08090D;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
:global(.bootstrap) .table-success {
  --bs-table-color: #666560;
  --bs-table-bg: #cdf4df;
  --bs-table-border-color: #b8d7c6;
  --bs-table-striped-bg: #c8edd9;
  --bs-table-striped-color: #666560;
  --bs-table-active-bg: #c3e6d2;
  --bs-table-active-color: #08090D;
  --bs-table-hover-bg: #c5e9d5;
  --bs-table-hover-color: #08090D;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
:global(.bootstrap) .table-info {
  --bs-table-color: #08090D;
  --bs-table-bg: #e4deed;
  --bs-table-border-color: #b8b3c0;
  --bs-table-striped-bg: #d9d3e2;
  --bs-table-striped-color: #08090D;
  --bs-table-active-bg: #cec9d7;
  --bs-table-active-color: #08090D;
  --bs-table-hover-bg: #d4cedc;
  --bs-table-hover-color: #08090D;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
:global(.bootstrap) .table-warning {
  --bs-table-color: #666560;
  --bs-table-bg: #ffeadb;
  --bs-table-border-color: #e0cfc2;
  --bs-table-striped-bg: #f7e3d5;
  --bs-table-striped-color: #666560;
  --bs-table-active-bg: #f0ddcf;
  --bs-table-active-color: #08090D;
  --bs-table-hover-bg: #f4e0d2;
  --bs-table-hover-color: #666560;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
:global(.bootstrap) .table-danger {
  --bs-table-color: #08090D;
  --bs-table-bg: #f2cdcd;
  --bs-table-border-color: #c3a6a7;
  --bs-table-striped-bg: #e6c3c3;
  --bs-table-striped-color: #08090D;
  --bs-table-active-bg: #dbb9ba;
  --bs-table-active-color: #08090D;
  --bs-table-hover-bg: #e0bebf;
  --bs-table-hover-color: #08090D;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
:global(.bootstrap) .table-light {
  --bs-table-color: #666560;
  --bs-table-bg: #F5F5F5;
  --bs-table-border-color: #d8d8d7;
  --bs-table-striped-bg: #eeeeee;
  --bs-table-striped-color: #666560;
  --bs-table-active-bg: #e7e7e6;
  --bs-table-active-color: #666560;
  --bs-table-hover-bg: #eaeaea;
  --bs-table-hover-color: #666560;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
:global(.bootstrap) .table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #4D4D4D;
  --bs-table-border-color: #717171;
  --bs-table-striped-bg: #565656;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #5f5f5f;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #5a5a5a;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
:global(.bootstrap) .table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 575.98px) {
  :global(.bootstrap) .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 812.98px) {
  :global(.bootstrap) .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  :global(.bootstrap) .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1366.98px) {
  :global(.bootstrap) .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  :global(.bootstrap) .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
:global(.bootstrap) .form-label {
  margin-bottom: 0.5rem;
}
:global(.bootstrap) .col-form-label {
  padding-top: calc(0.45rem + 1px);
  padding-bottom: calc(0.45rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
:global(.bootstrap) .col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.09375rem;
}
:global(.bootstrap) .col-form-label-sm {
  padding-top: calc(0.28rem + 1px);
  padding-bottom: calc(0.28rem + 1px);
  font-size: 0.7875rem;
}
:global(.bootstrap) .form-text {
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: var(--bs-secondary-color);
}
:global(.bootstrap) .form-control {
  display: block;
  width: 100%;
  padding: 0.45rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #848484;
  appearance: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #E5E6E1;
  border-radius: 0.2rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .form-control {
    transition: none;
  }
}
:global(.bootstrap) .form-control[type=file] {
  overflow: hidden;
}
:global(.bootstrap) .form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
:global(.bootstrap) .form-control:focus {
  color: #848484;
  background-color: #fff;
  border-color: #cdcfc5;
  outline: 0;
  box-shadow: none;
}
:global(.bootstrap) .form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
:global(.bootstrap) .form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
:global(.bootstrap) .form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}
:global(.bootstrap) .form-control:disabled {
  background-color: #fff;
  opacity: 1;
}
:global(.bootstrap) .form-control::file-selector-button {
  padding: 0.45rem 0.9rem;
  margin: -0.45rem -0.9rem;
  margin-inline-end: 0.9rem;
  color: #848484;
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .form-control::file-selector-button {
    transition: none;
  }
}
:global(.bootstrap) .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}
:global(.bootstrap) .form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.45rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #848484;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
:global(.bootstrap) .form-control-plaintext:focus {
  outline: 0;
}
:global(.bootstrap) .form-control-plaintext.form-control-sm, :global(.bootstrap) .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}
:global(.bootstrap) .form-control-sm {
  min-height: calc(1.5em + 0.56rem + 2px);
  padding: 0.28rem 0.8rem;
  font-size: 0.7875rem;
  border-radius: 0.2rem;
}
:global(.bootstrap) .form-control-sm::file-selector-button {
  padding: 0.28rem 0.8rem;
  margin: -0.28rem -0.8rem;
  margin-inline-end: 0.8rem;
}
:global(.bootstrap) .form-control-lg {
  min-height: calc(2em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  border-radius: 0.3rem;
}
:global(.bootstrap) .form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}
:global(.bootstrap) textarea.form-control {
  min-height: calc(1.5em + 0.9rem + 2px);
}
:global(.bootstrap) textarea.form-control-sm {
  min-height: calc(1.5em + 0.56rem + 2px);
}
:global(.bootstrap) textarea.form-control-lg {
  min-height: calc(2em + 1rem + 2px);
}
:global(.bootstrap) .form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.9rem + 2px);
  padding: 0.45rem;
}
:global(.bootstrap) .form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
:global(.bootstrap) .form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.2rem;
}
:global(.bootstrap) .form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0.2rem;
}
:global(.bootstrap) .form-control-color.form-control-sm {
  height: calc(1.5em + 0.56rem + 2px);
}
:global(.bootstrap) .form-control-color.form-control-lg {
  height: calc(2em + 1rem + 2px);
}
:global(.bootstrap) .form-select {
  --bs-form-select-bg-img: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23666560' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
  display: block;
  width: 100%;
  padding: 0.45rem 2.7rem 0.45rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #848484;
  appearance: none;
  background-color: #fff;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.9rem center;
  background-size: 16px 12px;
  border: 1px solid #E5E6E1;
  border-radius: 0.2rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .form-select {
    transition: none;
  }
}
:global(.bootstrap) .form-select:focus {
  border-color: #cdcfc5;
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(255, 215, 0, 0.25);
}
:global(.bootstrap) .form-select[multiple], :global(.bootstrap) .form-select[size]:not([size="1"]) {
  padding-right: 0.9rem;
  background-image: none;
}
:global(.bootstrap) .form-select:disabled {
  background-color: #fff;
}
:global(.bootstrap) .form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #848484;
}
:global(.bootstrap) .form-select-sm {
  padding-top: 0.28rem;
  padding-bottom: 0.28rem;
  padding-left: 0.8rem;
  font-size: 0.7875rem;
  border-radius: 0.2rem;
}
:global(.bootstrap) .form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.09375rem;
  border-radius: 0.3rem;
}
:global(.bootstrap) [data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ededed' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
}
:global(.bootstrap) .form-check {
  display: block;
  min-height: 1.3125rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
:global(.bootstrap) .form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}
:global(.bootstrap) .form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
:global(.bootstrap) .form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}
:global(.bootstrap) .form-check-input {
  --bs-form-check-bg: #fff;
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #E5E6E1;
  print-color-adjust: exact;
}
:global(.bootstrap) .form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
:global(.bootstrap) .form-check-input[type=radio] {
  border-radius: 50%;
}
:global(.bootstrap) .form-check-input:active {
  filter: brightness(90%);
}
:global(.bootstrap) .form-check-input:focus {
  border-color: #cdcfc5;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(255, 215, 0, 0.25);
}
:global(.bootstrap) .form-check-input:checked {
  background-color: #FFD700;
  border-color: #FFD700;
}
:global(.bootstrap) .form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
}
:global(.bootstrap) .form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e");
}
:global(.bootstrap) .form-check-input[type=checkbox]:indeterminate {
  background-color: #FFD700;
  border-color: #FFD700;
  --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e");
}
:global(.bootstrap) .form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
:global(.bootstrap) .form-check-input[disabled] ~ .form-check-label, :global(.bootstrap) .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}
:global(.bootstrap) .form-switch {
  padding-left: 2.5em;
}
:global(.bootstrap) .form-switch .form-check-input {
  --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(8, 9, 13, 0.25)'/%3e%3c/svg%3e");
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .form-switch .form-check-input {
    transition: none;
  }
}
:global(.bootstrap) .form-switch .form-check-input:focus {
  --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23cdcfc5'/%3e%3c/svg%3e");
}
:global(.bootstrap) .form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
}
:global(.bootstrap) .form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
:global(.bootstrap) .form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}
:global(.bootstrap) .form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}
:global(.bootstrap) .btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
:global(.bootstrap) .btn-check[disabled] + .btn, :global(.bootstrap) .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}
:global(.bootstrap) [data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255, 255, 255, 0.25)'/%3e%3c/svg%3e");
}
:global(.bootstrap) .form-range {
  width: 100%;
  height: 1.3rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
:global(.bootstrap) .form-range:focus {
  outline: 0;
}
:global(.bootstrap) .form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f5f6f8, none;
}
:global(.bootstrap) .form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f5f6f8, none;
}
:global(.bootstrap) .form-range::-moz-focus-outer {
  border: 0;
}
:global(.bootstrap) .form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #FFD700;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .form-range::-webkit-slider-thumb {
    transition: none;
  }
}
:global(.bootstrap) .form-range::-webkit-slider-thumb:active {
  background-color: #fff3b3;
}
:global(.bootstrap) .form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
:global(.bootstrap) .form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #FFD700;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .form-range::-moz-range-thumb {
    transition: none;
  }
}
:global(.bootstrap) .form-range::-moz-range-thumb:active {
  background-color: #fff3b3;
}
:global(.bootstrap) .form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
:global(.bootstrap) .form-range:disabled {
  pointer-events: none;
}
:global(.bootstrap) .form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
:global(.bootstrap) .form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}
:global(.bootstrap) .form-floating {
  position: relative;
}
:global(.bootstrap) .form-floating > .form-control,
:global(.bootstrap) .form-floating > .form-control-plaintext,
:global(.bootstrap) .form-floating > .form-select {
  height: calc(3.5rem + 2px);
  min-height: calc(3.5rem + 2px);
  line-height: 1.25;
}
:global(.bootstrap) .form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.9rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .form-floating > label {
    transition: none;
  }
}
:global(.bootstrap) .form-floating > .form-control,
:global(.bootstrap) .form-floating > .form-control-plaintext {
  padding: 1rem 0.9rem;
}
:global(.bootstrap) .form-floating > .form-control::placeholder,
:global(.bootstrap) .form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
:global(.bootstrap) .form-floating > .form-control:focus, :global(.bootstrap) .form-floating > .form-control:not(:placeholder-shown),
:global(.bootstrap) .form-floating > .form-control-plaintext:focus,
:global(.bootstrap) .form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
:global(.bootstrap) .form-floating > .form-control:-webkit-autofill,
:global(.bootstrap) .form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
:global(.bootstrap) .form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
:global(.bootstrap) .form-floating > .form-control:focus ~ label,
:global(.bootstrap) .form-floating > .form-control:not(:placeholder-shown) ~ label,
:global(.bootstrap) .form-floating > .form-control-plaintext ~ label,
:global(.bootstrap) .form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
:global(.bootstrap) .form-floating > .form-control:focus ~ label::after,
:global(.bootstrap) .form-floating > .form-control:not(:placeholder-shown) ~ label::after,
:global(.bootstrap) .form-floating > .form-control-plaintext ~ label::after,
:global(.bootstrap) .form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.45rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: #fff;
  border-radius: 0.2rem;
}
:global(.bootstrap) .form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
:global(.bootstrap) .form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}
:global(.bootstrap) .form-floating > :disabled ~ label,
:global(.bootstrap) .form-floating > .form-control:disabled ~ label {
  color: #A9A9A9;
}
:global(.bootstrap) .form-floating > :disabled ~ label::after,
:global(.bootstrap) .form-floating > .form-control:disabled ~ label::after {
  background-color: #fff;
}
:global(.bootstrap) .input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
:global(.bootstrap) .input-group > .form-control,
:global(.bootstrap) .input-group > .form-select,
:global(.bootstrap) .input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
:global(.bootstrap) .input-group > .form-control:focus,
:global(.bootstrap) .input-group > .form-select:focus,
:global(.bootstrap) .input-group > .form-floating:focus-within {
  z-index: 5;
}
:global(.bootstrap) .input-group .btn {
  position: relative;
  z-index: 2;
}
:global(.bootstrap) .input-group .btn:focus {
  z-index: 5;
}
:global(.bootstrap) .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.45rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #848484;
  text-align: center;
  white-space: nowrap;
  background-color: #F5F5F5;
  border: 1px solid #E5E6E1;
  border-radius: 0.2rem;
}
:global(.bootstrap) .input-group-lg > .form-control,
:global(.bootstrap) .input-group-lg > .form-select,
:global(.bootstrap) .input-group-lg > .input-group-text,
:global(.bootstrap) .input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  border-radius: 0.3rem;
}
:global(.bootstrap) .input-group-sm > .form-control,
:global(.bootstrap) .input-group-sm > .form-select,
:global(.bootstrap) .input-group-sm > .input-group-text,
:global(.bootstrap) .input-group-sm > .btn {
  padding: 0.28rem 0.8rem;
  font-size: 0.7875rem;
  border-radius: 0.2rem;
}
:global(.bootstrap) .input-group-lg > .form-select,
:global(.bootstrap) .input-group-sm > .form-select {
  padding-right: 3.6rem;
}
:global(.bootstrap) .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
:global(.bootstrap) .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
:global(.bootstrap) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
:global(.bootstrap) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
:global(.bootstrap) .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
:global(.bootstrap) .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
:global(.bootstrap) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
:global(.bootstrap) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
:global(.bootstrap) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(1px * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
:global(.bootstrap) .input-group > .form-floating:not(:first-child) > .form-control,
:global(.bootstrap) .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
:global(.bootstrap) .valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #07C960;
}
:global(.bootstrap) .valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.8rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #08090D;
  background-color: rgba(7, 201, 96, 0.9);
  border-radius: 0.2rem;
}
.was-validated :global(.bootstrap):valid ~ .valid-feedback,
.was-validated :global(.bootstrap):valid ~ .valid-tooltip, :global(.bootstrap).is-valid ~ .valid-feedback,
:global(.bootstrap).is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated :global(.bootstrap) .form-control:valid, :global(.bootstrap) .form-control.is-valid {
  border-color: #07C960;
  padding-right: calc(1.5em + 0.9rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2307C960' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.225rem) center;
  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated :global(.bootstrap) .form-control:valid:focus, :global(.bootstrap) .form-control.is-valid:focus {
  border-color: #07C960;
  box-shadow: 0 0 0 0.15rem rgba(7, 201, 96, 0.25);
}
.was-validated :global(.bootstrap) textarea.form-control:valid, :global(.bootstrap) textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.9rem);
  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);
}
.was-validated :global(.bootstrap) .form-select:valid, :global(.bootstrap) .form-select.is-valid {
  border-color: #07C960;
}
.was-validated :global(.bootstrap) .form-select:valid:not([multiple]):not([size]), .was-validated :global(.bootstrap) .form-select:valid:not([multiple])[size="1"], :global(.bootstrap) .form-select.is-valid:not([multiple]):not([size]), :global(.bootstrap) .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2307C960' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  padding-right: 4.95rem;
  background-position: right 0.9rem center, center right 2.7rem;
  background-size: 16px 12px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated :global(.bootstrap) .form-select:valid:focus, :global(.bootstrap) .form-select.is-valid:focus {
  border-color: #07C960;
  box-shadow: 0 0 0 0.15rem rgba(7, 201, 96, 0.25);
}
.was-validated :global(.bootstrap) .form-control-color:valid, :global(.bootstrap) .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.9rem));
}
.was-validated :global(.bootstrap) .form-check-input:valid, :global(.bootstrap) .form-check-input.is-valid {
  border-color: #07C960;
}
.was-validated :global(.bootstrap) .form-check-input:valid:checked, :global(.bootstrap) .form-check-input.is-valid:checked {
  background-color: #07C960;
}
.was-validated :global(.bootstrap) .form-check-input:valid:focus, :global(.bootstrap) .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.15rem rgba(7, 201, 96, 0.25);
}
.was-validated :global(.bootstrap) .form-check-input:valid ~ .form-check-label, :global(.bootstrap) .form-check-input.is-valid ~ .form-check-label {
  color: #07C960;
}
:global(.bootstrap) .form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}
.was-validated :global(.bootstrap) .input-group > .form-control:not(:focus):valid, :global(.bootstrap) .input-group > .form-control:not(:focus).is-valid,
.was-validated :global(.bootstrap) .input-group > .form-select:not(:focus):valid,
:global(.bootstrap) .input-group > .form-select:not(:focus).is-valid,
.was-validated :global(.bootstrap) .input-group > .form-floating:not(:focus-within):valid,
:global(.bootstrap) .input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}
:global(.bootstrap) .invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #bc0505;
}
:global(.bootstrap) .invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.8rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(188, 5, 5, 0.9);
  border-radius: 0.2rem;
}
.was-validated :global(.bootstrap):invalid ~ .invalid-feedback,
.was-validated :global(.bootstrap):invalid ~ .invalid-tooltip, :global(.bootstrap).is-invalid ~ .invalid-feedback,
:global(.bootstrap).is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated :global(.bootstrap) .form-control:invalid, :global(.bootstrap) .form-control.is-invalid {
  border-color: #bc0505;
  padding-right: calc(1.5em + 0.9rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23bc0505' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23bc0505' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.225rem) center;
  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated :global(.bootstrap) .form-control:invalid:focus, :global(.bootstrap) .form-control.is-invalid:focus {
  border-color: #bc0505;
  box-shadow: 0 0 0 0.15rem rgba(188, 5, 5, 0.25);
}
.was-validated :global(.bootstrap) textarea.form-control:invalid, :global(.bootstrap) textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.9rem);
  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);
}
.was-validated :global(.bootstrap) .form-select:invalid, :global(.bootstrap) .form-select.is-invalid {
  border-color: #bc0505;
}
.was-validated :global(.bootstrap) .form-select:invalid:not([multiple]):not([size]), .was-validated :global(.bootstrap) .form-select:invalid:not([multiple])[size="1"], :global(.bootstrap) .form-select.is-invalid:not([multiple]):not([size]), :global(.bootstrap) .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23bc0505' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23bc0505' stroke='none'/%3e%3c/svg%3e");
  padding-right: 4.95rem;
  background-position: right 0.9rem center, center right 2.7rem;
  background-size: 16px 12px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated :global(.bootstrap) .form-select:invalid:focus, :global(.bootstrap) .form-select.is-invalid:focus {
  border-color: #bc0505;
  box-shadow: 0 0 0 0.15rem rgba(188, 5, 5, 0.25);
}
.was-validated :global(.bootstrap) .form-control-color:invalid, :global(.bootstrap) .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.9rem));
}
.was-validated :global(.bootstrap) .form-check-input:invalid, :global(.bootstrap) .form-check-input.is-invalid {
  border-color: #bc0505;
}
.was-validated :global(.bootstrap) .form-check-input:invalid:checked, :global(.bootstrap) .form-check-input.is-invalid:checked {
  background-color: #bc0505;
}
.was-validated :global(.bootstrap) .form-check-input:invalid:focus, :global(.bootstrap) .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.15rem rgba(188, 5, 5, 0.25);
}
.was-validated :global(.bootstrap) .form-check-input:invalid ~ .form-check-label, :global(.bootstrap) .form-check-input.is-invalid ~ .form-check-label {
  color: #bc0505;
}
:global(.bootstrap) .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}
.was-validated :global(.bootstrap) .input-group > .form-control:not(:focus):invalid, :global(.bootstrap) .input-group > .form-control:not(:focus).is-invalid,
.was-validated :global(.bootstrap) .input-group > .form-select:not(:focus):invalid,
:global(.bootstrap) .input-group > .form-select:not(:focus).is-invalid,
.was-validated :global(.bootstrap) .input-group > .form-floating:not(:focus-within):invalid,
:global(.bootstrap) .input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}
:global(.bootstrap) .btn {
  --bs-btn-padding-x: 0.9rem;
  --bs-btn-padding-y: 0.45rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.15rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0;
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .btn {
    transition: none;
  }
}
:global(.bootstrap) .btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + :global(.bootstrap) .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
:global(.bootstrap) .btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + :global(.bootstrap) .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + :global(.bootstrap) .btn, :not(.btn-check) + :global(.bootstrap) .btn:active, :global(.bootstrap) .btn:first-child:active, :global(.bootstrap) .btn.active, :global(.bootstrap) .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + :global(.bootstrap) .btn:focus-visible, :not(.btn-check) + :global(.bootstrap) .btn:active:focus-visible, :global(.bootstrap) .btn:first-child:active:focus-visible, :global(.bootstrap) .btn.active:focus-visible, :global(.bootstrap) .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
:global(.bootstrap) .btn:disabled, :global(.bootstrap) .btn.disabled, fieldset:disabled :global(.bootstrap) .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}
:global(.bootstrap) .btn-primary {
  --bs-btn-color: #08090D;
  --bs-btn-bg: #FFD700;
  --bs-btn-border-color: #FFD700;
  --bs-btn-hover-color: #08090D;
  --bs-btn-hover-bg: #ffdd26;
  --bs-btn-hover-border-color: #ffdb1a;
  --bs-btn-focus-shadow-rgb: 218, 184, 2;
  --bs-btn-active-color: #08090D;
  --bs-btn-active-bg: #ffdf33;
  --bs-btn-active-border-color: #ffdb1a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #08090D;
  --bs-btn-disabled-bg: #FFD700;
  --bs-btn-disabled-border-color: #FFD700;
}
:global(.bootstrap) .btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #08090D;
  --bs-btn-border-color: #08090D;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #07080b;
  --bs-btn-hover-border-color: #06070a;
  --bs-btn-focus-shadow-rgb: 45, 46, 49;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #06070a;
  --bs-btn-active-border-color: #06070a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #08090D;
  --bs-btn-disabled-border-color: #08090D;
}
:global(.bootstrap) .btn-success {
  --bs-btn-color: #08090D;
  --bs-btn-bg: #07C960;
  --bs-btn-border-color: #07C960;
  --bs-btn-hover-color: #08090D;
  --bs-btn-hover-bg: #2cd178;
  --bs-btn-hover-border-color: #20ce70;
  --bs-btn-focus-shadow-rgb: 7, 172, 84;
  --bs-btn-active-color: #08090D;
  --bs-btn-active-bg: #39d480;
  --bs-btn-active-border-color: #20ce70;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #08090D;
  --bs-btn-disabled-bg: #07C960;
  --bs-btn-disabled-border-color: #07C960;
}
:global(.bootstrap) .btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #785CA7;
  --bs-btn-border-color: #785CA7;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #664e8e;
  --bs-btn-hover-border-color: #604a86;
  --bs-btn-focus-shadow-rgb: 140, 116, 180;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #604a86;
  --bs-btn-active-border-color: #5a457d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #785CA7;
  --bs-btn-disabled-border-color: #785CA7;
}
:global(.bootstrap) .btn-warning {
  --bs-btn-color: #08090D;
  --bs-btn-bg: #FD964C;
  --bs-btn-border-color: #FD964C;
  --bs-btn-hover-color: #08090D;
  --bs-btn-hover-bg: #fda667;
  --bs-btn-hover-border-color: #fda15e;
  --bs-btn-focus-shadow-rgb: 216, 129, 67;
  --bs-btn-active-color: #08090D;
  --bs-btn-active-bg: #fdab70;
  --bs-btn-active-border-color: #fda15e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #08090D;
  --bs-btn-disabled-bg: #FD964C;
  --bs-btn-disabled-border-color: #FD964C;
}
:global(.bootstrap) .btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #bc0505;
  --bs-btn-border-color: #bc0505;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #a00404;
  --bs-btn-hover-border-color: #960404;
  --bs-btn-focus-shadow-rgb: 198, 43, 43;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #960404;
  --bs-btn-active-border-color: #8d0404;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #bc0505;
  --bs-btn-disabled-border-color: #bc0505;
}
:global(.bootstrap) .btn-light {
  --bs-btn-color: #666560;
  --bs-btn-bg: #F5F5F5;
  --bs-btn-border-color: #F5F5F5;
  --bs-btn-hover-color: #08090D;
  --bs-btn-hover-bg: #d0d0d0;
  --bs-btn-hover-border-color: #c4c4c4;
  --bs-btn-focus-shadow-rgb: 224, 223, 223;
  --bs-btn-active-color: #08090D;
  --bs-btn-active-bg: #c4c4c4;
  --bs-btn-active-border-color: #b8b8b8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #666560;
  --bs-btn-disabled-bg: #F5F5F5;
  --bs-btn-disabled-border-color: #F5F5F5;
}
:global(.bootstrap) .btn-medium {
  --bs-btn-color: #08090D;
  --bs-btn-bg: #848484;
  --bs-btn-border-color: #848484;
  --bs-btn-hover-color: #08090D;
  --bs-btn-hover-bg: #969696;
  --bs-btn-hover-border-color: #909090;
  --bs-btn-focus-shadow-rgb: 113, 114, 114;
  --bs-btn-active-color: #08090D;
  --bs-btn-active-bg: #9d9d9d;
  --bs-btn-active-border-color: #909090;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #08090D;
  --bs-btn-disabled-bg: #848484;
  --bs-btn-disabled-border-color: #848484;
}
:global(.bootstrap) .btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #4D4D4D;
  --bs-btn-border-color: #4D4D4D;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #686868;
  --bs-btn-hover-border-color: #5f5f5f;
  --bs-btn-focus-shadow-rgb: 104, 104, 104;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #717171;
  --bs-btn-active-border-color: #5f5f5f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #4D4D4D;
  --bs-btn-disabled-border-color: #4D4D4D;
}
:global(.bootstrap) .btn-pro {
  --bs-btn-color: #08090D;
  --bs-btn-bg: #07C960;
  --bs-btn-border-color: #07C960;
  --bs-btn-hover-color: #08090D;
  --bs-btn-hover-bg: #2cd178;
  --bs-btn-hover-border-color: #20ce70;
  --bs-btn-focus-shadow-rgb: 7, 172, 84;
  --bs-btn-active-color: #08090D;
  --bs-btn-active-bg: #39d480;
  --bs-btn-active-border-color: #20ce70;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #08090D;
  --bs-btn-disabled-bg: #07C960;
  --bs-btn-disabled-border-color: #07C960;
}
:global(.bootstrap) .btn-con {
  --bs-btn-color: #fff;
  --bs-btn-bg: #bc0505;
  --bs-btn-border-color: #bc0505;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #a00404;
  --bs-btn-hover-border-color: #960404;
  --bs-btn-focus-shadow-rgb: 198, 43, 43;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #960404;
  --bs-btn-active-border-color: #8d0404;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #bc0505;
  --bs-btn-disabled-border-color: #bc0505;
}
:global(.bootstrap) .btn-outline-primary {
  --bs-btn-color: #FFD700;
  --bs-btn-border-color: #FFD700;
  --bs-btn-hover-color: #08090D;
  --bs-btn-hover-bg: #FFD700;
  --bs-btn-hover-border-color: #FFD700;
  --bs-btn-focus-shadow-rgb: 255, 215, 0;
  --bs-btn-active-color: #08090D;
  --bs-btn-active-bg: #FFD700;
  --bs-btn-active-border-color: #FFD700;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #FFD700;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FFD700;
  --bs-gradient: none;
}
:global(.bootstrap) .btn-outline-secondary {
  --bs-btn-color: #08090D;
  --bs-btn-border-color: #08090D;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #08090D;
  --bs-btn-hover-border-color: #08090D;
  --bs-btn-focus-shadow-rgb: 8, 9, 13;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #08090D;
  --bs-btn-active-border-color: #08090D;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #08090D;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #08090D;
  --bs-gradient: none;
}
:global(.bootstrap) .btn-outline-success {
  --bs-btn-color: #07C960;
  --bs-btn-border-color: #07C960;
  --bs-btn-hover-color: #08090D;
  --bs-btn-hover-bg: #07C960;
  --bs-btn-hover-border-color: #07C960;
  --bs-btn-focus-shadow-rgb: 7, 201, 96;
  --bs-btn-active-color: #08090D;
  --bs-btn-active-bg: #07C960;
  --bs-btn-active-border-color: #07C960;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #07C960;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #07C960;
  --bs-gradient: none;
}
:global(.bootstrap) .btn-outline-info {
  --bs-btn-color: #785CA7;
  --bs-btn-border-color: #785CA7;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #785CA7;
  --bs-btn-hover-border-color: #785CA7;
  --bs-btn-focus-shadow-rgb: 120, 92, 167;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #785CA7;
  --bs-btn-active-border-color: #785CA7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #785CA7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #785CA7;
  --bs-gradient: none;
}
:global(.bootstrap) .btn-outline-warning {
  --bs-btn-color: #FD964C;
  --bs-btn-border-color: #FD964C;
  --bs-btn-hover-color: #08090D;
  --bs-btn-hover-bg: #FD964C;
  --bs-btn-hover-border-color: #FD964C;
  --bs-btn-focus-shadow-rgb: 253, 150, 76;
  --bs-btn-active-color: #08090D;
  --bs-btn-active-bg: #FD964C;
  --bs-btn-active-border-color: #FD964C;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #FD964C;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FD964C;
  --bs-gradient: none;
}
:global(.bootstrap) .btn-outline-danger {
  --bs-btn-color: #bc0505;
  --bs-btn-border-color: #bc0505;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bc0505;
  --bs-btn-hover-border-color: #bc0505;
  --bs-btn-focus-shadow-rgb: 188, 5, 5;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #bc0505;
  --bs-btn-active-border-color: #bc0505;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #bc0505;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #bc0505;
  --bs-gradient: none;
}
:global(.bootstrap) .btn-outline-light {
  --bs-btn-color: #F5F5F5;
  --bs-btn-border-color: #F5F5F5;
  --bs-btn-hover-color: #666560;
  --bs-btn-hover-bg: #F5F5F5;
  --bs-btn-hover-border-color: #F5F5F5;
  --bs-btn-focus-shadow-rgb: 245, 245, 245;
  --bs-btn-active-color: #666560;
  --bs-btn-active-bg: #F5F5F5;
  --bs-btn-active-border-color: #F5F5F5;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #F5F5F5;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F5F5F5;
  --bs-gradient: none;
}
:global(.bootstrap) .btn-outline-medium {
  --bs-btn-color: #848484;
  --bs-btn-border-color: #848484;
  --bs-btn-hover-color: #08090D;
  --bs-btn-hover-bg: #848484;
  --bs-btn-hover-border-color: #848484;
  --bs-btn-focus-shadow-rgb: 132, 132, 132;
  --bs-btn-active-color: #08090D;
  --bs-btn-active-bg: #848484;
  --bs-btn-active-border-color: #848484;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #848484;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #848484;
  --bs-gradient: none;
}
:global(.bootstrap) .btn-outline-dark {
  --bs-btn-color: #4D4D4D;
  --bs-btn-border-color: #4D4D4D;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #4D4D4D;
  --bs-btn-hover-border-color: #4D4D4D;
  --bs-btn-focus-shadow-rgb: 77, 77, 77;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4D4D4D;
  --bs-btn-active-border-color: #4D4D4D;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #4D4D4D;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #4D4D4D;
  --bs-gradient: none;
}
:global(.bootstrap) .btn-outline-pro {
  --bs-btn-color: #07C960;
  --bs-btn-border-color: #07C960;
  --bs-btn-hover-color: #08090D;
  --bs-btn-hover-bg: #07C960;
  --bs-btn-hover-border-color: #07C960;
  --bs-btn-focus-shadow-rgb: 7, 201, 96;
  --bs-btn-active-color: #08090D;
  --bs-btn-active-bg: #07C960;
  --bs-btn-active-border-color: #07C960;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #07C960;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #07C960;
  --bs-gradient: none;
}
:global(.bootstrap) .btn-outline-con {
  --bs-btn-color: #bc0505;
  --bs-btn-border-color: #bc0505;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bc0505;
  --bs-btn-hover-border-color: #bc0505;
  --bs-btn-focus-shadow-rgb: 188, 5, 5;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #bc0505;
  --bs-btn-active-border-color: #bc0505;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(8, 9, 13, 0.125);
  --bs-btn-disabled-color: #bc0505;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #bc0505;
  --bs-gradient: none;
}
:global(.bootstrap) .btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: #2a8ecf;
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: #0a4d78;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: #0a4d78;
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #A9A9A9;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: #E5E6E1;
  text-decoration: none;
}
:global(.bootstrap) .btn-link:hover, :global(.bootstrap) .btn-link:focus-visible {
  text-decoration: none;
}
:global(.bootstrap) .btn-link:focus-visible {
  color: var(--bs-btn-color);
}
:global(.bootstrap) .btn-link:hover {
  color: var(--bs-btn-hover-color);
}
:global(.bootstrap) .btn-lg, :global(.bootstrap) .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.09375rem;
  --bs-btn-border-radius: 0.3rem;
}
:global(.bootstrap) .btn-sm, :global(.bootstrap) .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.28rem;
  --bs-btn-padding-x: 0.8rem;
  --bs-btn-font-size: 0.7875rem;
  --bs-btn-border-radius: 0.2rem;
}
:global(.bootstrap) .fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .fade {
    transition: none;
  }
}
:global(.bootstrap) .fade:not(.show) {
  opacity: 0;
}
:global(.bootstrap) .collapse:not(.show) {
  display: none;
}
:global(.bootstrap) .collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .collapsing {
    transition: none;
  }
}
:global(.bootstrap) .collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .collapsing.collapse-horizontal {
    transition: none;
  }
}
:global(.bootstrap) .dropup,
:global(.bootstrap) .dropend,
:global(.bootstrap) .dropdown,
:global(.bootstrap) .dropstart,
:global(.bootstrap) .dropup-center,
:global(.bootstrap) .dropdown-center {
  position: relative;
}
:global(.bootstrap) .dropdown-toggle {
  white-space: nowrap;
}
:global(.bootstrap) .dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.25rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.875rem;
  --bs-dropdown-color: #848484;
  --bs-dropdown-bg: #fff;
  --bs-dropdown-border-color: #ededed;
  --bs-dropdown-border-radius: 0.25rem;
  --bs-dropdown-border-width: 1px;
  --bs-dropdown-inner-border-radius: calc(0.25rem - 1px);
  --bs-dropdown-divider-bg: #F5F5F5;
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(8, 9, 13, 0.175);
  --bs-dropdown-link-color: #848484;
  --bs-dropdown-link-hover-color: #848484;
  --bs-dropdown-link-hover-bg: #FAFAFA;
  --bs-dropdown-link-active-color: #4D4D4D;
  --bs-dropdown-link-active-bg: #FAFAFA;
  --bs-dropdown-link-disabled-color: #A9A9A9;
  --bs-dropdown-item-padding-x: 1.2rem;
  --bs-dropdown-item-padding-y: 0.375rem;
  --bs-dropdown-header-color: inherit;
  --bs-dropdown-header-padding-x: 1.2rem;
  --bs-dropdown-header-padding-y: 0.25rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
:global(.bootstrap) .dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}
:global(.bootstrap) .dropdown-menu-start {
  --bs-position: start;
}
:global(.bootstrap) .dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}
:global(.bootstrap) .dropdown-menu-end {
  --bs-position: end;
}
:global(.bootstrap) .dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}
@media (min-width: 576px) {
  :global(.bootstrap) .dropdown-menu-sm-start {
    --bs-position: start;
  }
  :global(.bootstrap) .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  :global(.bootstrap) .dropdown-menu-sm-end {
    --bs-position: end;
  }
  :global(.bootstrap) .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .dropdown-menu-md-start {
    --bs-position: start;
  }
  :global(.bootstrap) .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  :global(.bootstrap) .dropdown-menu-md-end {
    --bs-position: end;
  }
  :global(.bootstrap) .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  :global(.bootstrap) .dropdown-menu-lg-start {
    --bs-position: start;
  }
  :global(.bootstrap) .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  :global(.bootstrap) .dropdown-menu-lg-end {
    --bs-position: end;
  }
  :global(.bootstrap) .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1367px) {
  :global(.bootstrap) .dropdown-menu-xl-start {
    --bs-position: start;
  }
  :global(.bootstrap) .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  :global(.bootstrap) .dropdown-menu-xl-end {
    --bs-position: end;
  }
  :global(.bootstrap) .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  :global(.bootstrap) .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  :global(.bootstrap) .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  :global(.bootstrap) .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  :global(.bootstrap) .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
:global(.bootstrap) .dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
:global(.bootstrap) .dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
:global(.bootstrap) .dropend .dropdown-toggle::after {
  vertical-align: 0;
}
:global(.bootstrap) .dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
:global(.bootstrap) .dropstart .dropdown-toggle::before {
  vertical-align: 0;
}
:global(.bootstrap) .dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}
:global(.bootstrap) .dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
:global(.bootstrap) .dropdown-item:hover, :global(.bootstrap) .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
:global(.bootstrap) .dropdown-item.active, :global(.bootstrap) .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
:global(.bootstrap) .dropdown-item.disabled, :global(.bootstrap) .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}
:global(.bootstrap) .dropdown-menu.show {
  display: block;
}
:global(.bootstrap) .dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.7875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}
:global(.bootstrap) .dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}
:global(.bootstrap) .dropdown-menu-dark {
  --bs-dropdown-color: #ededed;
  --bs-dropdown-bg: #666560;
  --bs-dropdown-border-color: #ededed;
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #ededed;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: #F5F5F5;
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #4D4D4D;
  --bs-dropdown-link-active-bg: #FAFAFA;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}
:global(.bootstrap) .btn-group,
:global(.bootstrap) .btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
:global(.bootstrap) .btn-group > .btn,
:global(.bootstrap) .btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
:global(.bootstrap) .btn-group > .btn-check:checked + .btn,
:global(.bootstrap) .btn-group > .btn-check:focus + .btn,
:global(.bootstrap) .btn-group > .btn:hover,
:global(.bootstrap) .btn-group > .btn:focus,
:global(.bootstrap) .btn-group > .btn:active,
:global(.bootstrap) .btn-group > .btn.active,
:global(.bootstrap) .btn-group-vertical > .btn-check:checked + .btn,
:global(.bootstrap) .btn-group-vertical > .btn-check:focus + .btn,
:global(.bootstrap) .btn-group-vertical > .btn:hover,
:global(.bootstrap) .btn-group-vertical > .btn:focus,
:global(.bootstrap) .btn-group-vertical > .btn:active,
:global(.bootstrap) .btn-group-vertical > .btn.active {
  z-index: 1;
}
:global(.bootstrap) .btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
:global(.bootstrap) .btn-toolbar .input-group {
  width: auto;
}
:global(.bootstrap) .btn-group {
  border-radius: 0.15rem;
}
:global(.bootstrap) .btn-group > :not(.btn-check:first-child) + .btn,
:global(.bootstrap) .btn-group > .btn-group:not(:first-child) {
  margin-left: calc(1px * -1);
}
:global(.bootstrap) .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
:global(.bootstrap) .btn-group > .btn.dropdown-toggle-split:first-child,
:global(.bootstrap) .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
:global(.bootstrap) .btn-group > .btn:nth-child(n+3),
:global(.bootstrap) .btn-group > :not(.btn-check) + .btn,
:global(.bootstrap) .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
:global(.bootstrap) .dropdown-toggle-split {
  padding-right: 0.675rem;
  padding-left: 0.675rem;
}
:global(.bootstrap) .dropdown-toggle-split::after, .dropup :global(.bootstrap) .dropdown-toggle-split::after, .dropend :global(.bootstrap) .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart :global(.bootstrap) .dropdown-toggle-split::before {
  margin-right: 0;
}
:global(.bootstrap) .btn-sm + .dropdown-toggle-split, :global(.bootstrap) .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.6rem;
  padding-left: 0.6rem;
}
:global(.bootstrap) .btn-lg + .dropdown-toggle-split, :global(.bootstrap) .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}
:global(.bootstrap) .btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
:global(.bootstrap) .btn-group-vertical > .btn,
:global(.bootstrap) .btn-group-vertical > .btn-group {
  width: 100%;
}
:global(.bootstrap) .btn-group-vertical > .btn:not(:first-child),
:global(.bootstrap) .btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(1px * -1);
}
:global(.bootstrap) .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
:global(.bootstrap) .btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
:global(.bootstrap) .btn-group-vertical > .btn ~ .btn,
:global(.bootstrap) .btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
:global(.bootstrap) .nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: #A9A9A9;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
:global(.bootstrap) .nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .nav-link {
    transition: none;
  }
}
:global(.bootstrap) .nav-link:hover, :global(.bootstrap) .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
:global(.bootstrap) .nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(255, 215, 0, 0.25);
}
:global(.bootstrap) .nav-link.disabled, :global(.bootstrap) .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}
:global(.bootstrap) .nav-tabs {
  --bs-nav-tabs-border-width: 1px;
  --bs-nav-tabs-border-color: #ededed;
  --bs-nav-tabs-border-radius: 0.25rem;
  --bs-nav-tabs-link-hover-border-color: #F5F5F5 #F5F5F5 #ededed;
  --bs-nav-tabs-link-active-color: #848484;
  --bs-nav-tabs-link-active-bg: #fff;
  --bs-nav-tabs-link-active-border-color: #ededed #ededed #fff;
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
:global(.bootstrap) .nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
:global(.bootstrap) .nav-tabs .nav-link:hover, :global(.bootstrap) .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
:global(.bootstrap) .nav-tabs .nav-link.active,
:global(.bootstrap) .nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
:global(.bootstrap) .nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
:global(.bootstrap) .nav-pills {
  --bs-nav-pills-border-radius: 0.25rem;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #FFD700;
}
:global(.bootstrap) .nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
:global(.bootstrap) .nav-pills .nav-link.active,
:global(.bootstrap) .nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}
:global(.bootstrap) .nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
:global(.bootstrap) .nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
:global(.bootstrap) .nav-underline .nav-link:hover, :global(.bootstrap) .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
:global(.bootstrap) .nav-underline .nav-link.active,
:global(.bootstrap) .nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}
:global(.bootstrap) .nav-fill > .nav-link,
:global(.bootstrap) .nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}
:global(.bootstrap) .nav-justified > .nav-link,
:global(.bootstrap) .nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}
:global(.bootstrap) .nav-fill .nav-item .nav-link,
:global(.bootstrap) .nav-justified .nav-item .nav-link {
  width: 100%;
}
:global(.bootstrap) .tab-content > .tab-pane {
  display: none;
}
:global(.bootstrap) .tab-content > .active {
  display: block;
}
:global(.bootstrap) .navbar {
  --bs-navbar-padding-x: 1.5rem;
  --bs-navbar-padding-y: 0.75rem;
  --bs-navbar-color: rgba(8, 9, 13, 0.5);
  --bs-navbar-hover-color: rgba(8, 9, 13, 0.7);
  --bs-navbar-disabled-color: rgba(8, 9, 13, 0.3);
  --bs-navbar-active-color: rgba(8, 9, 13, 0.9);
  --bs-navbar-brand-padding-y: 0.3359375rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.09375rem;
  --bs-navbar-brand-color: rgba(8, 9, 13, 0.9);
  --bs-navbar-brand-hover-color: rgba(8, 9, 13, 0.9);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.09375rem;
  --bs-navbar-toggler-icon-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(8, 9, 13, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  --bs-navbar-toggler-border-color: rgba(8, 9, 13, 0.1);
  --bs-navbar-toggler-border-radius: 0.15rem;
  --bs-navbar-toggler-focus-width: 0.15rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
:global(.bootstrap) .navbar > .container,
:global(.bootstrap) .navbar > .container-fluid,
:global(.bootstrap) .navbar > .container-sm,
:global(.bootstrap) .navbar > .container-md,
:global(.bootstrap) .navbar > .container-lg,
:global(.bootstrap) .navbar > .container-xl,
:global(.bootstrap) .navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
:global(.bootstrap) .navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}
:global(.bootstrap) .navbar-brand:hover, :global(.bootstrap) .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}
:global(.bootstrap) .navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
:global(.bootstrap) .navbar-nav .nav-link.active, :global(.bootstrap) .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
:global(.bootstrap) .navbar-nav .dropdown-menu {
  position: static;
}
:global(.bootstrap) .navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
:global(.bootstrap) .navbar-text a,
:global(.bootstrap) .navbar-text a:hover,
:global(.bootstrap) .navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}
:global(.bootstrap) .navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}
:global(.bootstrap) .navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .navbar-toggler {
    transition: none;
  }
}
:global(.bootstrap) .navbar-toggler:hover {
  text-decoration: none;
}
:global(.bootstrap) .navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}
:global(.bootstrap) .navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}
:global(.bootstrap) .navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}
@media (min-width: 576px) {
  :global(.bootstrap) .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  :global(.bootstrap) .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  :global(.bootstrap) .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  :global(.bootstrap) .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  :global(.bootstrap) .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  :global(.bootstrap) .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  :global(.bootstrap) .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  :global(.bootstrap) .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  :global(.bootstrap) .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  :global(.bootstrap) .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  :global(.bootstrap) .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  :global(.bootstrap) .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  :global(.bootstrap) .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  :global(.bootstrap) .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  :global(.bootstrap) .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  :global(.bootstrap) .navbar-expand-md .navbar-toggler {
    display: none;
  }
  :global(.bootstrap) .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  :global(.bootstrap) .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  :global(.bootstrap) .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  :global(.bootstrap) .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  :global(.bootstrap) .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  :global(.bootstrap) .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  :global(.bootstrap) .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  :global(.bootstrap) .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  :global(.bootstrap) .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  :global(.bootstrap) .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  :global(.bootstrap) .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  :global(.bootstrap) .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  :global(.bootstrap) .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1367px) {
  :global(.bootstrap) .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  :global(.bootstrap) .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  :global(.bootstrap) .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  :global(.bootstrap) .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  :global(.bootstrap) .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  :global(.bootstrap) .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  :global(.bootstrap) .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  :global(.bootstrap) .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  :global(.bootstrap) .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  :global(.bootstrap) .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  :global(.bootstrap) .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  :global(.bootstrap) .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  :global(.bootstrap) .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  :global(.bootstrap) .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  :global(.bootstrap) .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  :global(.bootstrap) .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  :global(.bootstrap) .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  :global(.bootstrap) .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  :global(.bootstrap) .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  :global(.bootstrap) .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
:global(.bootstrap) .navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
:global(.bootstrap) .navbar-expand .navbar-nav {
  flex-direction: row;
}
:global(.bootstrap) .navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
:global(.bootstrap) .navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
:global(.bootstrap) .navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
:global(.bootstrap) .navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
:global(.bootstrap) .navbar-expand .navbar-toggler {
  display: none;
}
:global(.bootstrap) .navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
:global(.bootstrap) .navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
:global(.bootstrap) .navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}
:global(.bootstrap) .navbar-dark,
:global(.bootstrap) .navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.5);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}
:global(.bootstrap) [data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}
:global(.bootstrap) .card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1.5rem;
  --bs-card-title-spacer-y: 0.75rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: 0;
  --bs-card-border-color: #E5E6E1;
  --bs-card-border-radius: 0.15rem;
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: 0.15rem;
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1.5rem;
  --bs-card-cap-bg: #fafafa;
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #fff;
  --bs-card-img-overlay-padding: 1.25rem;
  --bs-card-group-margin: 12px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
:global(.bootstrap) .card > hr {
  margin-right: 0;
  margin-left: 0;
}
:global(.bootstrap) .card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
:global(.bootstrap) .card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
:global(.bootstrap) .card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
:global(.bootstrap) .card > .card-header + .list-group,
:global(.bootstrap) .card > .list-group + .card-footer {
  border-top: 0;
}
:global(.bootstrap) .card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}
:global(.bootstrap) .card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}
:global(.bootstrap) .card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}
:global(.bootstrap) .card-text:last-child {
  margin-bottom: 0;
}
:global(.bootstrap) .card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}
:global(.bootstrap) .card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
:global(.bootstrap) .card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}
:global(.bootstrap) .card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
:global(.bootstrap) .card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}
:global(.bootstrap) .card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
:global(.bootstrap) .card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}
:global(.bootstrap) .card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}
:global(.bootstrap) .card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}
:global(.bootstrap) .card-img,
:global(.bootstrap) .card-img-top,
:global(.bootstrap) .card-img-bottom {
  width: 100%;
}
:global(.bootstrap) .card-img,
:global(.bootstrap) .card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
:global(.bootstrap) .card-img,
:global(.bootstrap) .card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
:global(.bootstrap) .card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  :global(.bootstrap) .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  :global(.bootstrap) .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  :global(.bootstrap) .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  :global(.bootstrap) .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  :global(.bootstrap) .card-group > .card:not(:last-child) .card-img-top,
  :global(.bootstrap) .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  :global(.bootstrap) .card-group > .card:not(:last-child) .card-img-bottom,
  :global(.bootstrap) .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  :global(.bootstrap) .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  :global(.bootstrap) .card-group > .card:not(:first-child) .card-img-top,
  :global(.bootstrap) .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  :global(.bootstrap) .card-group > .card:not(:first-child) .card-img-bottom,
  :global(.bootstrap) .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}
:global(.bootstrap) .accordion {
  --bs-accordion-color: #08090D;
  --bs-accordion-bg: #fff;
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: #08090D;
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23848484'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23665600'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  --bs-accordion-btn-focus-border-color: #cdcfc5;
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.15rem rgba(255, 215, 0, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: #08090D;
  --bs-accordion-active-bg: #FFD700;
}
:global(.bootstrap) .accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.875rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .accordion-button {
    transition: none;
  }
}
:global(.bootstrap) .accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
:global(.bootstrap) .accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
:global(.bootstrap) .accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .accordion-button::after {
    transition: none;
  }
}
:global(.bootstrap) .accordion-button:hover {
  z-index: 2;
}
:global(.bootstrap) .accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}
:global(.bootstrap) .accordion-header {
  margin-bottom: 0;
}
:global(.bootstrap) .accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
:global(.bootstrap) .accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
:global(.bootstrap) .accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
:global(.bootstrap) .accordion-item:not(:first-of-type) {
  border-top: 0;
}
:global(.bootstrap) .accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
:global(.bootstrap) .accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
:global(.bootstrap) .accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
:global(.bootstrap) .accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}
:global(.bootstrap) .accordion-flush .accordion-collapse {
  border-width: 0;
}
:global(.bootstrap) .accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
:global(.bootstrap) .accordion-flush .accordion-item:first-child {
  border-top: 0;
}
:global(.bootstrap) .accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
:global(.bootstrap) .accordion-flush .accordion-item .accordion-button, :global(.bootstrap) .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}
:global(.bootstrap) [data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffe766'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffe766'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}
:global(.bootstrap) .breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 1rem;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: transparent;
  --bs-breadcrumb-border-radius: 0.25rem;
  --bs-breadcrumb-divider-color: #E5E6E1;
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: #adb5bd;
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}
:global(.bootstrap) .breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
:global(.bootstrap) .breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "\f0142") /* rtl: var(--bs-breadcrumb-divider, "\f0142") */;
}
:global(.bootstrap) .breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}
:global(.bootstrap) .pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.5rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-color: #4D4D4D;
  --bs-pagination-bg: #fff;
  --bs-pagination-border-width: 1px;
  --bs-pagination-border-color: #ededed;
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: #4D4D4D;
  --bs-pagination-hover-bg: #F5F5F5;
  --bs-pagination-hover-border-color: #ededed;
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.15rem rgba(255, 215, 0, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #FFD700;
  --bs-pagination-active-border-color: #FFD700;
  --bs-pagination-disabled-color: #A9A9A9;
  --bs-pagination-disabled-bg: #fff;
  --bs-pagination-disabled-border-color: #ededed;
  display: flex;
  padding-left: 0;
  list-style: none;
}
:global(.bootstrap) .page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .page-link {
    transition: none;
  }
}
:global(.bootstrap) .page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
:global(.bootstrap) .page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
:global(.bootstrap) .page-link.active, .active > :global(.bootstrap) .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
:global(.bootstrap) .page-link.disabled, .disabled > :global(.bootstrap) .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}
:global(.bootstrap) .page-item:not(:first-child) .page-link {
  margin-left: calc(1px * -1);
}
:global(.bootstrap) .page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
:global(.bootstrap) .page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}
:global(.bootstrap) .pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.09375rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}
:global(.bootstrap) .pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.7875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}
:global(.bootstrap) .badge {
  --bs-badge-padding-x: 0.4em;
  --bs-badge-padding-y: 0.25em;
  --bs-badge-font-size: 75%;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
:global(.bootstrap) .badge:empty {
  display: none;
}
:global(.bootstrap) .btn .badge {
  position: relative;
  top: -1px;
}
:global(.bootstrap) .alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1.25rem;
  --bs-alert-padding-y: 0.75rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: 1px solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.25rem;
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}
:global(.bootstrap) .alert-heading {
  color: inherit;
}
:global(.bootstrap) .alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}
:global(.bootstrap) .alert-dismissible {
  padding-right: 3.75rem;
}
:global(.bootstrap) .alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.9375rem 1.25rem;
}
:global(.bootstrap) .alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}
:global(.bootstrap) .alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}
:global(.bootstrap) .alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}
:global(.bootstrap) .alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}
:global(.bootstrap) .alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}
:global(.bootstrap) .alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}
:global(.bootstrap) .alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}
:global(.bootstrap) .alert-medium {
  --bs-alert-color: var(--bs-medium-text-emphasis);
  --bs-alert-bg: var(--bs-medium-bg-subtle);
  --bs-alert-border-color: var(--bs-medium-border-subtle);
  --bs-alert-link-color: var(--bs-medium-text-emphasis);
}
:global(.bootstrap) .alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}
:global(.bootstrap) .alert-pro {
  --bs-alert-color: var(--bs-pro-text-emphasis);
  --bs-alert-bg: var(--bs-pro-bg-subtle);
  --bs-alert-border-color: var(--bs-pro-border-subtle);
  --bs-alert-link-color: var(--bs-pro-text-emphasis);
}
:global(.bootstrap) .alert-con {
  --bs-alert-color: var(--bs-con-text-emphasis);
  --bs-alert-bg: var(--bs-con-bg-subtle);
  --bs-alert-border-color: var(--bs-con-border-subtle);
  --bs-alert-link-color: var(--bs-con-text-emphasis);
}
@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.75rem;
  }
}
:global(.bootstrap) .progress,
:global(.bootstrap) .progress-stacked {
  --bs-progress-height: 0.75rem;
  --bs-progress-font-size: 0.65625rem;
  --bs-progress-bg: #fbfbfb;
  --bs-progress-border-radius: 0.25rem;
  --bs-progress-box-shadow: inset 0 0.1rem 0.1rem rgba(8, 9, 13, 0.1);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #FFD700;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}
:global(.bootstrap) .progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .progress-bar {
    transition: none;
  }
}
:global(.bootstrap) .progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}
:global(.bootstrap) .progress-stacked > .progress {
  overflow: visible;
}
:global(.bootstrap) .progress-stacked > .progress > .progress-bar {
  width: 100%;
}
:global(.bootstrap) .progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .progress-bar-animated {
    animation: none;
  }
}
:global(.bootstrap) .list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: #fff;
  --bs-list-group-border-color: rgba(8, 9, 13, 0.125);
  --bs-list-group-border-width: 1px;
  --bs-list-group-border-radius: 0.25rem;
  --bs-list-group-item-padding-x: 1.25rem;
  --bs-list-group-item-padding-y: 0.75rem;
  --bs-list-group-action-color: #848484;
  --bs-list-group-action-hover-color: #848484;
  --bs-list-group-action-hover-bg: #FAFAFA;
  --bs-list-group-action-active-color: #848484;
  --bs-list-group-action-active-bg: #F5F5F5;
  --bs-list-group-disabled-color: #A9A9A9;
  --bs-list-group-disabled-bg: #fff;
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #FFD700;
  --bs-list-group-active-border-color: #FFD700;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}
:global(.bootstrap) .list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
:global(.bootstrap) .list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}
:global(.bootstrap) .list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
:global(.bootstrap) .list-group-item-action:hover, :global(.bootstrap) .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
:global(.bootstrap) .list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}
:global(.bootstrap) .list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
:global(.bootstrap) .list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
:global(.bootstrap) .list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
:global(.bootstrap) .list-group-item.disabled, :global(.bootstrap) .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
:global(.bootstrap) .list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
:global(.bootstrap) .list-group-item + .list-group-item {
  border-top-width: 0;
}
:global(.bootstrap) .list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}
:global(.bootstrap) .list-group-horizontal {
  flex-direction: row;
}
:global(.bootstrap) .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
:global(.bootstrap) .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
:global(.bootstrap) .list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
:global(.bootstrap) .list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
:global(.bootstrap) .list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}
@media (min-width: 576px) {
  :global(.bootstrap) .list-group-horizontal-sm {
    flex-direction: row;
  }
  :global(.bootstrap) .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  :global(.bootstrap) .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  :global(.bootstrap) .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  :global(.bootstrap) .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  :global(.bootstrap) .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .list-group-horizontal-md {
    flex-direction: row;
  }
  :global(.bootstrap) .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  :global(.bootstrap) .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  :global(.bootstrap) .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  :global(.bootstrap) .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  :global(.bootstrap) .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  :global(.bootstrap) .list-group-horizontal-lg {
    flex-direction: row;
  }
  :global(.bootstrap) .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  :global(.bootstrap) .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  :global(.bootstrap) .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  :global(.bootstrap) .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  :global(.bootstrap) .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1367px) {
  :global(.bootstrap) .list-group-horizontal-xl {
    flex-direction: row;
  }
  :global(.bootstrap) .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  :global(.bootstrap) .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  :global(.bootstrap) .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  :global(.bootstrap) .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  :global(.bootstrap) .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  :global(.bootstrap) .list-group-horizontal-xxl {
    flex-direction: row;
  }
  :global(.bootstrap) .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  :global(.bootstrap) .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  :global(.bootstrap) .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  :global(.bootstrap) .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  :global(.bootstrap) .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
:global(.bootstrap) .list-group-flush {
  border-radius: 0;
}
:global(.bootstrap) .list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
:global(.bootstrap) .list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}
:global(.bootstrap) .list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}
:global(.bootstrap) .list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}
:global(.bootstrap) .list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}
:global(.bootstrap) .list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}
:global(.bootstrap) .list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}
:global(.bootstrap) .list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}
:global(.bootstrap) .list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}
:global(.bootstrap) .list-group-item-medium {
  --bs-list-group-color: var(--bs-medium-text-emphasis);
  --bs-list-group-bg: var(--bs-medium-bg-subtle);
  --bs-list-group-border-color: var(--bs-medium-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-medium-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-medium-border-subtle);
  --bs-list-group-active-color: var(--bs-medium-bg-subtle);
  --bs-list-group-active-bg: var(--bs-medium-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-medium-text-emphasis);
}
:global(.bootstrap) .list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}
:global(.bootstrap) .list-group-item-pro {
  --bs-list-group-color: var(--bs-pro-text-emphasis);
  --bs-list-group-bg: var(--bs-pro-bg-subtle);
  --bs-list-group-border-color: var(--bs-pro-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-pro-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-pro-border-subtle);
  --bs-list-group-active-color: var(--bs-pro-bg-subtle);
  --bs-list-group-active-bg: var(--bs-pro-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-pro-text-emphasis);
}
:global(.bootstrap) .list-group-item-con {
  --bs-list-group-color: var(--bs-con-text-emphasis);
  --bs-list-group-bg: var(--bs-con-bg-subtle);
  --bs-list-group-border-color: var(--bs-con-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-con-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-con-border-subtle);
  --bs-list-group-active-color: var(--bs-con-bg-subtle);
  --bs-list-group-active-bg: var(--bs-con-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-con-text-emphasis);
}
:global(.bootstrap) .btn-close {
  --bs-btn-close-color: #08090D;
  --bs-btn-close-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%2308090D'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e");
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(255, 215, 0, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: var(--bs-btn-close-opacity);
}
:global(.bootstrap) .btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
:global(.bootstrap) .btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
:global(.bootstrap) .btn-close:disabled, :global(.bootstrap) .btn-close.disabled {
  pointer-events: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}
:global(.bootstrap) .btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}
:global(.bootstrap) [data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}
:global(.bootstrap) .toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.25rem;
  --bs-toast-spacing: 24px;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-border-width: 1px;
  --bs-toast-border-color: rgba(0, 0, 0, 0.1);
  --bs-toast-border-radius: 0.25rem;
  --bs-toast-box-shadow: 0 0.25rem 0.75rem rgba(8, 9, 13, 0.1);
  --bs-toast-header-color: #A9A9A9;
  --bs-toast-header-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
:global(.bootstrap) .toast.showing {
  opacity: 0;
}
:global(.bootstrap) .toast:not(.show) {
  display: none;
}
:global(.bootstrap) .toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
:global(.bootstrap) .toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}
:global(.bootstrap) .toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
:global(.bootstrap) .toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}
:global(.bootstrap) .toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}
:global(.bootstrap) .modal {
  --bs-modal-zindex: 1090;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: #fff;
  --bs-modal-border-color: transparent;
  --bs-modal-border-width: 1px;
  --bs-modal-border-radius: 0.2rem;
  --bs-modal-box-shadow: 0 0.25rem 0.5rem rgba(8, 9, 13, 0.5);
  --bs-modal-inner-border-radius: calc(0.2rem - 1px);
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: #f3f3f3;
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: #f3f3f3;
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}
:global(.bootstrap) .modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade :global(.bootstrap) .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade :global(.bootstrap) .modal-dialog {
    transition: none;
  }
}
.modal.show :global(.bootstrap) .modal-dialog {
  transform: none;
}
.modal.modal-static :global(.bootstrap) .modal-dialog {
  transform: scale(1.02);
}
:global(.bootstrap) .modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
:global(.bootstrap) .modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
:global(.bootstrap) .modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}
:global(.bootstrap) .modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}
:global(.bootstrap) .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}
:global(.bootstrap) .modal-backdrop {
  --bs-backdrop-zindex: 1080;
  --bs-backdrop-bg: #4D4D4D;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
:global(.bootstrap) .modal-backdrop.fade {
  opacity: 0;
}
:global(.bootstrap) .modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}
:global(.bootstrap) .modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
:global(.bootstrap) .modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}
:global(.bootstrap) .modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}
:global(.bootstrap) .modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}
:global(.bootstrap) .modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
:global(.bootstrap) .modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}
@media (min-width: 576px) {
  :global(.bootstrap) .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(8, 9, 13, 0.5);
  }
  :global(.bootstrap) .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  :global(.bootstrap) .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  :global(.bootstrap) .modal-lg,
  :global(.bootstrap) .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1367px) {
  :global(.bootstrap) .modal-xl {
    --bs-modal-width: 1140px;
  }
}
:global(.bootstrap) .modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
:global(.bootstrap) .modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
:global(.bootstrap) .modal-fullscreen .modal-header,
:global(.bootstrap) .modal-fullscreen .modal-footer {
  border-radius: 0;
}
:global(.bootstrap) .modal-fullscreen .modal-body {
  overflow-y: auto;
}
@media (max-width: 575.98px) {
  :global(.bootstrap) .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  :global(.bootstrap) .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  :global(.bootstrap) .modal-fullscreen-sm-down .modal-header,
  :global(.bootstrap) .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  :global(.bootstrap) .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 812.98px) {
  :global(.bootstrap) .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  :global(.bootstrap) .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  :global(.bootstrap) .modal-fullscreen-md-down .modal-header,
  :global(.bootstrap) .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  :global(.bootstrap) .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  :global(.bootstrap) .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  :global(.bootstrap) .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  :global(.bootstrap) .modal-fullscreen-lg-down .modal-header,
  :global(.bootstrap) .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  :global(.bootstrap) .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1366.98px) {
  :global(.bootstrap) .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  :global(.bootstrap) .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  :global(.bootstrap) .modal-fullscreen-xl-down .modal-header,
  :global(.bootstrap) .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  :global(.bootstrap) .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  :global(.bootstrap) .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  :global(.bootstrap) .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  :global(.bootstrap) .modal-fullscreen-xxl-down .modal-header,
  :global(.bootstrap) .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  :global(.bootstrap) .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
:global(.bootstrap) .tooltip {
  --bs-tooltip-zindex: 1070;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.8rem;
  --bs-tooltip-padding-y: 0.4rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: #fff;
  --bs-tooltip-bg: #08090D;
  --bs-tooltip-border-radius: 0.2rem;
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
:global(.bootstrap) .tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
:global(.bootstrap) .tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
:global(.bootstrap) .tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}
:global(.bootstrap) .bs-tooltip-top .tooltip-arrow, :global(.bootstrap) .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
:global(.bootstrap) .bs-tooltip-top .tooltip-arrow::before, :global(.bootstrap) .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}
:global(.bootstrap) .bs-tooltip-end .tooltip-arrow, :global(.bootstrap) .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
:global(.bootstrap) .bs-tooltip-end .tooltip-arrow::before, :global(.bootstrap) .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}
:global(.bootstrap) .bs-tooltip-bottom .tooltip-arrow, :global(.bootstrap) .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
:global(.bootstrap) .bs-tooltip-bottom .tooltip-arrow::before, :global(.bootstrap) .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}
:global(.bootstrap) .bs-tooltip-start .tooltip-arrow, :global(.bootstrap) .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
:global(.bootstrap) .bs-tooltip-start .tooltip-arrow::before, :global(.bootstrap) .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}
:global(.bootstrap) .tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}
:global(.bootstrap) .popover {
  --bs-popover-zindex: 1060;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.7875rem;
  --bs-popover-bg: #EEF8FF;
  --bs-popover-border-width: 1px;
  --bs-popover-border-color: #ededed;
  --bs-popover-border-radius: 0.25rem;
  --bs-popover-inner-border-radius: calc(0.25rem - 1px);
  --bs-popover-box-shadow: 0 0.25rem 0.5rem rgba(8, 9, 13, 0.2);
  --bs-popover-header-padding-x: 0.8rem;
  --bs-popover-header-padding-y: 0.7rem;
  --bs-popover-header-font-size: 0.875rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: #FAFAFA;
  --bs-popover-body-padding-x: 0.8rem;
  --bs-popover-body-padding-y: 0.7rem;
  --bs-popover-body-color: #08090D;
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
:global(.bootstrap) .popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
:global(.bootstrap) .popover .popover-arrow::before, :global(.bootstrap) .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}
:global(.bootstrap) .bs-popover-top > .popover-arrow, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
:global(.bootstrap) .bs-popover-top > .popover-arrow::before, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, :global(.bootstrap) .bs-popover-top > .popover-arrow::after, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
:global(.bootstrap) .bs-popover-top > .popover-arrow::before, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
:global(.bootstrap) .bs-popover-top > .popover-arrow::after, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}
:global(.bootstrap) .bs-popover-end > .popover-arrow, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
:global(.bootstrap) .bs-popover-end > .popover-arrow::before, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, :global(.bootstrap) .bs-popover-end > .popover-arrow::after, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
:global(.bootstrap) .bs-popover-end > .popover-arrow::before, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
:global(.bootstrap) .bs-popover-end > .popover-arrow::after, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}
:global(.bootstrap) .bs-popover-bottom > .popover-arrow, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
:global(.bootstrap) .bs-popover-bottom > .popover-arrow::before, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, :global(.bootstrap) .bs-popover-bottom > .popover-arrow::after, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
:global(.bootstrap) .bs-popover-bottom > .popover-arrow::before, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
:global(.bootstrap) .bs-popover-bottom > .popover-arrow::after, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
:global(.bootstrap) .bs-popover-bottom .popover-header::before, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}
:global(.bootstrap) .bs-popover-start > .popover-arrow, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
:global(.bootstrap) .bs-popover-start > .popover-arrow::before, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, :global(.bootstrap) .bs-popover-start > .popover-arrow::after, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
:global(.bootstrap) .bs-popover-start > .popover-arrow::before, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
:global(.bootstrap) .bs-popover-start > .popover-arrow::after, :global(.bootstrap) .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}
:global(.bootstrap) .popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
:global(.bootstrap) .popover-header:empty {
  display: none;
}
:global(.bootstrap) .popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}
:global(.bootstrap) .carousel {
  position: relative;
}
:global(.bootstrap) .carousel.pointer-event {
  touch-action: pan-y;
}
:global(.bootstrap) .carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
:global(.bootstrap) .carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}
:global(.bootstrap) .carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .carousel-item {
    transition: none;
  }
}
:global(.bootstrap) .carousel-item.active,
:global(.bootstrap) .carousel-item-next,
:global(.bootstrap) .carousel-item-prev {
  display: block;
}
:global(.bootstrap) .carousel-item-next:not(.carousel-item-start),
:global(.bootstrap) .active.carousel-item-end {
  transform: translateX(100%);
}
:global(.bootstrap) .carousel-item-prev:not(.carousel-item-end),
:global(.bootstrap) .active.carousel-item-start {
  transform: translateX(-100%);
}
:global(.bootstrap) .carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
:global(.bootstrap) .carousel-fade .carousel-item.active,
:global(.bootstrap) .carousel-fade .carousel-item-next.carousel-item-start,
:global(.bootstrap) .carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
:global(.bootstrap) .carousel-fade .active.carousel-item-start,
:global(.bootstrap) .carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .carousel-fade .active.carousel-item-start,
  :global(.bootstrap) .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}
:global(.bootstrap) .carousel-control-prev,
:global(.bootstrap) .carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .carousel-control-prev,
  :global(.bootstrap) .carousel-control-next {
    transition: none;
  }
}
:global(.bootstrap) .carousel-control-prev:hover, :global(.bootstrap) .carousel-control-prev:focus,
:global(.bootstrap) .carousel-control-next:hover,
:global(.bootstrap) .carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}
:global(.bootstrap) .carousel-control-prev {
  left: 0;
}
:global(.bootstrap) .carousel-control-next {
  right: 0;
}
:global(.bootstrap) .carousel-control-prev-icon,
:global(.bootstrap) .carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}
:global(.bootstrap) .carousel-control-prev-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e");
}
:global(.bootstrap) .carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e");
}
:global(.bootstrap) .carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
:global(.bootstrap) .carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
:global(.bootstrap) .carousel-indicators .active {
  opacity: 1;
}
:global(.bootstrap) .carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}
:global(.bootstrap) .carousel-dark .carousel-control-prev-icon,
:global(.bootstrap) .carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
:global(.bootstrap) .carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #08090D;
}
:global(.bootstrap) .carousel-dark .carousel-caption {
  color: #08090D;
}
:global(.bootstrap) [data-bs-theme=dark] .carousel .carousel-control-prev-icon,
:global(.bootstrap) [data-bs-theme=dark] .carousel .carousel-control-next-icon, :global(.bootstrap) [data-bs-theme=dark].carousel .carousel-control-prev-icon,
:global(.bootstrap) [data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
:global(.bootstrap) [data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], :global(.bootstrap) [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #08090D;
}
:global(.bootstrap) [data-bs-theme=dark] .carousel .carousel-caption, :global(.bootstrap) [data-bs-theme=dark].carousel .carousel-caption {
  color: #08090D;
}
:global(.bootstrap) .spinner-grow,
:global(.bootstrap) .spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}
@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
:global(.bootstrap) .spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}
:global(.bootstrap) .spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}
@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
:global(.bootstrap) .spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}
:global(.bootstrap) .spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .spinner-border,
  :global(.bootstrap) .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
:global(.bootstrap) .offcanvas, :global(.bootstrap) .offcanvas-xxl, :global(.bootstrap) .offcanvas-xl, :global(.bootstrap) .offcanvas-lg, :global(.bootstrap) .offcanvas-md, :global(.bootstrap) .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: 1px;
  --bs-offcanvas-border-color: transparent;
  --bs-offcanvas-box-shadow: 0 0.25rem 0.5rem rgba(8, 9, 13, 0.5);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}
@media (max-width: 575.98px) {
  :global(.bootstrap) .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  :global(.bootstrap) .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  :global(.bootstrap) .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  :global(.bootstrap) .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  :global(.bootstrap) .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  :global(.bootstrap) .offcanvas-sm.showing, :global(.bootstrap) .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  :global(.bootstrap) .offcanvas-sm.showing, :global(.bootstrap) .offcanvas-sm.hiding, :global(.bootstrap) .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  :global(.bootstrap) .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  :global(.bootstrap) .offcanvas-sm .offcanvas-header {
    display: none;
  }
  :global(.bootstrap) .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 812.98px) {
  :global(.bootstrap) .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 812.98px) and (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 812.98px) {
  :global(.bootstrap) .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  :global(.bootstrap) .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  :global(.bootstrap) .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  :global(.bootstrap) .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  :global(.bootstrap) .offcanvas-md.showing, :global(.bootstrap) .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  :global(.bootstrap) .offcanvas-md.showing, :global(.bootstrap) .offcanvas-md.hiding, :global(.bootstrap) .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  :global(.bootstrap) .offcanvas-md .offcanvas-header {
    display: none;
  }
  :global(.bootstrap) .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 991.98px) {
  :global(.bootstrap) .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  :global(.bootstrap) .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  :global(.bootstrap) .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  :global(.bootstrap) .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  :global(.bootstrap) .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  :global(.bootstrap) .offcanvas-lg.showing, :global(.bootstrap) .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  :global(.bootstrap) .offcanvas-lg.showing, :global(.bootstrap) .offcanvas-lg.hiding, :global(.bootstrap) .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  :global(.bootstrap) .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  :global(.bootstrap) .offcanvas-lg .offcanvas-header {
    display: none;
  }
  :global(.bootstrap) .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1366.98px) {
  :global(.bootstrap) .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1366.98px) and (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1366.98px) {
  :global(.bootstrap) .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  :global(.bootstrap) .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  :global(.bootstrap) .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  :global(.bootstrap) .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  :global(.bootstrap) .offcanvas-xl.showing, :global(.bootstrap) .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  :global(.bootstrap) .offcanvas-xl.showing, :global(.bootstrap) .offcanvas-xl.hiding, :global(.bootstrap) .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1367px) {
  :global(.bootstrap) .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  :global(.bootstrap) .offcanvas-xl .offcanvas-header {
    display: none;
  }
  :global(.bootstrap) .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1399.98px) {
  :global(.bootstrap) .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  :global(.bootstrap) .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  :global(.bootstrap) .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  :global(.bootstrap) .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  :global(.bootstrap) .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  :global(.bootstrap) .offcanvas-xxl.showing, :global(.bootstrap) .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  :global(.bootstrap) .offcanvas-xxl.showing, :global(.bootstrap) .offcanvas-xxl.hiding, :global(.bootstrap) .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  :global(.bootstrap) .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  :global(.bootstrap) .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  :global(.bootstrap) .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
:global(.bootstrap) .offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .offcanvas {
    transition: none;
  }
}
:global(.bootstrap) .offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
:global(.bootstrap) .offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
:global(.bootstrap) .offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
:global(.bootstrap) .offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
:global(.bootstrap) .offcanvas.showing, :global(.bootstrap) .offcanvas.show:not(.hiding) {
  transform: none;
}
:global(.bootstrap) .offcanvas.showing, :global(.bootstrap) .offcanvas.hiding, :global(.bootstrap) .offcanvas.show {
  visibility: visible;
}
:global(.bootstrap) .offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #4D4D4D;
}
:global(.bootstrap) .offcanvas-backdrop.fade {
  opacity: 0;
}
:global(.bootstrap) .offcanvas-backdrop.show {
  opacity: 0.5;
}
:global(.bootstrap) .offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
:global(.bootstrap) .offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}
:global(.bootstrap) .offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}
:global(.bootstrap) .offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}
:global(.bootstrap) .placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
:global(.bootstrap) .placeholder.btn::before {
  display: inline-block;
  content: "";
}
:global(.bootstrap) .placeholder-xs {
  min-height: 0.6em;
}
:global(.bootstrap) .placeholder-sm {
  min-height: 0.8em;
}
:global(.bootstrap) .placeholder-lg {
  min-height: 1.2em;
}
:global(.bootstrap) .placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}
@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
:global(.bootstrap) .placeholder-wave {
  mask-image: linear-gradient(130deg, #08090D 55%, rgba(0, 0, 0, 0.8) 75%, #08090D 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}
@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
:global(.bootstrap) .clearfix::after {
  display: block;
  clear: both;
  content: "";
}
:global(.bootstrap) .text-bg-primary {
  color: #08090D !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}
:global(.bootstrap) .text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}
:global(.bootstrap) .text-bg-success {
  color: #08090D !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}
:global(.bootstrap) .text-bg-info {
  color: #fff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}
:global(.bootstrap) .text-bg-warning {
  color: #08090D !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}
:global(.bootstrap) .text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}
:global(.bootstrap) .text-bg-light {
  color: #666560 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}
:global(.bootstrap) .text-bg-medium {
  color: #08090D !important;
  background-color: RGBA(var(--bs-medium-rgb), var(--bs-bg-opacity, 1)) !important;
}
:global(.bootstrap) .text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}
:global(.bootstrap) .text-bg-pro {
  color: #08090D !important;
  background-color: RGBA(var(--bs-pro-rgb), var(--bs-bg-opacity, 1)) !important;
}
:global(.bootstrap) .text-bg-con {
  color: #fff !important;
  background-color: RGBA(var(--bs-con-rgb), var(--bs-bg-opacity, 1)) !important;
}
:global(.bootstrap) .link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-primary:hover, :global(.bootstrap) .link-primary:focus {
  color: RGBA(255, 223, 51, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 223, 51, var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-secondary:hover, :global(.bootstrap) .link-secondary:focus {
  color: RGBA(6, 7, 10, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(6, 7, 10, var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-success:hover, :global(.bootstrap) .link-success:focus {
  color: RGBA(57, 212, 128, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(57, 212, 128, var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-info:hover, :global(.bootstrap) .link-info:focus {
  color: RGBA(96, 74, 134, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(96, 74, 134, var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-warning:hover, :global(.bootstrap) .link-warning:focus {
  color: RGBA(253, 171, 112, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(253, 171, 112, var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-danger:hover, :global(.bootstrap) .link-danger:focus {
  color: RGBA(150, 4, 4, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(150, 4, 4, var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-light:hover, :global(.bootstrap) .link-light:focus {
  color: RGBA(247, 247, 247, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(247, 247, 247, var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-medium {
  color: RGBA(var(--bs-medium-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-medium-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-medium:hover, :global(.bootstrap) .link-medium:focus {
  color: RGBA(157, 157, 157, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(157, 157, 157, var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-dark:hover, :global(.bootstrap) .link-dark:focus {
  color: RGBA(62, 62, 62, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(62, 62, 62, var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-pro {
  color: RGBA(var(--bs-pro-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-pro-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-pro:hover, :global(.bootstrap) .link-pro:focus {
  color: RGBA(57, 212, 128, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(57, 212, 128, var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-con {
  color: RGBA(var(--bs-con-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-con-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-con:hover, :global(.bootstrap) .link-con:focus {
  color: RGBA(150, 4, 4, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(150, 4, 4, var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-body-emphasis:hover, :global(.bootstrap) .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}
:global(.bootstrap) .focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}
:global(.bootstrap) .icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
:global(.bootstrap) .icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  :global(.bootstrap) .icon-link > .bi {
    transition: none;
  }
}
:global(.bootstrap) .icon-link-hover:hover > .bi, :global(.bootstrap) .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}
:global(.bootstrap) .ratio {
  position: relative;
  width: 100%;
}
:global(.bootstrap) .ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
:global(.bootstrap) .ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
:global(.bootstrap) .ratio-1x1 {
  --bs-aspect-ratio: 100%;
}
:global(.bootstrap) .ratio-4x3 {
  --bs-aspect-ratio: 75%;
}
:global(.bootstrap) .ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}
:global(.bootstrap) .ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}
:global(.bootstrap) .fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
:global(.bootstrap) .fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}
:global(.bootstrap) .sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}
:global(.bootstrap) .sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}
@media (min-width: 576px) {
  :global(.bootstrap) .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  :global(.bootstrap) .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  :global(.bootstrap) .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  :global(.bootstrap) .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  :global(.bootstrap) .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1367px) {
  :global(.bootstrap) .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  :global(.bootstrap) .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  :global(.bootstrap) .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  :global(.bootstrap) .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
:global(.bootstrap) .hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}
:global(.bootstrap) .vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}
:global(.bootstrap) .visually-hidden,
:global(.bootstrap) .visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
:global(.bootstrap) .visually-hidden:not(caption),
:global(.bootstrap) .visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
:global(.bootstrap) .stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}
:global(.bootstrap) .text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:global(.bootstrap) .vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}
:global(.bootstrap) .align-baseline {
  vertical-align: baseline !important;
}
:global(.bootstrap) .align-top {
  vertical-align: top !important;
}
:global(.bootstrap) .align-middle {
  vertical-align: middle !important;
}
:global(.bootstrap) .align-bottom {
  vertical-align: bottom !important;
}
:global(.bootstrap) .align-text-bottom {
  vertical-align: text-bottom !important;
}
:global(.bootstrap) .align-text-top {
  vertical-align: text-top !important;
}
:global(.bootstrap) .float-start {
  float: left !important;
}
:global(.bootstrap) .float-end {
  float: right !important;
}
:global(.bootstrap) .float-none {
  float: none !important;
}
:global(.bootstrap) .object-fit-contain {
  object-fit: contain !important;
}
:global(.bootstrap) .object-fit-cover {
  object-fit: cover !important;
}
:global(.bootstrap) .object-fit-fill {
  object-fit: fill !important;
}
:global(.bootstrap) .object-fit-scale {
  object-fit: scale-down !important;
}
:global(.bootstrap) .object-fit-none {
  object-fit: none !important;
}
:global(.bootstrap) .opacity-0 {
  opacity: 0 !important;
}
:global(.bootstrap) .opacity-25 {
  opacity: 0.25 !important;
}
:global(.bootstrap) .opacity-50 {
  opacity: 0.5 !important;
}
:global(.bootstrap) .opacity-75 {
  opacity: 0.75 !important;
}
:global(.bootstrap) .opacity-100 {
  opacity: 1 !important;
}
:global(.bootstrap) .overflow-auto {
  overflow: auto !important;
}
:global(.bootstrap) .overflow-hidden {
  overflow: hidden !important;
}
:global(.bootstrap) .overflow-visible {
  overflow: visible !important;
}
:global(.bootstrap) .overflow-scroll {
  overflow: scroll !important;
}
:global(.bootstrap) .overflow-x-auto {
  overflow-x: auto !important;
}
:global(.bootstrap) .overflow-x-hidden {
  overflow-x: hidden !important;
}
:global(.bootstrap) .overflow-x-visible {
  overflow-x: visible !important;
}
:global(.bootstrap) .overflow-x-scroll {
  overflow-x: scroll !important;
}
:global(.bootstrap) .overflow-y-auto {
  overflow-y: auto !important;
}
:global(.bootstrap) .overflow-y-hidden {
  overflow-y: hidden !important;
}
:global(.bootstrap) .overflow-y-visible {
  overflow-y: visible !important;
}
:global(.bootstrap) .overflow-y-scroll {
  overflow-y: scroll !important;
}
:global(.bootstrap) .d-inline {
  display: inline !important;
}
:global(.bootstrap) .d-inline-block {
  display: inline-block !important;
}
:global(.bootstrap) .d-block {
  display: block !important;
}
:global(.bootstrap) .d-grid {
  display: grid !important;
}
:global(.bootstrap) .d-inline-grid {
  display: inline-grid !important;
}
:global(.bootstrap) .d-table {
  display: table !important;
}
:global(.bootstrap) .d-table-row {
  display: table-row !important;
}
:global(.bootstrap) .d-table-cell {
  display: table-cell !important;
}
:global(.bootstrap) .d-flex {
  display: flex !important;
}
:global(.bootstrap) .d-inline-flex {
  display: inline-flex !important;
}
:global(.bootstrap) .d-none {
  display: none !important;
}
:global(.bootstrap) .shadow {
  box-shadow: var(--bs-box-shadow) !important;
}
:global(.bootstrap) .shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}
:global(.bootstrap) .shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}
:global(.bootstrap) .shadow-none {
  box-shadow: none !important;
}
:global(.bootstrap) .focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}
:global(.bootstrap) .focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}
:global(.bootstrap) .focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}
:global(.bootstrap) .focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}
:global(.bootstrap) .focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}
:global(.bootstrap) .focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}
:global(.bootstrap) .focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}
:global(.bootstrap) .focus-ring-medium {
  --bs-focus-ring-color: rgba(var(--bs-medium-rgb), var(--bs-focus-ring-opacity));
}
:global(.bootstrap) .focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}
:global(.bootstrap) .focus-ring-pro {
  --bs-focus-ring-color: rgba(var(--bs-pro-rgb), var(--bs-focus-ring-opacity));
}
:global(.bootstrap) .focus-ring-con {
  --bs-focus-ring-color: rgba(var(--bs-con-rgb), var(--bs-focus-ring-opacity));
}
:global(.bootstrap) .position-static {
  position: static !important;
}
:global(.bootstrap) .position-relative {
  position: relative !important;
}
:global(.bootstrap) .position-absolute {
  position: absolute !important;
}
:global(.bootstrap) .position-fixed {
  position: fixed !important;
}
:global(.bootstrap) .position-sticky {
  position: sticky !important;
}
:global(.bootstrap) .top-0 {
  top: 0 !important;
}
:global(.bootstrap) .top-5 {
  top: 5% !important;
}
:global(.bootstrap) .top-10 {
  top: 10% !important;
}
:global(.bootstrap) .top-25 {
  top: 25% !important;
}
:global(.bootstrap) .top-50 {
  top: 50% !important;
}
:global(.bootstrap) .top-75 {
  top: 75% !important;
}
:global(.bootstrap) .top-100 {
  top: 100% !important;
}
:global(.bootstrap) .bottom-0 {
  bottom: 0 !important;
}
:global(.bootstrap) .bottom-5 {
  bottom: 5% !important;
}
:global(.bootstrap) .bottom-10 {
  bottom: 10% !important;
}
:global(.bootstrap) .bottom-25 {
  bottom: 25% !important;
}
:global(.bootstrap) .bottom-50 {
  bottom: 50% !important;
}
:global(.bootstrap) .bottom-75 {
  bottom: 75% !important;
}
:global(.bootstrap) .bottom-100 {
  bottom: 100% !important;
}
:global(.bootstrap) .start-0 {
  left: 0 !important;
}
:global(.bootstrap) .start-5 {
  left: 5% !important;
}
:global(.bootstrap) .start-10 {
  left: 10% !important;
}
:global(.bootstrap) .start-25 {
  left: 25% !important;
}
:global(.bootstrap) .start-50 {
  left: 50% !important;
}
:global(.bootstrap) .start-75 {
  left: 75% !important;
}
:global(.bootstrap) .start-100 {
  left: 100% !important;
}
:global(.bootstrap) .end-0 {
  right: 0 !important;
}
:global(.bootstrap) .end-5 {
  right: 5% !important;
}
:global(.bootstrap) .end-10 {
  right: 10% !important;
}
:global(.bootstrap) .end-25 {
  right: 25% !important;
}
:global(.bootstrap) .end-50 {
  right: 50% !important;
}
:global(.bootstrap) .end-75 {
  right: 75% !important;
}
:global(.bootstrap) .end-100 {
  right: 100% !important;
}
:global(.bootstrap) .translate-middle {
  transform: translate(-50%, -50%) !important;
}
:global(.bootstrap) .translate-middle-x {
  transform: translateX(-50%) !important;
}
:global(.bootstrap) .translate-middle-y {
  transform: translateY(-50%) !important;
}
:global(.bootstrap) .border {
  border: 1px solid #f3f3f3 !important;
}
:global(.bootstrap) .border-0 {
  border: 0 !important;
}
:global(.bootstrap) .border-top {
  border-top: 1px solid #f3f3f3 !important;
}
:global(.bootstrap) .border-top-0 {
  border-top: 0 !important;
}
:global(.bootstrap) .border-end {
  border-right: 1px solid #f3f3f3 !important;
}
:global(.bootstrap) .border-end-0 {
  border-right: 0 !important;
}
:global(.bootstrap) .border-bottom {
  border-bottom: 1px solid #f3f3f3 !important;
}
:global(.bootstrap) .border-bottom-0 {
  border-bottom: 0 !important;
}
:global(.bootstrap) .border-start {
  border-left: 1px solid #f3f3f3 !important;
}
:global(.bootstrap) .border-start-0 {
  border-left: 0 !important;
}
:global(.bootstrap) .border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-medium {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-medium-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-pro {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-pro-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-con {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-con-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}
:global(.bootstrap) .border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}
:global(.bootstrap) .border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}
:global(.bootstrap) .border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}
:global(.bootstrap) .border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}
:global(.bootstrap) .border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}
:global(.bootstrap) .border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}
:global(.bootstrap) .border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}
:global(.bootstrap) .border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}
:global(.bootstrap) .border-1 {
  border-width: 1px !important;
}
:global(.bootstrap) .border-2 {
  border-width: 2px !important;
}
:global(.bootstrap) .border-3 {
  border-width: 3px !important;
}
:global(.bootstrap) .border-4 {
  border-width: 4px !important;
}
:global(.bootstrap) .border-5 {
  border-width: 5px !important;
}
:global(.bootstrap) .border-opacity-10 {
  --bs-border-opacity: 0.1;
}
:global(.bootstrap) .border-opacity-25 {
  --bs-border-opacity: 0.25;
}
:global(.bootstrap) .border-opacity-50 {
  --bs-border-opacity: 0.5;
}
:global(.bootstrap) .border-opacity-75 {
  --bs-border-opacity: 0.75;
}
:global(.bootstrap) .border-opacity-100 {
  --bs-border-opacity: 1;
}
:global(.bootstrap) .w-10 {
  width: 10% !important;
}
:global(.bootstrap) .w-15 {
  width: 15% !important;
}
:global(.bootstrap) .w-20 {
  width: 20% !important;
}
:global(.bootstrap) .w-25 {
  width: 25% !important;
}
:global(.bootstrap) .w-50 {
  width: 50% !important;
}
:global(.bootstrap) .w-75 {
  width: 75% !important;
}
:global(.bootstrap) .w-100 {
  width: 100% !important;
}
:global(.bootstrap) .w-auto {
  width: auto !important;
}
:global(.bootstrap) .mw-100 {
  max-width: 100% !important;
}
:global(.bootstrap) .vw-100 {
  width: 100vw !important;
}
:global(.bootstrap) .min-vw-100 {
  min-width: 100vw !important;
}
:global(.bootstrap) .h-25 {
  height: 25% !important;
}
:global(.bootstrap) .h-50 {
  height: 50% !important;
}
:global(.bootstrap) .h-75 {
  height: 75% !important;
}
:global(.bootstrap) .h-100 {
  height: 100% !important;
}
:global(.bootstrap) .h-auto {
  height: auto !important;
}
:global(.bootstrap) .mh-100 {
  max-height: 100% !important;
}
:global(.bootstrap) .vh-100 {
  height: 100vh !important;
}
:global(.bootstrap) .min-vh-100 {
  min-height: 100vh !important;
}
:global(.bootstrap) .flex-fill {
  flex: 1 1 auto !important;
}
:global(.bootstrap) .flex-row {
  flex-direction: row !important;
}
:global(.bootstrap) .flex-column {
  flex-direction: column !important;
}
:global(.bootstrap) .flex-row-reverse {
  flex-direction: row-reverse !important;
}
:global(.bootstrap) .flex-column-reverse {
  flex-direction: column-reverse !important;
}
:global(.bootstrap) .flex-grow-0 {
  flex-grow: 0 !important;
}
:global(.bootstrap) .flex-grow-1 {
  flex-grow: 1 !important;
}
:global(.bootstrap) .flex-shrink-0 {
  flex-shrink: 0 !important;
}
:global(.bootstrap) .flex-shrink-1 {
  flex-shrink: 1 !important;
}
:global(.bootstrap) .flex-wrap {
  flex-wrap: wrap !important;
}
:global(.bootstrap) .flex-nowrap {
  flex-wrap: nowrap !important;
}
:global(.bootstrap) .flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}
:global(.bootstrap) .justify-content-start {
  justify-content: flex-start !important;
}
:global(.bootstrap) .justify-content-end {
  justify-content: flex-end !important;
}
:global(.bootstrap) .justify-content-center {
  justify-content: center !important;
}
:global(.bootstrap) .justify-content-between {
  justify-content: space-between !important;
}
:global(.bootstrap) .justify-content-around {
  justify-content: space-around !important;
}
:global(.bootstrap) .justify-content-evenly {
  justify-content: space-evenly !important;
}
:global(.bootstrap) .align-items-start {
  align-items: flex-start !important;
}
:global(.bootstrap) .align-items-end {
  align-items: flex-end !important;
}
:global(.bootstrap) .align-items-center {
  align-items: center !important;
}
:global(.bootstrap) .align-items-baseline {
  align-items: baseline !important;
}
:global(.bootstrap) .align-items-stretch {
  align-items: stretch !important;
}
:global(.bootstrap) .align-content-start {
  align-content: flex-start !important;
}
:global(.bootstrap) .align-content-end {
  align-content: flex-end !important;
}
:global(.bootstrap) .align-content-center {
  align-content: center !important;
}
:global(.bootstrap) .align-content-between {
  align-content: space-between !important;
}
:global(.bootstrap) .align-content-around {
  align-content: space-around !important;
}
:global(.bootstrap) .align-content-stretch {
  align-content: stretch !important;
}
:global(.bootstrap) .align-self-auto {
  align-self: auto !important;
}
:global(.bootstrap) .align-self-start {
  align-self: flex-start !important;
}
:global(.bootstrap) .align-self-end {
  align-self: flex-end !important;
}
:global(.bootstrap) .align-self-center {
  align-self: center !important;
}
:global(.bootstrap) .align-self-baseline {
  align-self: baseline !important;
}
:global(.bootstrap) .align-self-stretch {
  align-self: stretch !important;
}
:global(.bootstrap) .order-first {
  order: -1 !important;
}
:global(.bootstrap) .order-0 {
  order: 0 !important;
}
:global(.bootstrap) .order-1 {
  order: 1 !important;
}
:global(.bootstrap) .order-2 {
  order: 2 !important;
}
:global(.bootstrap) .order-3 {
  order: 3 !important;
}
:global(.bootstrap) .order-4 {
  order: 4 !important;
}
:global(.bootstrap) .order-5 {
  order: 5 !important;
}
:global(.bootstrap) .order-last {
  order: 6 !important;
}
:global(.bootstrap) .m-0 {
  margin: 0 !important;
}
:global(.bootstrap) .m-1 {
  margin: 0.375rem !important;
}
:global(.bootstrap) .m-2 {
  margin: 0.75rem !important;
}
:global(.bootstrap) .m-3 {
  margin: 1.5rem !important;
}
:global(.bootstrap) .m-4 {
  margin: 2.25rem !important;
}
:global(.bootstrap) .m-5 {
  margin: 4.5rem !important;
}
:global(.bootstrap) .m-auto {
  margin: auto !important;
}
:global(.bootstrap) .mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}
:global(.bootstrap) .mx-1 {
  margin-right: 0.375rem !important;
  margin-left: 0.375rem !important;
}
:global(.bootstrap) .mx-2 {
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
}
:global(.bootstrap) .mx-3 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}
:global(.bootstrap) .mx-4 {
  margin-right: 2.25rem !important;
  margin-left: 2.25rem !important;
}
:global(.bootstrap) .mx-5 {
  margin-right: 4.5rem !important;
  margin-left: 4.5rem !important;
}
:global(.bootstrap) .mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}
:global(.bootstrap) .my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
:global(.bootstrap) .my-1 {
  margin-top: 0.375rem !important;
  margin-bottom: 0.375rem !important;
}
:global(.bootstrap) .my-2 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}
:global(.bootstrap) .my-3 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
:global(.bootstrap) .my-4 {
  margin-top: 2.25rem !important;
  margin-bottom: 2.25rem !important;
}
:global(.bootstrap) .my-5 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}
:global(.bootstrap) .my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
:global(.bootstrap) .mt-0 {
  margin-top: 0 !important;
}
:global(.bootstrap) .mt-1 {
  margin-top: 0.375rem !important;
}
:global(.bootstrap) .mt-2 {
  margin-top: 0.75rem !important;
}
:global(.bootstrap) .mt-3 {
  margin-top: 1.5rem !important;
}
:global(.bootstrap) .mt-4 {
  margin-top: 2.25rem !important;
}
:global(.bootstrap) .mt-5 {
  margin-top: 4.5rem !important;
}
:global(.bootstrap) .mt-auto {
  margin-top: auto !important;
}
:global(.bootstrap) .me-0 {
  margin-right: 0 !important;
}
:global(.bootstrap) .me-1 {
  margin-right: 0.375rem !important;
}
:global(.bootstrap) .me-2 {
  margin-right: 0.75rem !important;
}
:global(.bootstrap) .me-3 {
  margin-right: 1.5rem !important;
}
:global(.bootstrap) .me-4 {
  margin-right: 2.25rem !important;
}
:global(.bootstrap) .me-5 {
  margin-right: 4.5rem !important;
}
:global(.bootstrap) .me-auto {
  margin-right: auto !important;
}
:global(.bootstrap) .mb-0 {
  margin-bottom: 0 !important;
}
:global(.bootstrap) .mb-1 {
  margin-bottom: 0.375rem !important;
}
:global(.bootstrap) .mb-2 {
  margin-bottom: 0.75rem !important;
}
:global(.bootstrap) .mb-3 {
  margin-bottom: 1.5rem !important;
}
:global(.bootstrap) .mb-4 {
  margin-bottom: 2.25rem !important;
}
:global(.bootstrap) .mb-5 {
  margin-bottom: 4.5rem !important;
}
:global(.bootstrap) .mb-auto {
  margin-bottom: auto !important;
}
:global(.bootstrap) .ms-0 {
  margin-left: 0 !important;
}
:global(.bootstrap) .ms-1 {
  margin-left: 0.375rem !important;
}
:global(.bootstrap) .ms-2 {
  margin-left: 0.75rem !important;
}
:global(.bootstrap) .ms-3 {
  margin-left: 1.5rem !important;
}
:global(.bootstrap) .ms-4 {
  margin-left: 2.25rem !important;
}
:global(.bootstrap) .ms-5 {
  margin-left: 4.5rem !important;
}
:global(.bootstrap) .ms-auto {
  margin-left: auto !important;
}
:global(.bootstrap) .p-0 {
  padding: 0 !important;
}
:global(.bootstrap) .p-1 {
  padding: 0.375rem !important;
}
:global(.bootstrap) .p-2 {
  padding: 0.75rem !important;
}
:global(.bootstrap) .p-3 {
  padding: 1.5rem !important;
}
:global(.bootstrap) .p-4 {
  padding: 2.25rem !important;
}
:global(.bootstrap) .p-5 {
  padding: 4.5rem !important;
}
:global(.bootstrap) .px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
:global(.bootstrap) .px-1 {
  padding-right: 0.375rem !important;
  padding-left: 0.375rem !important;
}
:global(.bootstrap) .px-2 {
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
}
:global(.bootstrap) .px-3 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}
:global(.bootstrap) .px-4 {
  padding-right: 2.25rem !important;
  padding-left: 2.25rem !important;
}
:global(.bootstrap) .px-5 {
  padding-right: 4.5rem !important;
  padding-left: 4.5rem !important;
}
:global(.bootstrap) .py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
:global(.bootstrap) .py-1 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
:global(.bootstrap) .py-2 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
:global(.bootstrap) .py-3 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
:global(.bootstrap) .py-4 {
  padding-top: 2.25rem !important;
  padding-bottom: 2.25rem !important;
}
:global(.bootstrap) .py-5 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}
:global(.bootstrap) .pt-0 {
  padding-top: 0 !important;
}
:global(.bootstrap) .pt-1 {
  padding-top: 0.375rem !important;
}
:global(.bootstrap) .pt-2 {
  padding-top: 0.75rem !important;
}
:global(.bootstrap) .pt-3 {
  padding-top: 1.5rem !important;
}
:global(.bootstrap) .pt-4 {
  padding-top: 2.25rem !important;
}
:global(.bootstrap) .pt-5 {
  padding-top: 4.5rem !important;
}
:global(.bootstrap) .pe-0 {
  padding-right: 0 !important;
}
:global(.bootstrap) .pe-1 {
  padding-right: 0.375rem !important;
}
:global(.bootstrap) .pe-2 {
  padding-right: 0.75rem !important;
}
:global(.bootstrap) .pe-3 {
  padding-right: 1.5rem !important;
}
:global(.bootstrap) .pe-4 {
  padding-right: 2.25rem !important;
}
:global(.bootstrap) .pe-5 {
  padding-right: 4.5rem !important;
}
:global(.bootstrap) .pb-0 {
  padding-bottom: 0 !important;
}
:global(.bootstrap) .pb-1 {
  padding-bottom: 0.375rem !important;
}
:global(.bootstrap) .pb-2 {
  padding-bottom: 0.75rem !important;
}
:global(.bootstrap) .pb-3 {
  padding-bottom: 1.5rem !important;
}
:global(.bootstrap) .pb-4 {
  padding-bottom: 2.25rem !important;
}
:global(.bootstrap) .pb-5 {
  padding-bottom: 4.5rem !important;
}
:global(.bootstrap) .ps-0 {
  padding-left: 0 !important;
}
:global(.bootstrap) .ps-1 {
  padding-left: 0.375rem !important;
}
:global(.bootstrap) .ps-2 {
  padding-left: 0.75rem !important;
}
:global(.bootstrap) .ps-3 {
  padding-left: 1.5rem !important;
}
:global(.bootstrap) .ps-4 {
  padding-left: 2.25rem !important;
}
:global(.bootstrap) .ps-5 {
  padding-left: 4.5rem !important;
}
:global(.bootstrap) .gap-0 {
  gap: 0 !important;
}
:global(.bootstrap) .gap-1 {
  gap: 0.375rem !important;
}
:global(.bootstrap) .gap-2 {
  gap: 0.75rem !important;
}
:global(.bootstrap) .gap-3 {
  gap: 1.5rem !important;
}
:global(.bootstrap) .gap-4 {
  gap: 2.25rem !important;
}
:global(.bootstrap) .gap-5 {
  gap: 4.5rem !important;
}
:global(.bootstrap) .row-gap-0 {
  row-gap: 0 !important;
}
:global(.bootstrap) .row-gap-1 {
  row-gap: 0.375rem !important;
}
:global(.bootstrap) .row-gap-2 {
  row-gap: 0.75rem !important;
}
:global(.bootstrap) .row-gap-3 {
  row-gap: 1.5rem !important;
}
:global(.bootstrap) .row-gap-4 {
  row-gap: 2.25rem !important;
}
:global(.bootstrap) .row-gap-5 {
  row-gap: 4.5rem !important;
}
:global(.bootstrap) .column-gap-0 {
  column-gap: 0 !important;
}
:global(.bootstrap) .column-gap-1 {
  column-gap: 0.375rem !important;
}
:global(.bootstrap) .column-gap-2 {
  column-gap: 0.75rem !important;
}
:global(.bootstrap) .column-gap-3 {
  column-gap: 1.5rem !important;
}
:global(.bootstrap) .column-gap-4 {
  column-gap: 2.25rem !important;
}
:global(.bootstrap) .column-gap-5 {
  column-gap: 4.5rem !important;
}
:global(.bootstrap) .font-monospace {
  font-family: var(--bs-font-monospace) !important;
}
:global(.bootstrap) .fs-1 {
  font-size: 2.5rem !important;
}
:global(.bootstrap) .fs-2 {
  font-size: 2rem !important;
}
:global(.bootstrap) .fs-3 {
  font-size: 1.75rem !important;
}
:global(.bootstrap) .fs-4 {
  font-size: 1.5rem !important;
}
:global(.bootstrap) .fs-5 {
  font-size: 1.25rem !important;
}
:global(.bootstrap) .fs-6 {
  font-size: 1rem !important;
}
:global(.bootstrap) .fs-7 {
  font-size: 0.7875rem !important;
}
:global(.bootstrap) .fst-italic {
  font-style: italic !important;
}
:global(.bootstrap) .fst-normal {
  font-style: normal !important;
}
:global(.bootstrap) .fw-lighter {
  font-weight: lighter !important;
}
:global(.bootstrap) .fw-light {
  font-weight: 300 !important;
}
:global(.bootstrap) .fw-normal {
  font-weight: 400 !important;
}
:global(.bootstrap) .fw-medium {
  font-weight: 500 !important;
}
:global(.bootstrap) .fw-semibold {
  font-weight: 600 !important;
}
:global(.bootstrap) .fw-bold {
  font-weight: 700 !important;
}
:global(.bootstrap) .fw-bolder {
  font-weight: bolder !important;
}
:global(.bootstrap) .lh-1 {
  line-height: 1 !important;
}
:global(.bootstrap) .lh-sm {
  line-height: 1.5 !important;
}
:global(.bootstrap) .lh-base {
  line-height: 1.5 !important;
}
:global(.bootstrap) .lh-lg {
  line-height: 2 !important;
}
:global(.bootstrap) .text-start {
  text-align: left !important;
}
:global(.bootstrap) .text-end {
  text-align: right !important;
}
:global(.bootstrap) .text-center {
  text-align: center !important;
}
:global(.bootstrap) .text-decoration-none {
  text-decoration: none !important;
}
:global(.bootstrap) .text-decoration-underline {
  text-decoration: underline !important;
}
:global(.bootstrap) .text-decoration-line-through {
  text-decoration: line-through !important;
}
:global(.bootstrap) .text-lowercase {
  text-transform: lowercase !important;
}
:global(.bootstrap) .text-uppercase {
  text-transform: uppercase !important;
}
:global(.bootstrap) .text-capitalize {
  text-transform: capitalize !important;
}
:global(.bootstrap) .text-wrap {
  white-space: normal !important;
}
:global(.bootstrap) .text-nowrap {
  white-space: nowrap !important;
}
:global(.bootstrap) .text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}
:global(.bootstrap) .text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-medium {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-medium-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-pro {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-pro-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-con {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-con-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}
:global(.bootstrap) .text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}
:global(.bootstrap) .text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(8, 9, 13, 0.5) !important;
}
:global(.bootstrap) .text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}
:global(.bootstrap) .text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}
:global(.bootstrap) .text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}
:global(.bootstrap) .text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}
:global(.bootstrap) .text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}
:global(.bootstrap) .text-opacity-25 {
  --bs-text-opacity: 0.25;
}
:global(.bootstrap) .text-opacity-50 {
  --bs-text-opacity: 0.5;
}
:global(.bootstrap) .text-opacity-75 {
  --bs-text-opacity: 0.75;
}
:global(.bootstrap) .text-opacity-100 {
  --bs-text-opacity: 1;
}
:global(.bootstrap) .text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}
:global(.bootstrap) .text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}
:global(.bootstrap) .text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}
:global(.bootstrap) .text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}
:global(.bootstrap) .text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}
:global(.bootstrap) .text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}
:global(.bootstrap) .text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}
:global(.bootstrap) .text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}
:global(.bootstrap) .link-opacity-10 {
  --bs-link-opacity: 0.1;
}
:global(.bootstrap) .link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}
:global(.bootstrap) .link-opacity-25 {
  --bs-link-opacity: 0.25;
}
:global(.bootstrap) .link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}
:global(.bootstrap) .link-opacity-50 {
  --bs-link-opacity: 0.5;
}
:global(.bootstrap) .link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}
:global(.bootstrap) .link-opacity-75 {
  --bs-link-opacity: 0.75;
}
:global(.bootstrap) .link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}
:global(.bootstrap) .link-opacity-100 {
  --bs-link-opacity: 1;
}
:global(.bootstrap) .link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}
:global(.bootstrap) .link-offset-1 {
  text-underline-offset: 0.125em !important;
}
:global(.bootstrap) .link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}
:global(.bootstrap) .link-offset-2 {
  text-underline-offset: 0.25em !important;
}
:global(.bootstrap) .link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}
:global(.bootstrap) .link-offset-3 {
  text-underline-offset: 0.375em !important;
}
:global(.bootstrap) .link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}
:global(.bootstrap) .link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}
:global(.bootstrap) .link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}
:global(.bootstrap) .link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}
:global(.bootstrap) .link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}
:global(.bootstrap) .link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}
:global(.bootstrap) .link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}
:global(.bootstrap) .link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}
:global(.bootstrap) .link-underline-medium {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-medium-rgb), var(--bs-link-underline-opacity)) !important;
}
:global(.bootstrap) .link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}
:global(.bootstrap) .link-underline-pro {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-pro-rgb), var(--bs-link-underline-opacity)) !important;
}
:global(.bootstrap) .link-underline-con {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-con-rgb), var(--bs-link-underline-opacity)) !important;
}
:global(.bootstrap) .link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
:global(.bootstrap) .link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}
:global(.bootstrap) .link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}
:global(.bootstrap) .link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}
:global(.bootstrap) .link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}
:global(.bootstrap) .link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}
:global(.bootstrap) .link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}
:global(.bootstrap) .link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}
:global(.bootstrap) .link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}
:global(.bootstrap) .link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}
:global(.bootstrap) .link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}
:global(.bootstrap) .link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}
:global(.bootstrap) .link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}
:global(.bootstrap) .bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-medium {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-medium-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-pro {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-pro-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-con {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-con-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}
:global(.bootstrap) .bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}
:global(.bootstrap) .bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}
:global(.bootstrap) .bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}
:global(.bootstrap) .bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}
:global(.bootstrap) .bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}
:global(.bootstrap) .bg-opacity-100 {
  --bs-bg-opacity: 1;
}
:global(.bootstrap) .bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}
:global(.bootstrap) .bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}
:global(.bootstrap) .bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}
:global(.bootstrap) .bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}
:global(.bootstrap) .bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}
:global(.bootstrap) .bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}
:global(.bootstrap) .bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}
:global(.bootstrap) .bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}
:global(.bootstrap) .bg-gradient {
  background-image: var(--bs-gradient) !important;
}
:global(.bootstrap) .user-select-all {
  user-select: all !important;
}
:global(.bootstrap) .user-select-auto {
  user-select: auto !important;
}
:global(.bootstrap) .user-select-none {
  user-select: none !important;
}
:global(.bootstrap) .pe-none {
  pointer-events: none !important;
}
:global(.bootstrap) .pe-auto {
  pointer-events: auto !important;
}
:global(.bootstrap) .rounded {
  border-radius: var(--bs-border-radius) !important;
}
:global(.bootstrap) .rounded-0 {
  border-radius: 0 !important;
}
:global(.bootstrap) .rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}
:global(.bootstrap) .rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}
:global(.bootstrap) .rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}
:global(.bootstrap) .rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}
:global(.bootstrap) .rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}
:global(.bootstrap) .rounded-circle {
  border-radius: 50% !important;
}
:global(.bootstrap) .rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}
:global(.bootstrap) .rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}
:global(.bootstrap) .rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
:global(.bootstrap) .rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}
:global(.bootstrap) .rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}
:global(.bootstrap) .rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}
:global(.bootstrap) .rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}
:global(.bootstrap) .rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}
:global(.bootstrap) .rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}
:global(.bootstrap) .rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}
:global(.bootstrap) .rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}
:global(.bootstrap) .rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
:global(.bootstrap) .rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}
:global(.bootstrap) .rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}
:global(.bootstrap) .rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}
:global(.bootstrap) .rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}
:global(.bootstrap) .rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}
:global(.bootstrap) .rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}
:global(.bootstrap) .rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}
:global(.bootstrap) .rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}
:global(.bootstrap) .rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
:global(.bootstrap) .rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}
:global(.bootstrap) .rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}
:global(.bootstrap) .rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}
:global(.bootstrap) .rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}
:global(.bootstrap) .rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}
:global(.bootstrap) .rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}
:global(.bootstrap) .rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}
:global(.bootstrap) .rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}
:global(.bootstrap) .rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
:global(.bootstrap) .rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}
:global(.bootstrap) .rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}
:global(.bootstrap) .rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}
:global(.bootstrap) .rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}
:global(.bootstrap) .rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}
:global(.bootstrap) .rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}
:global(.bootstrap) .rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}
:global(.bootstrap) .visible {
  visibility: visible !important;
}
:global(.bootstrap) .invisible {
  visibility: hidden !important;
}
:global(.bootstrap) .z-n1 {
  z-index: -1 !important;
}
:global(.bootstrap) .z-0 {
  z-index: 0 !important;
}
:global(.bootstrap) .z-1 {
  z-index: 1 !important;
}
:global(.bootstrap) .z-2 {
  z-index: 2 !important;
}
:global(.bootstrap) .z-3 {
  z-index: 3 !important;
}
@media (min-width: 576px) {
  :global(.bootstrap) .float-sm-start {
    float: left !important;
  }
  :global(.bootstrap) .float-sm-end {
    float: right !important;
  }
  :global(.bootstrap) .float-sm-none {
    float: none !important;
  }
  :global(.bootstrap) .object-fit-sm-contain {
    object-fit: contain !important;
  }
  :global(.bootstrap) .object-fit-sm-cover {
    object-fit: cover !important;
  }
  :global(.bootstrap) .object-fit-sm-fill {
    object-fit: fill !important;
  }
  :global(.bootstrap) .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  :global(.bootstrap) .object-fit-sm-none {
    object-fit: none !important;
  }
  :global(.bootstrap) .d-sm-inline {
    display: inline !important;
  }
  :global(.bootstrap) .d-sm-inline-block {
    display: inline-block !important;
  }
  :global(.bootstrap) .d-sm-block {
    display: block !important;
  }
  :global(.bootstrap) .d-sm-grid {
    display: grid !important;
  }
  :global(.bootstrap) .d-sm-inline-grid {
    display: inline-grid !important;
  }
  :global(.bootstrap) .d-sm-table {
    display: table !important;
  }
  :global(.bootstrap) .d-sm-table-row {
    display: table-row !important;
  }
  :global(.bootstrap) .d-sm-table-cell {
    display: table-cell !important;
  }
  :global(.bootstrap) .d-sm-flex {
    display: flex !important;
  }
  :global(.bootstrap) .d-sm-inline-flex {
    display: inline-flex !important;
  }
  :global(.bootstrap) .d-sm-none {
    display: none !important;
  }
  :global(.bootstrap) .top-sm-0 {
    top: 0 !important;
  }
  :global(.bootstrap) .top-sm-5 {
    top: 5% !important;
  }
  :global(.bootstrap) .top-sm-10 {
    top: 10% !important;
  }
  :global(.bootstrap) .top-sm-25 {
    top: 25% !important;
  }
  :global(.bootstrap) .top-sm-50 {
    top: 50% !important;
  }
  :global(.bootstrap) .top-sm-75 {
    top: 75% !important;
  }
  :global(.bootstrap) .top-sm-100 {
    top: 100% !important;
  }
  :global(.bootstrap) .bottom-sm-0 {
    bottom: 0 !important;
  }
  :global(.bootstrap) .bottom-sm-5 {
    bottom: 5% !important;
  }
  :global(.bootstrap) .bottom-sm-10 {
    bottom: 10% !important;
  }
  :global(.bootstrap) .bottom-sm-25 {
    bottom: 25% !important;
  }
  :global(.bootstrap) .bottom-sm-50 {
    bottom: 50% !important;
  }
  :global(.bootstrap) .bottom-sm-75 {
    bottom: 75% !important;
  }
  :global(.bootstrap) .bottom-sm-100 {
    bottom: 100% !important;
  }
  :global(.bootstrap) .start-sm-0 {
    left: 0 !important;
  }
  :global(.bootstrap) .start-sm-5 {
    left: 5% !important;
  }
  :global(.bootstrap) .start-sm-10 {
    left: 10% !important;
  }
  :global(.bootstrap) .start-sm-25 {
    left: 25% !important;
  }
  :global(.bootstrap) .start-sm-50 {
    left: 50% !important;
  }
  :global(.bootstrap) .start-sm-75 {
    left: 75% !important;
  }
  :global(.bootstrap) .start-sm-100 {
    left: 100% !important;
  }
  :global(.bootstrap) .end-sm-0 {
    right: 0 !important;
  }
  :global(.bootstrap) .end-sm-5 {
    right: 5% !important;
  }
  :global(.bootstrap) .end-sm-10 {
    right: 10% !important;
  }
  :global(.bootstrap) .end-sm-25 {
    right: 25% !important;
  }
  :global(.bootstrap) .end-sm-50 {
    right: 50% !important;
  }
  :global(.bootstrap) .end-sm-75 {
    right: 75% !important;
  }
  :global(.bootstrap) .end-sm-100 {
    right: 100% !important;
  }
  :global(.bootstrap) .border-sm {
    border: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-sm-0 {
    border: 0 !important;
  }
  :global(.bootstrap) .border-top-sm {
    border-top: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-top-sm-0 {
    border-top: 0 !important;
  }
  :global(.bootstrap) .border-end-sm {
    border-right: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-end-sm-0 {
    border-right: 0 !important;
  }
  :global(.bootstrap) .border-bottom-sm {
    border-bottom: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-bottom-sm-0 {
    border-bottom: 0 !important;
  }
  :global(.bootstrap) .border-start-sm {
    border-left: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-start-sm-0 {
    border-left: 0 !important;
  }
  :global(.bootstrap) .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  :global(.bootstrap) .flex-sm-row {
    flex-direction: row !important;
  }
  :global(.bootstrap) .flex-sm-column {
    flex-direction: column !important;
  }
  :global(.bootstrap) .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  :global(.bootstrap) .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  :global(.bootstrap) .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  :global(.bootstrap) .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  :global(.bootstrap) .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  :global(.bootstrap) .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  :global(.bootstrap) .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  :global(.bootstrap) .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  :global(.bootstrap) .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :global(.bootstrap) .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  :global(.bootstrap) .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  :global(.bootstrap) .justify-content-sm-center {
    justify-content: center !important;
  }
  :global(.bootstrap) .justify-content-sm-between {
    justify-content: space-between !important;
  }
  :global(.bootstrap) .justify-content-sm-around {
    justify-content: space-around !important;
  }
  :global(.bootstrap) .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  :global(.bootstrap) .align-items-sm-start {
    align-items: flex-start !important;
  }
  :global(.bootstrap) .align-items-sm-end {
    align-items: flex-end !important;
  }
  :global(.bootstrap) .align-items-sm-center {
    align-items: center !important;
  }
  :global(.bootstrap) .align-items-sm-baseline {
    align-items: baseline !important;
  }
  :global(.bootstrap) .align-items-sm-stretch {
    align-items: stretch !important;
  }
  :global(.bootstrap) .align-content-sm-start {
    align-content: flex-start !important;
  }
  :global(.bootstrap) .align-content-sm-end {
    align-content: flex-end !important;
  }
  :global(.bootstrap) .align-content-sm-center {
    align-content: center !important;
  }
  :global(.bootstrap) .align-content-sm-between {
    align-content: space-between !important;
  }
  :global(.bootstrap) .align-content-sm-around {
    align-content: space-around !important;
  }
  :global(.bootstrap) .align-content-sm-stretch {
    align-content: stretch !important;
  }
  :global(.bootstrap) .align-self-sm-auto {
    align-self: auto !important;
  }
  :global(.bootstrap) .align-self-sm-start {
    align-self: flex-start !important;
  }
  :global(.bootstrap) .align-self-sm-end {
    align-self: flex-end !important;
  }
  :global(.bootstrap) .align-self-sm-center {
    align-self: center !important;
  }
  :global(.bootstrap) .align-self-sm-baseline {
    align-self: baseline !important;
  }
  :global(.bootstrap) .align-self-sm-stretch {
    align-self: stretch !important;
  }
  :global(.bootstrap) .order-sm-first {
    order: -1 !important;
  }
  :global(.bootstrap) .order-sm-0 {
    order: 0 !important;
  }
  :global(.bootstrap) .order-sm-1 {
    order: 1 !important;
  }
  :global(.bootstrap) .order-sm-2 {
    order: 2 !important;
  }
  :global(.bootstrap) .order-sm-3 {
    order: 3 !important;
  }
  :global(.bootstrap) .order-sm-4 {
    order: 4 !important;
  }
  :global(.bootstrap) .order-sm-5 {
    order: 5 !important;
  }
  :global(.bootstrap) .order-sm-last {
    order: 6 !important;
  }
  :global(.bootstrap) .m-sm-0 {
    margin: 0 !important;
  }
  :global(.bootstrap) .m-sm-1 {
    margin: 0.375rem !important;
  }
  :global(.bootstrap) .m-sm-2 {
    margin: 0.75rem !important;
  }
  :global(.bootstrap) .m-sm-3 {
    margin: 1.5rem !important;
  }
  :global(.bootstrap) .m-sm-4 {
    margin: 2.25rem !important;
  }
  :global(.bootstrap) .m-sm-5 {
    margin: 4.5rem !important;
  }
  :global(.bootstrap) .m-sm-auto {
    margin: auto !important;
  }
  :global(.bootstrap) .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  :global(.bootstrap) .mx-sm-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  :global(.bootstrap) .mx-sm-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  :global(.bootstrap) .mx-sm-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  :global(.bootstrap) .mx-sm-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  :global(.bootstrap) .mx-sm-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  :global(.bootstrap) .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  :global(.bootstrap) .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  :global(.bootstrap) .my-sm-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .my-sm-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .my-sm-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .my-sm-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .my-sm-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  :global(.bootstrap) .mt-sm-0 {
    margin-top: 0 !important;
  }
  :global(.bootstrap) .mt-sm-1 {
    margin-top: 0.375rem !important;
  }
  :global(.bootstrap) .mt-sm-2 {
    margin-top: 0.75rem !important;
  }
  :global(.bootstrap) .mt-sm-3 {
    margin-top: 1.5rem !important;
  }
  :global(.bootstrap) .mt-sm-4 {
    margin-top: 2.25rem !important;
  }
  :global(.bootstrap) .mt-sm-5 {
    margin-top: 4.5rem !important;
  }
  :global(.bootstrap) .mt-sm-auto {
    margin-top: auto !important;
  }
  :global(.bootstrap) .me-sm-0 {
    margin-right: 0 !important;
  }
  :global(.bootstrap) .me-sm-1 {
    margin-right: 0.375rem !important;
  }
  :global(.bootstrap) .me-sm-2 {
    margin-right: 0.75rem !important;
  }
  :global(.bootstrap) .me-sm-3 {
    margin-right: 1.5rem !important;
  }
  :global(.bootstrap) .me-sm-4 {
    margin-right: 2.25rem !important;
  }
  :global(.bootstrap) .me-sm-5 {
    margin-right: 4.5rem !important;
  }
  :global(.bootstrap) .me-sm-auto {
    margin-right: auto !important;
  }
  :global(.bootstrap) .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  :global(.bootstrap) .mb-sm-1 {
    margin-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .mb-sm-2 {
    margin-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .mb-sm-3 {
    margin-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .mb-sm-4 {
    margin-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .mb-sm-5 {
    margin-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .mb-sm-auto {
    margin-bottom: auto !important;
  }
  :global(.bootstrap) .ms-sm-0 {
    margin-left: 0 !important;
  }
  :global(.bootstrap) .ms-sm-1 {
    margin-left: 0.375rem !important;
  }
  :global(.bootstrap) .ms-sm-2 {
    margin-left: 0.75rem !important;
  }
  :global(.bootstrap) .ms-sm-3 {
    margin-left: 1.5rem !important;
  }
  :global(.bootstrap) .ms-sm-4 {
    margin-left: 2.25rem !important;
  }
  :global(.bootstrap) .ms-sm-5 {
    margin-left: 4.5rem !important;
  }
  :global(.bootstrap) .ms-sm-auto {
    margin-left: auto !important;
  }
  :global(.bootstrap) .p-sm-0 {
    padding: 0 !important;
  }
  :global(.bootstrap) .p-sm-1 {
    padding: 0.375rem !important;
  }
  :global(.bootstrap) .p-sm-2 {
    padding: 0.75rem !important;
  }
  :global(.bootstrap) .p-sm-3 {
    padding: 1.5rem !important;
  }
  :global(.bootstrap) .p-sm-4 {
    padding: 2.25rem !important;
  }
  :global(.bootstrap) .p-sm-5 {
    padding: 4.5rem !important;
  }
  :global(.bootstrap) .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  :global(.bootstrap) .px-sm-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  :global(.bootstrap) .px-sm-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  :global(.bootstrap) .px-sm-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  :global(.bootstrap) .px-sm-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  :global(.bootstrap) .px-sm-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  :global(.bootstrap) .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  :global(.bootstrap) .py-sm-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .py-sm-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .py-sm-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .py-sm-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .py-sm-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .pt-sm-0 {
    padding-top: 0 !important;
  }
  :global(.bootstrap) .pt-sm-1 {
    padding-top: 0.375rem !important;
  }
  :global(.bootstrap) .pt-sm-2 {
    padding-top: 0.75rem !important;
  }
  :global(.bootstrap) .pt-sm-3 {
    padding-top: 1.5rem !important;
  }
  :global(.bootstrap) .pt-sm-4 {
    padding-top: 2.25rem !important;
  }
  :global(.bootstrap) .pt-sm-5 {
    padding-top: 4.5rem !important;
  }
  :global(.bootstrap) .pe-sm-0 {
    padding-right: 0 !important;
  }
  :global(.bootstrap) .pe-sm-1 {
    padding-right: 0.375rem !important;
  }
  :global(.bootstrap) .pe-sm-2 {
    padding-right: 0.75rem !important;
  }
  :global(.bootstrap) .pe-sm-3 {
    padding-right: 1.5rem !important;
  }
  :global(.bootstrap) .pe-sm-4 {
    padding-right: 2.25rem !important;
  }
  :global(.bootstrap) .pe-sm-5 {
    padding-right: 4.5rem !important;
  }
  :global(.bootstrap) .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  :global(.bootstrap) .pb-sm-1 {
    padding-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .pb-sm-2 {
    padding-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .pb-sm-3 {
    padding-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .pb-sm-4 {
    padding-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .pb-sm-5 {
    padding-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .ps-sm-0 {
    padding-left: 0 !important;
  }
  :global(.bootstrap) .ps-sm-1 {
    padding-left: 0.375rem !important;
  }
  :global(.bootstrap) .ps-sm-2 {
    padding-left: 0.75rem !important;
  }
  :global(.bootstrap) .ps-sm-3 {
    padding-left: 1.5rem !important;
  }
  :global(.bootstrap) .ps-sm-4 {
    padding-left: 2.25rem !important;
  }
  :global(.bootstrap) .ps-sm-5 {
    padding-left: 4.5rem !important;
  }
  :global(.bootstrap) .gap-sm-0 {
    gap: 0 !important;
  }
  :global(.bootstrap) .gap-sm-1 {
    gap: 0.375rem !important;
  }
  :global(.bootstrap) .gap-sm-2 {
    gap: 0.75rem !important;
  }
  :global(.bootstrap) .gap-sm-3 {
    gap: 1.5rem !important;
  }
  :global(.bootstrap) .gap-sm-4 {
    gap: 2.25rem !important;
  }
  :global(.bootstrap) .gap-sm-5 {
    gap: 4.5rem !important;
  }
  :global(.bootstrap) .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  :global(.bootstrap) .row-gap-sm-1 {
    row-gap: 0.375rem !important;
  }
  :global(.bootstrap) .row-gap-sm-2 {
    row-gap: 0.75rem !important;
  }
  :global(.bootstrap) .row-gap-sm-3 {
    row-gap: 1.5rem !important;
  }
  :global(.bootstrap) .row-gap-sm-4 {
    row-gap: 2.25rem !important;
  }
  :global(.bootstrap) .row-gap-sm-5 {
    row-gap: 4.5rem !important;
  }
  :global(.bootstrap) .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  :global(.bootstrap) .column-gap-sm-1 {
    column-gap: 0.375rem !important;
  }
  :global(.bootstrap) .column-gap-sm-2 {
    column-gap: 0.75rem !important;
  }
  :global(.bootstrap) .column-gap-sm-3 {
    column-gap: 1.5rem !important;
  }
  :global(.bootstrap) .column-gap-sm-4 {
    column-gap: 2.25rem !important;
  }
  :global(.bootstrap) .column-gap-sm-5 {
    column-gap: 4.5rem !important;
  }
  :global(.bootstrap) .fs-sm-1 {
    font-size: 2.5rem !important;
  }
  :global(.bootstrap) .fs-sm-2 {
    font-size: 2rem !important;
  }
  :global(.bootstrap) .fs-sm-3 {
    font-size: 1.75rem !important;
  }
  :global(.bootstrap) .fs-sm-4 {
    font-size: 1.5rem !important;
  }
  :global(.bootstrap) .fs-sm-5 {
    font-size: 1.25rem !important;
  }
  :global(.bootstrap) .fs-sm-6 {
    font-size: 1rem !important;
  }
  :global(.bootstrap) .fs-sm-7 {
    font-size: 0.7875rem !important;
  }
  :global(.bootstrap) .text-sm-start {
    text-align: left !important;
  }
  :global(.bootstrap) .text-sm-end {
    text-align: right !important;
  }
  :global(.bootstrap) .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .float-md-start {
    float: left !important;
  }
  :global(.bootstrap) .float-md-end {
    float: right !important;
  }
  :global(.bootstrap) .float-md-none {
    float: none !important;
  }
  :global(.bootstrap) .object-fit-md-contain {
    object-fit: contain !important;
  }
  :global(.bootstrap) .object-fit-md-cover {
    object-fit: cover !important;
  }
  :global(.bootstrap) .object-fit-md-fill {
    object-fit: fill !important;
  }
  :global(.bootstrap) .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  :global(.bootstrap) .object-fit-md-none {
    object-fit: none !important;
  }
  :global(.bootstrap) .d-md-inline {
    display: inline !important;
  }
  :global(.bootstrap) .d-md-inline-block {
    display: inline-block !important;
  }
  :global(.bootstrap) .d-md-block {
    display: block !important;
  }
  :global(.bootstrap) .d-md-grid {
    display: grid !important;
  }
  :global(.bootstrap) .d-md-inline-grid {
    display: inline-grid !important;
  }
  :global(.bootstrap) .d-md-table {
    display: table !important;
  }
  :global(.bootstrap) .d-md-table-row {
    display: table-row !important;
  }
  :global(.bootstrap) .d-md-table-cell {
    display: table-cell !important;
  }
  :global(.bootstrap) .d-md-flex {
    display: flex !important;
  }
  :global(.bootstrap) .d-md-inline-flex {
    display: inline-flex !important;
  }
  :global(.bootstrap) .d-md-none {
    display: none !important;
  }
  :global(.bootstrap) .top-md-0 {
    top: 0 !important;
  }
  :global(.bootstrap) .top-md-5 {
    top: 5% !important;
  }
  :global(.bootstrap) .top-md-10 {
    top: 10% !important;
  }
  :global(.bootstrap) .top-md-25 {
    top: 25% !important;
  }
  :global(.bootstrap) .top-md-50 {
    top: 50% !important;
  }
  :global(.bootstrap) .top-md-75 {
    top: 75% !important;
  }
  :global(.bootstrap) .top-md-100 {
    top: 100% !important;
  }
  :global(.bootstrap) .bottom-md-0 {
    bottom: 0 !important;
  }
  :global(.bootstrap) .bottom-md-5 {
    bottom: 5% !important;
  }
  :global(.bootstrap) .bottom-md-10 {
    bottom: 10% !important;
  }
  :global(.bootstrap) .bottom-md-25 {
    bottom: 25% !important;
  }
  :global(.bootstrap) .bottom-md-50 {
    bottom: 50% !important;
  }
  :global(.bootstrap) .bottom-md-75 {
    bottom: 75% !important;
  }
  :global(.bootstrap) .bottom-md-100 {
    bottom: 100% !important;
  }
  :global(.bootstrap) .start-md-0 {
    left: 0 !important;
  }
  :global(.bootstrap) .start-md-5 {
    left: 5% !important;
  }
  :global(.bootstrap) .start-md-10 {
    left: 10% !important;
  }
  :global(.bootstrap) .start-md-25 {
    left: 25% !important;
  }
  :global(.bootstrap) .start-md-50 {
    left: 50% !important;
  }
  :global(.bootstrap) .start-md-75 {
    left: 75% !important;
  }
  :global(.bootstrap) .start-md-100 {
    left: 100% !important;
  }
  :global(.bootstrap) .end-md-0 {
    right: 0 !important;
  }
  :global(.bootstrap) .end-md-5 {
    right: 5% !important;
  }
  :global(.bootstrap) .end-md-10 {
    right: 10% !important;
  }
  :global(.bootstrap) .end-md-25 {
    right: 25% !important;
  }
  :global(.bootstrap) .end-md-50 {
    right: 50% !important;
  }
  :global(.bootstrap) .end-md-75 {
    right: 75% !important;
  }
  :global(.bootstrap) .end-md-100 {
    right: 100% !important;
  }
  :global(.bootstrap) .border-md {
    border: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-md-0 {
    border: 0 !important;
  }
  :global(.bootstrap) .border-top-md {
    border-top: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-top-md-0 {
    border-top: 0 !important;
  }
  :global(.bootstrap) .border-end-md {
    border-right: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-end-md-0 {
    border-right: 0 !important;
  }
  :global(.bootstrap) .border-bottom-md {
    border-bottom: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-bottom-md-0 {
    border-bottom: 0 !important;
  }
  :global(.bootstrap) .border-start-md {
    border-left: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-start-md-0 {
    border-left: 0 !important;
  }
  :global(.bootstrap) .flex-md-fill {
    flex: 1 1 auto !important;
  }
  :global(.bootstrap) .flex-md-row {
    flex-direction: row !important;
  }
  :global(.bootstrap) .flex-md-column {
    flex-direction: column !important;
  }
  :global(.bootstrap) .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  :global(.bootstrap) .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  :global(.bootstrap) .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  :global(.bootstrap) .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  :global(.bootstrap) .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  :global(.bootstrap) .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  :global(.bootstrap) .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  :global(.bootstrap) .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  :global(.bootstrap) .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :global(.bootstrap) .justify-content-md-start {
    justify-content: flex-start !important;
  }
  :global(.bootstrap) .justify-content-md-end {
    justify-content: flex-end !important;
  }
  :global(.bootstrap) .justify-content-md-center {
    justify-content: center !important;
  }
  :global(.bootstrap) .justify-content-md-between {
    justify-content: space-between !important;
  }
  :global(.bootstrap) .justify-content-md-around {
    justify-content: space-around !important;
  }
  :global(.bootstrap) .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  :global(.bootstrap) .align-items-md-start {
    align-items: flex-start !important;
  }
  :global(.bootstrap) .align-items-md-end {
    align-items: flex-end !important;
  }
  :global(.bootstrap) .align-items-md-center {
    align-items: center !important;
  }
  :global(.bootstrap) .align-items-md-baseline {
    align-items: baseline !important;
  }
  :global(.bootstrap) .align-items-md-stretch {
    align-items: stretch !important;
  }
  :global(.bootstrap) .align-content-md-start {
    align-content: flex-start !important;
  }
  :global(.bootstrap) .align-content-md-end {
    align-content: flex-end !important;
  }
  :global(.bootstrap) .align-content-md-center {
    align-content: center !important;
  }
  :global(.bootstrap) .align-content-md-between {
    align-content: space-between !important;
  }
  :global(.bootstrap) .align-content-md-around {
    align-content: space-around !important;
  }
  :global(.bootstrap) .align-content-md-stretch {
    align-content: stretch !important;
  }
  :global(.bootstrap) .align-self-md-auto {
    align-self: auto !important;
  }
  :global(.bootstrap) .align-self-md-start {
    align-self: flex-start !important;
  }
  :global(.bootstrap) .align-self-md-end {
    align-self: flex-end !important;
  }
  :global(.bootstrap) .align-self-md-center {
    align-self: center !important;
  }
  :global(.bootstrap) .align-self-md-baseline {
    align-self: baseline !important;
  }
  :global(.bootstrap) .align-self-md-stretch {
    align-self: stretch !important;
  }
  :global(.bootstrap) .order-md-first {
    order: -1 !important;
  }
  :global(.bootstrap) .order-md-0 {
    order: 0 !important;
  }
  :global(.bootstrap) .order-md-1 {
    order: 1 !important;
  }
  :global(.bootstrap) .order-md-2 {
    order: 2 !important;
  }
  :global(.bootstrap) .order-md-3 {
    order: 3 !important;
  }
  :global(.bootstrap) .order-md-4 {
    order: 4 !important;
  }
  :global(.bootstrap) .order-md-5 {
    order: 5 !important;
  }
  :global(.bootstrap) .order-md-last {
    order: 6 !important;
  }
  :global(.bootstrap) .m-md-0 {
    margin: 0 !important;
  }
  :global(.bootstrap) .m-md-1 {
    margin: 0.375rem !important;
  }
  :global(.bootstrap) .m-md-2 {
    margin: 0.75rem !important;
  }
  :global(.bootstrap) .m-md-3 {
    margin: 1.5rem !important;
  }
  :global(.bootstrap) .m-md-4 {
    margin: 2.25rem !important;
  }
  :global(.bootstrap) .m-md-5 {
    margin: 4.5rem !important;
  }
  :global(.bootstrap) .m-md-auto {
    margin: auto !important;
  }
  :global(.bootstrap) .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  :global(.bootstrap) .mx-md-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  :global(.bootstrap) .mx-md-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  :global(.bootstrap) .mx-md-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  :global(.bootstrap) .mx-md-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  :global(.bootstrap) .mx-md-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  :global(.bootstrap) .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  :global(.bootstrap) .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  :global(.bootstrap) .my-md-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .my-md-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .my-md-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .my-md-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .my-md-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  :global(.bootstrap) .mt-md-0 {
    margin-top: 0 !important;
  }
  :global(.bootstrap) .mt-md-1 {
    margin-top: 0.375rem !important;
  }
  :global(.bootstrap) .mt-md-2 {
    margin-top: 0.75rem !important;
  }
  :global(.bootstrap) .mt-md-3 {
    margin-top: 1.5rem !important;
  }
  :global(.bootstrap) .mt-md-4 {
    margin-top: 2.25rem !important;
  }
  :global(.bootstrap) .mt-md-5 {
    margin-top: 4.5rem !important;
  }
  :global(.bootstrap) .mt-md-auto {
    margin-top: auto !important;
  }
  :global(.bootstrap) .me-md-0 {
    margin-right: 0 !important;
  }
  :global(.bootstrap) .me-md-1 {
    margin-right: 0.375rem !important;
  }
  :global(.bootstrap) .me-md-2 {
    margin-right: 0.75rem !important;
  }
  :global(.bootstrap) .me-md-3 {
    margin-right: 1.5rem !important;
  }
  :global(.bootstrap) .me-md-4 {
    margin-right: 2.25rem !important;
  }
  :global(.bootstrap) .me-md-5 {
    margin-right: 4.5rem !important;
  }
  :global(.bootstrap) .me-md-auto {
    margin-right: auto !important;
  }
  :global(.bootstrap) .mb-md-0 {
    margin-bottom: 0 !important;
  }
  :global(.bootstrap) .mb-md-1 {
    margin-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .mb-md-2 {
    margin-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .mb-md-3 {
    margin-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .mb-md-4 {
    margin-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .mb-md-5 {
    margin-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .mb-md-auto {
    margin-bottom: auto !important;
  }
  :global(.bootstrap) .ms-md-0 {
    margin-left: 0 !important;
  }
  :global(.bootstrap) .ms-md-1 {
    margin-left: 0.375rem !important;
  }
  :global(.bootstrap) .ms-md-2 {
    margin-left: 0.75rem !important;
  }
  :global(.bootstrap) .ms-md-3 {
    margin-left: 1.5rem !important;
  }
  :global(.bootstrap) .ms-md-4 {
    margin-left: 2.25rem !important;
  }
  :global(.bootstrap) .ms-md-5 {
    margin-left: 4.5rem !important;
  }
  :global(.bootstrap) .ms-md-auto {
    margin-left: auto !important;
  }
  :global(.bootstrap) .p-md-0 {
    padding: 0 !important;
  }
  :global(.bootstrap) .p-md-1 {
    padding: 0.375rem !important;
  }
  :global(.bootstrap) .p-md-2 {
    padding: 0.75rem !important;
  }
  :global(.bootstrap) .p-md-3 {
    padding: 1.5rem !important;
  }
  :global(.bootstrap) .p-md-4 {
    padding: 2.25rem !important;
  }
  :global(.bootstrap) .p-md-5 {
    padding: 4.5rem !important;
  }
  :global(.bootstrap) .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  :global(.bootstrap) .px-md-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  :global(.bootstrap) .px-md-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  :global(.bootstrap) .px-md-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  :global(.bootstrap) .px-md-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  :global(.bootstrap) .px-md-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  :global(.bootstrap) .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  :global(.bootstrap) .py-md-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .py-md-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .py-md-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .py-md-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .py-md-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .pt-md-0 {
    padding-top: 0 !important;
  }
  :global(.bootstrap) .pt-md-1 {
    padding-top: 0.375rem !important;
  }
  :global(.bootstrap) .pt-md-2 {
    padding-top: 0.75rem !important;
  }
  :global(.bootstrap) .pt-md-3 {
    padding-top: 1.5rem !important;
  }
  :global(.bootstrap) .pt-md-4 {
    padding-top: 2.25rem !important;
  }
  :global(.bootstrap) .pt-md-5 {
    padding-top: 4.5rem !important;
  }
  :global(.bootstrap) .pe-md-0 {
    padding-right: 0 !important;
  }
  :global(.bootstrap) .pe-md-1 {
    padding-right: 0.375rem !important;
  }
  :global(.bootstrap) .pe-md-2 {
    padding-right: 0.75rem !important;
  }
  :global(.bootstrap) .pe-md-3 {
    padding-right: 1.5rem !important;
  }
  :global(.bootstrap) .pe-md-4 {
    padding-right: 2.25rem !important;
  }
  :global(.bootstrap) .pe-md-5 {
    padding-right: 4.5rem !important;
  }
  :global(.bootstrap) .pb-md-0 {
    padding-bottom: 0 !important;
  }
  :global(.bootstrap) .pb-md-1 {
    padding-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .pb-md-2 {
    padding-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .pb-md-3 {
    padding-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .pb-md-4 {
    padding-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .pb-md-5 {
    padding-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .ps-md-0 {
    padding-left: 0 !important;
  }
  :global(.bootstrap) .ps-md-1 {
    padding-left: 0.375rem !important;
  }
  :global(.bootstrap) .ps-md-2 {
    padding-left: 0.75rem !important;
  }
  :global(.bootstrap) .ps-md-3 {
    padding-left: 1.5rem !important;
  }
  :global(.bootstrap) .ps-md-4 {
    padding-left: 2.25rem !important;
  }
  :global(.bootstrap) .ps-md-5 {
    padding-left: 4.5rem !important;
  }
  :global(.bootstrap) .gap-md-0 {
    gap: 0 !important;
  }
  :global(.bootstrap) .gap-md-1 {
    gap: 0.375rem !important;
  }
  :global(.bootstrap) .gap-md-2 {
    gap: 0.75rem !important;
  }
  :global(.bootstrap) .gap-md-3 {
    gap: 1.5rem !important;
  }
  :global(.bootstrap) .gap-md-4 {
    gap: 2.25rem !important;
  }
  :global(.bootstrap) .gap-md-5 {
    gap: 4.5rem !important;
  }
  :global(.bootstrap) .row-gap-md-0 {
    row-gap: 0 !important;
  }
  :global(.bootstrap) .row-gap-md-1 {
    row-gap: 0.375rem !important;
  }
  :global(.bootstrap) .row-gap-md-2 {
    row-gap: 0.75rem !important;
  }
  :global(.bootstrap) .row-gap-md-3 {
    row-gap: 1.5rem !important;
  }
  :global(.bootstrap) .row-gap-md-4 {
    row-gap: 2.25rem !important;
  }
  :global(.bootstrap) .row-gap-md-5 {
    row-gap: 4.5rem !important;
  }
  :global(.bootstrap) .column-gap-md-0 {
    column-gap: 0 !important;
  }
  :global(.bootstrap) .column-gap-md-1 {
    column-gap: 0.375rem !important;
  }
  :global(.bootstrap) .column-gap-md-2 {
    column-gap: 0.75rem !important;
  }
  :global(.bootstrap) .column-gap-md-3 {
    column-gap: 1.5rem !important;
  }
  :global(.bootstrap) .column-gap-md-4 {
    column-gap: 2.25rem !important;
  }
  :global(.bootstrap) .column-gap-md-5 {
    column-gap: 4.5rem !important;
  }
  :global(.bootstrap) .fs-md-1 {
    font-size: 2.5rem !important;
  }
  :global(.bootstrap) .fs-md-2 {
    font-size: 2rem !important;
  }
  :global(.bootstrap) .fs-md-3 {
    font-size: 1.75rem !important;
  }
  :global(.bootstrap) .fs-md-4 {
    font-size: 1.5rem !important;
  }
  :global(.bootstrap) .fs-md-5 {
    font-size: 1.25rem !important;
  }
  :global(.bootstrap) .fs-md-6 {
    font-size: 1rem !important;
  }
  :global(.bootstrap) .fs-md-7 {
    font-size: 0.7875rem !important;
  }
  :global(.bootstrap) .text-md-start {
    text-align: left !important;
  }
  :global(.bootstrap) .text-md-end {
    text-align: right !important;
  }
  :global(.bootstrap) .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  :global(.bootstrap) .float-lg-start {
    float: left !important;
  }
  :global(.bootstrap) .float-lg-end {
    float: right !important;
  }
  :global(.bootstrap) .float-lg-none {
    float: none !important;
  }
  :global(.bootstrap) .object-fit-lg-contain {
    object-fit: contain !important;
  }
  :global(.bootstrap) .object-fit-lg-cover {
    object-fit: cover !important;
  }
  :global(.bootstrap) .object-fit-lg-fill {
    object-fit: fill !important;
  }
  :global(.bootstrap) .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  :global(.bootstrap) .object-fit-lg-none {
    object-fit: none !important;
  }
  :global(.bootstrap) .d-lg-inline {
    display: inline !important;
  }
  :global(.bootstrap) .d-lg-inline-block {
    display: inline-block !important;
  }
  :global(.bootstrap) .d-lg-block {
    display: block !important;
  }
  :global(.bootstrap) .d-lg-grid {
    display: grid !important;
  }
  :global(.bootstrap) .d-lg-inline-grid {
    display: inline-grid !important;
  }
  :global(.bootstrap) .d-lg-table {
    display: table !important;
  }
  :global(.bootstrap) .d-lg-table-row {
    display: table-row !important;
  }
  :global(.bootstrap) .d-lg-table-cell {
    display: table-cell !important;
  }
  :global(.bootstrap) .d-lg-flex {
    display: flex !important;
  }
  :global(.bootstrap) .d-lg-inline-flex {
    display: inline-flex !important;
  }
  :global(.bootstrap) .d-lg-none {
    display: none !important;
  }
  :global(.bootstrap) .top-lg-0 {
    top: 0 !important;
  }
  :global(.bootstrap) .top-lg-5 {
    top: 5% !important;
  }
  :global(.bootstrap) .top-lg-10 {
    top: 10% !important;
  }
  :global(.bootstrap) .top-lg-25 {
    top: 25% !important;
  }
  :global(.bootstrap) .top-lg-50 {
    top: 50% !important;
  }
  :global(.bootstrap) .top-lg-75 {
    top: 75% !important;
  }
  :global(.bootstrap) .top-lg-100 {
    top: 100% !important;
  }
  :global(.bootstrap) .bottom-lg-0 {
    bottom: 0 !important;
  }
  :global(.bootstrap) .bottom-lg-5 {
    bottom: 5% !important;
  }
  :global(.bootstrap) .bottom-lg-10 {
    bottom: 10% !important;
  }
  :global(.bootstrap) .bottom-lg-25 {
    bottom: 25% !important;
  }
  :global(.bootstrap) .bottom-lg-50 {
    bottom: 50% !important;
  }
  :global(.bootstrap) .bottom-lg-75 {
    bottom: 75% !important;
  }
  :global(.bootstrap) .bottom-lg-100 {
    bottom: 100% !important;
  }
  :global(.bootstrap) .start-lg-0 {
    left: 0 !important;
  }
  :global(.bootstrap) .start-lg-5 {
    left: 5% !important;
  }
  :global(.bootstrap) .start-lg-10 {
    left: 10% !important;
  }
  :global(.bootstrap) .start-lg-25 {
    left: 25% !important;
  }
  :global(.bootstrap) .start-lg-50 {
    left: 50% !important;
  }
  :global(.bootstrap) .start-lg-75 {
    left: 75% !important;
  }
  :global(.bootstrap) .start-lg-100 {
    left: 100% !important;
  }
  :global(.bootstrap) .end-lg-0 {
    right: 0 !important;
  }
  :global(.bootstrap) .end-lg-5 {
    right: 5% !important;
  }
  :global(.bootstrap) .end-lg-10 {
    right: 10% !important;
  }
  :global(.bootstrap) .end-lg-25 {
    right: 25% !important;
  }
  :global(.bootstrap) .end-lg-50 {
    right: 50% !important;
  }
  :global(.bootstrap) .end-lg-75 {
    right: 75% !important;
  }
  :global(.bootstrap) .end-lg-100 {
    right: 100% !important;
  }
  :global(.bootstrap) .border-lg {
    border: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-lg-0 {
    border: 0 !important;
  }
  :global(.bootstrap) .border-top-lg {
    border-top: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-top-lg-0 {
    border-top: 0 !important;
  }
  :global(.bootstrap) .border-end-lg {
    border-right: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-end-lg-0 {
    border-right: 0 !important;
  }
  :global(.bootstrap) .border-bottom-lg {
    border-bottom: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-bottom-lg-0 {
    border-bottom: 0 !important;
  }
  :global(.bootstrap) .border-start-lg {
    border-left: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-start-lg-0 {
    border-left: 0 !important;
  }
  :global(.bootstrap) .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  :global(.bootstrap) .flex-lg-row {
    flex-direction: row !important;
  }
  :global(.bootstrap) .flex-lg-column {
    flex-direction: column !important;
  }
  :global(.bootstrap) .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  :global(.bootstrap) .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  :global(.bootstrap) .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  :global(.bootstrap) .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  :global(.bootstrap) .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  :global(.bootstrap) .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  :global(.bootstrap) .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  :global(.bootstrap) .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  :global(.bootstrap) .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :global(.bootstrap) .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  :global(.bootstrap) .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  :global(.bootstrap) .justify-content-lg-center {
    justify-content: center !important;
  }
  :global(.bootstrap) .justify-content-lg-between {
    justify-content: space-between !important;
  }
  :global(.bootstrap) .justify-content-lg-around {
    justify-content: space-around !important;
  }
  :global(.bootstrap) .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  :global(.bootstrap) .align-items-lg-start {
    align-items: flex-start !important;
  }
  :global(.bootstrap) .align-items-lg-end {
    align-items: flex-end !important;
  }
  :global(.bootstrap) .align-items-lg-center {
    align-items: center !important;
  }
  :global(.bootstrap) .align-items-lg-baseline {
    align-items: baseline !important;
  }
  :global(.bootstrap) .align-items-lg-stretch {
    align-items: stretch !important;
  }
  :global(.bootstrap) .align-content-lg-start {
    align-content: flex-start !important;
  }
  :global(.bootstrap) .align-content-lg-end {
    align-content: flex-end !important;
  }
  :global(.bootstrap) .align-content-lg-center {
    align-content: center !important;
  }
  :global(.bootstrap) .align-content-lg-between {
    align-content: space-between !important;
  }
  :global(.bootstrap) .align-content-lg-around {
    align-content: space-around !important;
  }
  :global(.bootstrap) .align-content-lg-stretch {
    align-content: stretch !important;
  }
  :global(.bootstrap) .align-self-lg-auto {
    align-self: auto !important;
  }
  :global(.bootstrap) .align-self-lg-start {
    align-self: flex-start !important;
  }
  :global(.bootstrap) .align-self-lg-end {
    align-self: flex-end !important;
  }
  :global(.bootstrap) .align-self-lg-center {
    align-self: center !important;
  }
  :global(.bootstrap) .align-self-lg-baseline {
    align-self: baseline !important;
  }
  :global(.bootstrap) .align-self-lg-stretch {
    align-self: stretch !important;
  }
  :global(.bootstrap) .order-lg-first {
    order: -1 !important;
  }
  :global(.bootstrap) .order-lg-0 {
    order: 0 !important;
  }
  :global(.bootstrap) .order-lg-1 {
    order: 1 !important;
  }
  :global(.bootstrap) .order-lg-2 {
    order: 2 !important;
  }
  :global(.bootstrap) .order-lg-3 {
    order: 3 !important;
  }
  :global(.bootstrap) .order-lg-4 {
    order: 4 !important;
  }
  :global(.bootstrap) .order-lg-5 {
    order: 5 !important;
  }
  :global(.bootstrap) .order-lg-last {
    order: 6 !important;
  }
  :global(.bootstrap) .m-lg-0 {
    margin: 0 !important;
  }
  :global(.bootstrap) .m-lg-1 {
    margin: 0.375rem !important;
  }
  :global(.bootstrap) .m-lg-2 {
    margin: 0.75rem !important;
  }
  :global(.bootstrap) .m-lg-3 {
    margin: 1.5rem !important;
  }
  :global(.bootstrap) .m-lg-4 {
    margin: 2.25rem !important;
  }
  :global(.bootstrap) .m-lg-5 {
    margin: 4.5rem !important;
  }
  :global(.bootstrap) .m-lg-auto {
    margin: auto !important;
  }
  :global(.bootstrap) .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  :global(.bootstrap) .mx-lg-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  :global(.bootstrap) .mx-lg-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  :global(.bootstrap) .mx-lg-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  :global(.bootstrap) .mx-lg-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  :global(.bootstrap) .mx-lg-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  :global(.bootstrap) .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  :global(.bootstrap) .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  :global(.bootstrap) .my-lg-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .my-lg-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .my-lg-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .my-lg-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .my-lg-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  :global(.bootstrap) .mt-lg-0 {
    margin-top: 0 !important;
  }
  :global(.bootstrap) .mt-lg-1 {
    margin-top: 0.375rem !important;
  }
  :global(.bootstrap) .mt-lg-2 {
    margin-top: 0.75rem !important;
  }
  :global(.bootstrap) .mt-lg-3 {
    margin-top: 1.5rem !important;
  }
  :global(.bootstrap) .mt-lg-4 {
    margin-top: 2.25rem !important;
  }
  :global(.bootstrap) .mt-lg-5 {
    margin-top: 4.5rem !important;
  }
  :global(.bootstrap) .mt-lg-auto {
    margin-top: auto !important;
  }
  :global(.bootstrap) .me-lg-0 {
    margin-right: 0 !important;
  }
  :global(.bootstrap) .me-lg-1 {
    margin-right: 0.375rem !important;
  }
  :global(.bootstrap) .me-lg-2 {
    margin-right: 0.75rem !important;
  }
  :global(.bootstrap) .me-lg-3 {
    margin-right: 1.5rem !important;
  }
  :global(.bootstrap) .me-lg-4 {
    margin-right: 2.25rem !important;
  }
  :global(.bootstrap) .me-lg-5 {
    margin-right: 4.5rem !important;
  }
  :global(.bootstrap) .me-lg-auto {
    margin-right: auto !important;
  }
  :global(.bootstrap) .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  :global(.bootstrap) .mb-lg-1 {
    margin-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .mb-lg-2 {
    margin-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .mb-lg-3 {
    margin-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .mb-lg-4 {
    margin-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .mb-lg-5 {
    margin-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .mb-lg-auto {
    margin-bottom: auto !important;
  }
  :global(.bootstrap) .ms-lg-0 {
    margin-left: 0 !important;
  }
  :global(.bootstrap) .ms-lg-1 {
    margin-left: 0.375rem !important;
  }
  :global(.bootstrap) .ms-lg-2 {
    margin-left: 0.75rem !important;
  }
  :global(.bootstrap) .ms-lg-3 {
    margin-left: 1.5rem !important;
  }
  :global(.bootstrap) .ms-lg-4 {
    margin-left: 2.25rem !important;
  }
  :global(.bootstrap) .ms-lg-5 {
    margin-left: 4.5rem !important;
  }
  :global(.bootstrap) .ms-lg-auto {
    margin-left: auto !important;
  }
  :global(.bootstrap) .p-lg-0 {
    padding: 0 !important;
  }
  :global(.bootstrap) .p-lg-1 {
    padding: 0.375rem !important;
  }
  :global(.bootstrap) .p-lg-2 {
    padding: 0.75rem !important;
  }
  :global(.bootstrap) .p-lg-3 {
    padding: 1.5rem !important;
  }
  :global(.bootstrap) .p-lg-4 {
    padding: 2.25rem !important;
  }
  :global(.bootstrap) .p-lg-5 {
    padding: 4.5rem !important;
  }
  :global(.bootstrap) .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  :global(.bootstrap) .px-lg-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  :global(.bootstrap) .px-lg-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  :global(.bootstrap) .px-lg-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  :global(.bootstrap) .px-lg-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  :global(.bootstrap) .px-lg-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  :global(.bootstrap) .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  :global(.bootstrap) .py-lg-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .py-lg-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .py-lg-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .py-lg-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .py-lg-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .pt-lg-0 {
    padding-top: 0 !important;
  }
  :global(.bootstrap) .pt-lg-1 {
    padding-top: 0.375rem !important;
  }
  :global(.bootstrap) .pt-lg-2 {
    padding-top: 0.75rem !important;
  }
  :global(.bootstrap) .pt-lg-3 {
    padding-top: 1.5rem !important;
  }
  :global(.bootstrap) .pt-lg-4 {
    padding-top: 2.25rem !important;
  }
  :global(.bootstrap) .pt-lg-5 {
    padding-top: 4.5rem !important;
  }
  :global(.bootstrap) .pe-lg-0 {
    padding-right: 0 !important;
  }
  :global(.bootstrap) .pe-lg-1 {
    padding-right: 0.375rem !important;
  }
  :global(.bootstrap) .pe-lg-2 {
    padding-right: 0.75rem !important;
  }
  :global(.bootstrap) .pe-lg-3 {
    padding-right: 1.5rem !important;
  }
  :global(.bootstrap) .pe-lg-4 {
    padding-right: 2.25rem !important;
  }
  :global(.bootstrap) .pe-lg-5 {
    padding-right: 4.5rem !important;
  }
  :global(.bootstrap) .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  :global(.bootstrap) .pb-lg-1 {
    padding-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .pb-lg-2 {
    padding-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .pb-lg-3 {
    padding-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .pb-lg-4 {
    padding-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .pb-lg-5 {
    padding-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .ps-lg-0 {
    padding-left: 0 !important;
  }
  :global(.bootstrap) .ps-lg-1 {
    padding-left: 0.375rem !important;
  }
  :global(.bootstrap) .ps-lg-2 {
    padding-left: 0.75rem !important;
  }
  :global(.bootstrap) .ps-lg-3 {
    padding-left: 1.5rem !important;
  }
  :global(.bootstrap) .ps-lg-4 {
    padding-left: 2.25rem !important;
  }
  :global(.bootstrap) .ps-lg-5 {
    padding-left: 4.5rem !important;
  }
  :global(.bootstrap) .gap-lg-0 {
    gap: 0 !important;
  }
  :global(.bootstrap) .gap-lg-1 {
    gap: 0.375rem !important;
  }
  :global(.bootstrap) .gap-lg-2 {
    gap: 0.75rem !important;
  }
  :global(.bootstrap) .gap-lg-3 {
    gap: 1.5rem !important;
  }
  :global(.bootstrap) .gap-lg-4 {
    gap: 2.25rem !important;
  }
  :global(.bootstrap) .gap-lg-5 {
    gap: 4.5rem !important;
  }
  :global(.bootstrap) .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  :global(.bootstrap) .row-gap-lg-1 {
    row-gap: 0.375rem !important;
  }
  :global(.bootstrap) .row-gap-lg-2 {
    row-gap: 0.75rem !important;
  }
  :global(.bootstrap) .row-gap-lg-3 {
    row-gap: 1.5rem !important;
  }
  :global(.bootstrap) .row-gap-lg-4 {
    row-gap: 2.25rem !important;
  }
  :global(.bootstrap) .row-gap-lg-5 {
    row-gap: 4.5rem !important;
  }
  :global(.bootstrap) .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  :global(.bootstrap) .column-gap-lg-1 {
    column-gap: 0.375rem !important;
  }
  :global(.bootstrap) .column-gap-lg-2 {
    column-gap: 0.75rem !important;
  }
  :global(.bootstrap) .column-gap-lg-3 {
    column-gap: 1.5rem !important;
  }
  :global(.bootstrap) .column-gap-lg-4 {
    column-gap: 2.25rem !important;
  }
  :global(.bootstrap) .column-gap-lg-5 {
    column-gap: 4.5rem !important;
  }
  :global(.bootstrap) .fs-lg-1 {
    font-size: 2.5rem !important;
  }
  :global(.bootstrap) .fs-lg-2 {
    font-size: 2rem !important;
  }
  :global(.bootstrap) .fs-lg-3 {
    font-size: 1.75rem !important;
  }
  :global(.bootstrap) .fs-lg-4 {
    font-size: 1.5rem !important;
  }
  :global(.bootstrap) .fs-lg-5 {
    font-size: 1.25rem !important;
  }
  :global(.bootstrap) .fs-lg-6 {
    font-size: 1rem !important;
  }
  :global(.bootstrap) .fs-lg-7 {
    font-size: 0.7875rem !important;
  }
  :global(.bootstrap) .text-lg-start {
    text-align: left !important;
  }
  :global(.bootstrap) .text-lg-end {
    text-align: right !important;
  }
  :global(.bootstrap) .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1367px) {
  :global(.bootstrap) .float-xl-start {
    float: left !important;
  }
  :global(.bootstrap) .float-xl-end {
    float: right !important;
  }
  :global(.bootstrap) .float-xl-none {
    float: none !important;
  }
  :global(.bootstrap) .object-fit-xl-contain {
    object-fit: contain !important;
  }
  :global(.bootstrap) .object-fit-xl-cover {
    object-fit: cover !important;
  }
  :global(.bootstrap) .object-fit-xl-fill {
    object-fit: fill !important;
  }
  :global(.bootstrap) .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  :global(.bootstrap) .object-fit-xl-none {
    object-fit: none !important;
  }
  :global(.bootstrap) .d-xl-inline {
    display: inline !important;
  }
  :global(.bootstrap) .d-xl-inline-block {
    display: inline-block !important;
  }
  :global(.bootstrap) .d-xl-block {
    display: block !important;
  }
  :global(.bootstrap) .d-xl-grid {
    display: grid !important;
  }
  :global(.bootstrap) .d-xl-inline-grid {
    display: inline-grid !important;
  }
  :global(.bootstrap) .d-xl-table {
    display: table !important;
  }
  :global(.bootstrap) .d-xl-table-row {
    display: table-row !important;
  }
  :global(.bootstrap) .d-xl-table-cell {
    display: table-cell !important;
  }
  :global(.bootstrap) .d-xl-flex {
    display: flex !important;
  }
  :global(.bootstrap) .d-xl-inline-flex {
    display: inline-flex !important;
  }
  :global(.bootstrap) .d-xl-none {
    display: none !important;
  }
  :global(.bootstrap) .top-xl-0 {
    top: 0 !important;
  }
  :global(.bootstrap) .top-xl-5 {
    top: 5% !important;
  }
  :global(.bootstrap) .top-xl-10 {
    top: 10% !important;
  }
  :global(.bootstrap) .top-xl-25 {
    top: 25% !important;
  }
  :global(.bootstrap) .top-xl-50 {
    top: 50% !important;
  }
  :global(.bootstrap) .top-xl-75 {
    top: 75% !important;
  }
  :global(.bootstrap) .top-xl-100 {
    top: 100% !important;
  }
  :global(.bootstrap) .bottom-xl-0 {
    bottom: 0 !important;
  }
  :global(.bootstrap) .bottom-xl-5 {
    bottom: 5% !important;
  }
  :global(.bootstrap) .bottom-xl-10 {
    bottom: 10% !important;
  }
  :global(.bootstrap) .bottom-xl-25 {
    bottom: 25% !important;
  }
  :global(.bootstrap) .bottom-xl-50 {
    bottom: 50% !important;
  }
  :global(.bootstrap) .bottom-xl-75 {
    bottom: 75% !important;
  }
  :global(.bootstrap) .bottom-xl-100 {
    bottom: 100% !important;
  }
  :global(.bootstrap) .start-xl-0 {
    left: 0 !important;
  }
  :global(.bootstrap) .start-xl-5 {
    left: 5% !important;
  }
  :global(.bootstrap) .start-xl-10 {
    left: 10% !important;
  }
  :global(.bootstrap) .start-xl-25 {
    left: 25% !important;
  }
  :global(.bootstrap) .start-xl-50 {
    left: 50% !important;
  }
  :global(.bootstrap) .start-xl-75 {
    left: 75% !important;
  }
  :global(.bootstrap) .start-xl-100 {
    left: 100% !important;
  }
  :global(.bootstrap) .end-xl-0 {
    right: 0 !important;
  }
  :global(.bootstrap) .end-xl-5 {
    right: 5% !important;
  }
  :global(.bootstrap) .end-xl-10 {
    right: 10% !important;
  }
  :global(.bootstrap) .end-xl-25 {
    right: 25% !important;
  }
  :global(.bootstrap) .end-xl-50 {
    right: 50% !important;
  }
  :global(.bootstrap) .end-xl-75 {
    right: 75% !important;
  }
  :global(.bootstrap) .end-xl-100 {
    right: 100% !important;
  }
  :global(.bootstrap) .border-xl {
    border: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-xl-0 {
    border: 0 !important;
  }
  :global(.bootstrap) .border-top-xl {
    border-top: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-top-xl-0 {
    border-top: 0 !important;
  }
  :global(.bootstrap) .border-end-xl {
    border-right: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-end-xl-0 {
    border-right: 0 !important;
  }
  :global(.bootstrap) .border-bottom-xl {
    border-bottom: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-bottom-xl-0 {
    border-bottom: 0 !important;
  }
  :global(.bootstrap) .border-start-xl {
    border-left: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-start-xl-0 {
    border-left: 0 !important;
  }
  :global(.bootstrap) .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  :global(.bootstrap) .flex-xl-row {
    flex-direction: row !important;
  }
  :global(.bootstrap) .flex-xl-column {
    flex-direction: column !important;
  }
  :global(.bootstrap) .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  :global(.bootstrap) .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  :global(.bootstrap) .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  :global(.bootstrap) .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  :global(.bootstrap) .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  :global(.bootstrap) .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  :global(.bootstrap) .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  :global(.bootstrap) .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  :global(.bootstrap) .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :global(.bootstrap) .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  :global(.bootstrap) .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  :global(.bootstrap) .justify-content-xl-center {
    justify-content: center !important;
  }
  :global(.bootstrap) .justify-content-xl-between {
    justify-content: space-between !important;
  }
  :global(.bootstrap) .justify-content-xl-around {
    justify-content: space-around !important;
  }
  :global(.bootstrap) .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  :global(.bootstrap) .align-items-xl-start {
    align-items: flex-start !important;
  }
  :global(.bootstrap) .align-items-xl-end {
    align-items: flex-end !important;
  }
  :global(.bootstrap) .align-items-xl-center {
    align-items: center !important;
  }
  :global(.bootstrap) .align-items-xl-baseline {
    align-items: baseline !important;
  }
  :global(.bootstrap) .align-items-xl-stretch {
    align-items: stretch !important;
  }
  :global(.bootstrap) .align-content-xl-start {
    align-content: flex-start !important;
  }
  :global(.bootstrap) .align-content-xl-end {
    align-content: flex-end !important;
  }
  :global(.bootstrap) .align-content-xl-center {
    align-content: center !important;
  }
  :global(.bootstrap) .align-content-xl-between {
    align-content: space-between !important;
  }
  :global(.bootstrap) .align-content-xl-around {
    align-content: space-around !important;
  }
  :global(.bootstrap) .align-content-xl-stretch {
    align-content: stretch !important;
  }
  :global(.bootstrap) .align-self-xl-auto {
    align-self: auto !important;
  }
  :global(.bootstrap) .align-self-xl-start {
    align-self: flex-start !important;
  }
  :global(.bootstrap) .align-self-xl-end {
    align-self: flex-end !important;
  }
  :global(.bootstrap) .align-self-xl-center {
    align-self: center !important;
  }
  :global(.bootstrap) .align-self-xl-baseline {
    align-self: baseline !important;
  }
  :global(.bootstrap) .align-self-xl-stretch {
    align-self: stretch !important;
  }
  :global(.bootstrap) .order-xl-first {
    order: -1 !important;
  }
  :global(.bootstrap) .order-xl-0 {
    order: 0 !important;
  }
  :global(.bootstrap) .order-xl-1 {
    order: 1 !important;
  }
  :global(.bootstrap) .order-xl-2 {
    order: 2 !important;
  }
  :global(.bootstrap) .order-xl-3 {
    order: 3 !important;
  }
  :global(.bootstrap) .order-xl-4 {
    order: 4 !important;
  }
  :global(.bootstrap) .order-xl-5 {
    order: 5 !important;
  }
  :global(.bootstrap) .order-xl-last {
    order: 6 !important;
  }
  :global(.bootstrap) .m-xl-0 {
    margin: 0 !important;
  }
  :global(.bootstrap) .m-xl-1 {
    margin: 0.375rem !important;
  }
  :global(.bootstrap) .m-xl-2 {
    margin: 0.75rem !important;
  }
  :global(.bootstrap) .m-xl-3 {
    margin: 1.5rem !important;
  }
  :global(.bootstrap) .m-xl-4 {
    margin: 2.25rem !important;
  }
  :global(.bootstrap) .m-xl-5 {
    margin: 4.5rem !important;
  }
  :global(.bootstrap) .m-xl-auto {
    margin: auto !important;
  }
  :global(.bootstrap) .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  :global(.bootstrap) .mx-xl-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  :global(.bootstrap) .mx-xl-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  :global(.bootstrap) .mx-xl-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  :global(.bootstrap) .mx-xl-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  :global(.bootstrap) .mx-xl-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  :global(.bootstrap) .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  :global(.bootstrap) .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  :global(.bootstrap) .my-xl-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .my-xl-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .my-xl-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .my-xl-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .my-xl-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  :global(.bootstrap) .mt-xl-0 {
    margin-top: 0 !important;
  }
  :global(.bootstrap) .mt-xl-1 {
    margin-top: 0.375rem !important;
  }
  :global(.bootstrap) .mt-xl-2 {
    margin-top: 0.75rem !important;
  }
  :global(.bootstrap) .mt-xl-3 {
    margin-top: 1.5rem !important;
  }
  :global(.bootstrap) .mt-xl-4 {
    margin-top: 2.25rem !important;
  }
  :global(.bootstrap) .mt-xl-5 {
    margin-top: 4.5rem !important;
  }
  :global(.bootstrap) .mt-xl-auto {
    margin-top: auto !important;
  }
  :global(.bootstrap) .me-xl-0 {
    margin-right: 0 !important;
  }
  :global(.bootstrap) .me-xl-1 {
    margin-right: 0.375rem !important;
  }
  :global(.bootstrap) .me-xl-2 {
    margin-right: 0.75rem !important;
  }
  :global(.bootstrap) .me-xl-3 {
    margin-right: 1.5rem !important;
  }
  :global(.bootstrap) .me-xl-4 {
    margin-right: 2.25rem !important;
  }
  :global(.bootstrap) .me-xl-5 {
    margin-right: 4.5rem !important;
  }
  :global(.bootstrap) .me-xl-auto {
    margin-right: auto !important;
  }
  :global(.bootstrap) .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  :global(.bootstrap) .mb-xl-1 {
    margin-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .mb-xl-2 {
    margin-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .mb-xl-3 {
    margin-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .mb-xl-4 {
    margin-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .mb-xl-5 {
    margin-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .mb-xl-auto {
    margin-bottom: auto !important;
  }
  :global(.bootstrap) .ms-xl-0 {
    margin-left: 0 !important;
  }
  :global(.bootstrap) .ms-xl-1 {
    margin-left: 0.375rem !important;
  }
  :global(.bootstrap) .ms-xl-2 {
    margin-left: 0.75rem !important;
  }
  :global(.bootstrap) .ms-xl-3 {
    margin-left: 1.5rem !important;
  }
  :global(.bootstrap) .ms-xl-4 {
    margin-left: 2.25rem !important;
  }
  :global(.bootstrap) .ms-xl-5 {
    margin-left: 4.5rem !important;
  }
  :global(.bootstrap) .ms-xl-auto {
    margin-left: auto !important;
  }
  :global(.bootstrap) .p-xl-0 {
    padding: 0 !important;
  }
  :global(.bootstrap) .p-xl-1 {
    padding: 0.375rem !important;
  }
  :global(.bootstrap) .p-xl-2 {
    padding: 0.75rem !important;
  }
  :global(.bootstrap) .p-xl-3 {
    padding: 1.5rem !important;
  }
  :global(.bootstrap) .p-xl-4 {
    padding: 2.25rem !important;
  }
  :global(.bootstrap) .p-xl-5 {
    padding: 4.5rem !important;
  }
  :global(.bootstrap) .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  :global(.bootstrap) .px-xl-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  :global(.bootstrap) .px-xl-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  :global(.bootstrap) .px-xl-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  :global(.bootstrap) .px-xl-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  :global(.bootstrap) .px-xl-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  :global(.bootstrap) .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  :global(.bootstrap) .py-xl-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .py-xl-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .py-xl-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .py-xl-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .py-xl-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .pt-xl-0 {
    padding-top: 0 !important;
  }
  :global(.bootstrap) .pt-xl-1 {
    padding-top: 0.375rem !important;
  }
  :global(.bootstrap) .pt-xl-2 {
    padding-top: 0.75rem !important;
  }
  :global(.bootstrap) .pt-xl-3 {
    padding-top: 1.5rem !important;
  }
  :global(.bootstrap) .pt-xl-4 {
    padding-top: 2.25rem !important;
  }
  :global(.bootstrap) .pt-xl-5 {
    padding-top: 4.5rem !important;
  }
  :global(.bootstrap) .pe-xl-0 {
    padding-right: 0 !important;
  }
  :global(.bootstrap) .pe-xl-1 {
    padding-right: 0.375rem !important;
  }
  :global(.bootstrap) .pe-xl-2 {
    padding-right: 0.75rem !important;
  }
  :global(.bootstrap) .pe-xl-3 {
    padding-right: 1.5rem !important;
  }
  :global(.bootstrap) .pe-xl-4 {
    padding-right: 2.25rem !important;
  }
  :global(.bootstrap) .pe-xl-5 {
    padding-right: 4.5rem !important;
  }
  :global(.bootstrap) .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  :global(.bootstrap) .pb-xl-1 {
    padding-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .pb-xl-2 {
    padding-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .pb-xl-3 {
    padding-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .pb-xl-4 {
    padding-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .pb-xl-5 {
    padding-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .ps-xl-0 {
    padding-left: 0 !important;
  }
  :global(.bootstrap) .ps-xl-1 {
    padding-left: 0.375rem !important;
  }
  :global(.bootstrap) .ps-xl-2 {
    padding-left: 0.75rem !important;
  }
  :global(.bootstrap) .ps-xl-3 {
    padding-left: 1.5rem !important;
  }
  :global(.bootstrap) .ps-xl-4 {
    padding-left: 2.25rem !important;
  }
  :global(.bootstrap) .ps-xl-5 {
    padding-left: 4.5rem !important;
  }
  :global(.bootstrap) .gap-xl-0 {
    gap: 0 !important;
  }
  :global(.bootstrap) .gap-xl-1 {
    gap: 0.375rem !important;
  }
  :global(.bootstrap) .gap-xl-2 {
    gap: 0.75rem !important;
  }
  :global(.bootstrap) .gap-xl-3 {
    gap: 1.5rem !important;
  }
  :global(.bootstrap) .gap-xl-4 {
    gap: 2.25rem !important;
  }
  :global(.bootstrap) .gap-xl-5 {
    gap: 4.5rem !important;
  }
  :global(.bootstrap) .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  :global(.bootstrap) .row-gap-xl-1 {
    row-gap: 0.375rem !important;
  }
  :global(.bootstrap) .row-gap-xl-2 {
    row-gap: 0.75rem !important;
  }
  :global(.bootstrap) .row-gap-xl-3 {
    row-gap: 1.5rem !important;
  }
  :global(.bootstrap) .row-gap-xl-4 {
    row-gap: 2.25rem !important;
  }
  :global(.bootstrap) .row-gap-xl-5 {
    row-gap: 4.5rem !important;
  }
  :global(.bootstrap) .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  :global(.bootstrap) .column-gap-xl-1 {
    column-gap: 0.375rem !important;
  }
  :global(.bootstrap) .column-gap-xl-2 {
    column-gap: 0.75rem !important;
  }
  :global(.bootstrap) .column-gap-xl-3 {
    column-gap: 1.5rem !important;
  }
  :global(.bootstrap) .column-gap-xl-4 {
    column-gap: 2.25rem !important;
  }
  :global(.bootstrap) .column-gap-xl-5 {
    column-gap: 4.5rem !important;
  }
  :global(.bootstrap) .fs-xl-1 {
    font-size: 2.5rem !important;
  }
  :global(.bootstrap) .fs-xl-2 {
    font-size: 2rem !important;
  }
  :global(.bootstrap) .fs-xl-3 {
    font-size: 1.75rem !important;
  }
  :global(.bootstrap) .fs-xl-4 {
    font-size: 1.5rem !important;
  }
  :global(.bootstrap) .fs-xl-5 {
    font-size: 1.25rem !important;
  }
  :global(.bootstrap) .fs-xl-6 {
    font-size: 1rem !important;
  }
  :global(.bootstrap) .fs-xl-7 {
    font-size: 0.7875rem !important;
  }
  :global(.bootstrap) .text-xl-start {
    text-align: left !important;
  }
  :global(.bootstrap) .text-xl-end {
    text-align: right !important;
  }
  :global(.bootstrap) .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  :global(.bootstrap) .float-xxl-start {
    float: left !important;
  }
  :global(.bootstrap) .float-xxl-end {
    float: right !important;
  }
  :global(.bootstrap) .float-xxl-none {
    float: none !important;
  }
  :global(.bootstrap) .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  :global(.bootstrap) .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  :global(.bootstrap) .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  :global(.bootstrap) .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  :global(.bootstrap) .object-fit-xxl-none {
    object-fit: none !important;
  }
  :global(.bootstrap) .d-xxl-inline {
    display: inline !important;
  }
  :global(.bootstrap) .d-xxl-inline-block {
    display: inline-block !important;
  }
  :global(.bootstrap) .d-xxl-block {
    display: block !important;
  }
  :global(.bootstrap) .d-xxl-grid {
    display: grid !important;
  }
  :global(.bootstrap) .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  :global(.bootstrap) .d-xxl-table {
    display: table !important;
  }
  :global(.bootstrap) .d-xxl-table-row {
    display: table-row !important;
  }
  :global(.bootstrap) .d-xxl-table-cell {
    display: table-cell !important;
  }
  :global(.bootstrap) .d-xxl-flex {
    display: flex !important;
  }
  :global(.bootstrap) .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  :global(.bootstrap) .d-xxl-none {
    display: none !important;
  }
  :global(.bootstrap) .top-xxl-0 {
    top: 0 !important;
  }
  :global(.bootstrap) .top-xxl-5 {
    top: 5% !important;
  }
  :global(.bootstrap) .top-xxl-10 {
    top: 10% !important;
  }
  :global(.bootstrap) .top-xxl-25 {
    top: 25% !important;
  }
  :global(.bootstrap) .top-xxl-50 {
    top: 50% !important;
  }
  :global(.bootstrap) .top-xxl-75 {
    top: 75% !important;
  }
  :global(.bootstrap) .top-xxl-100 {
    top: 100% !important;
  }
  :global(.bootstrap) .bottom-xxl-0 {
    bottom: 0 !important;
  }
  :global(.bootstrap) .bottom-xxl-5 {
    bottom: 5% !important;
  }
  :global(.bootstrap) .bottom-xxl-10 {
    bottom: 10% !important;
  }
  :global(.bootstrap) .bottom-xxl-25 {
    bottom: 25% !important;
  }
  :global(.bootstrap) .bottom-xxl-50 {
    bottom: 50% !important;
  }
  :global(.bootstrap) .bottom-xxl-75 {
    bottom: 75% !important;
  }
  :global(.bootstrap) .bottom-xxl-100 {
    bottom: 100% !important;
  }
  :global(.bootstrap) .start-xxl-0 {
    left: 0 !important;
  }
  :global(.bootstrap) .start-xxl-5 {
    left: 5% !important;
  }
  :global(.bootstrap) .start-xxl-10 {
    left: 10% !important;
  }
  :global(.bootstrap) .start-xxl-25 {
    left: 25% !important;
  }
  :global(.bootstrap) .start-xxl-50 {
    left: 50% !important;
  }
  :global(.bootstrap) .start-xxl-75 {
    left: 75% !important;
  }
  :global(.bootstrap) .start-xxl-100 {
    left: 100% !important;
  }
  :global(.bootstrap) .end-xxl-0 {
    right: 0 !important;
  }
  :global(.bootstrap) .end-xxl-5 {
    right: 5% !important;
  }
  :global(.bootstrap) .end-xxl-10 {
    right: 10% !important;
  }
  :global(.bootstrap) .end-xxl-25 {
    right: 25% !important;
  }
  :global(.bootstrap) .end-xxl-50 {
    right: 50% !important;
  }
  :global(.bootstrap) .end-xxl-75 {
    right: 75% !important;
  }
  :global(.bootstrap) .end-xxl-100 {
    right: 100% !important;
  }
  :global(.bootstrap) .border-xxl {
    border: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-xxl-0 {
    border: 0 !important;
  }
  :global(.bootstrap) .border-top-xxl {
    border-top: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-top-xxl-0 {
    border-top: 0 !important;
  }
  :global(.bootstrap) .border-end-xxl {
    border-right: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-end-xxl-0 {
    border-right: 0 !important;
  }
  :global(.bootstrap) .border-bottom-xxl {
    border-bottom: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-bottom-xxl-0 {
    border-bottom: 0 !important;
  }
  :global(.bootstrap) .border-start-xxl {
    border-left: 1px solid #f3f3f3 !important;
  }
  :global(.bootstrap) .border-start-xxl-0 {
    border-left: 0 !important;
  }
  :global(.bootstrap) .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  :global(.bootstrap) .flex-xxl-row {
    flex-direction: row !important;
  }
  :global(.bootstrap) .flex-xxl-column {
    flex-direction: column !important;
  }
  :global(.bootstrap) .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  :global(.bootstrap) .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  :global(.bootstrap) .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  :global(.bootstrap) .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  :global(.bootstrap) .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  :global(.bootstrap) .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  :global(.bootstrap) .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  :global(.bootstrap) .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  :global(.bootstrap) .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :global(.bootstrap) .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  :global(.bootstrap) .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  :global(.bootstrap) .justify-content-xxl-center {
    justify-content: center !important;
  }
  :global(.bootstrap) .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  :global(.bootstrap) .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  :global(.bootstrap) .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  :global(.bootstrap) .align-items-xxl-start {
    align-items: flex-start !important;
  }
  :global(.bootstrap) .align-items-xxl-end {
    align-items: flex-end !important;
  }
  :global(.bootstrap) .align-items-xxl-center {
    align-items: center !important;
  }
  :global(.bootstrap) .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  :global(.bootstrap) .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  :global(.bootstrap) .align-content-xxl-start {
    align-content: flex-start !important;
  }
  :global(.bootstrap) .align-content-xxl-end {
    align-content: flex-end !important;
  }
  :global(.bootstrap) .align-content-xxl-center {
    align-content: center !important;
  }
  :global(.bootstrap) .align-content-xxl-between {
    align-content: space-between !important;
  }
  :global(.bootstrap) .align-content-xxl-around {
    align-content: space-around !important;
  }
  :global(.bootstrap) .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  :global(.bootstrap) .align-self-xxl-auto {
    align-self: auto !important;
  }
  :global(.bootstrap) .align-self-xxl-start {
    align-self: flex-start !important;
  }
  :global(.bootstrap) .align-self-xxl-end {
    align-self: flex-end !important;
  }
  :global(.bootstrap) .align-self-xxl-center {
    align-self: center !important;
  }
  :global(.bootstrap) .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  :global(.bootstrap) .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  :global(.bootstrap) .order-xxl-first {
    order: -1 !important;
  }
  :global(.bootstrap) .order-xxl-0 {
    order: 0 !important;
  }
  :global(.bootstrap) .order-xxl-1 {
    order: 1 !important;
  }
  :global(.bootstrap) .order-xxl-2 {
    order: 2 !important;
  }
  :global(.bootstrap) .order-xxl-3 {
    order: 3 !important;
  }
  :global(.bootstrap) .order-xxl-4 {
    order: 4 !important;
  }
  :global(.bootstrap) .order-xxl-5 {
    order: 5 !important;
  }
  :global(.bootstrap) .order-xxl-last {
    order: 6 !important;
  }
  :global(.bootstrap) .m-xxl-0 {
    margin: 0 !important;
  }
  :global(.bootstrap) .m-xxl-1 {
    margin: 0.375rem !important;
  }
  :global(.bootstrap) .m-xxl-2 {
    margin: 0.75rem !important;
  }
  :global(.bootstrap) .m-xxl-3 {
    margin: 1.5rem !important;
  }
  :global(.bootstrap) .m-xxl-4 {
    margin: 2.25rem !important;
  }
  :global(.bootstrap) .m-xxl-5 {
    margin: 4.5rem !important;
  }
  :global(.bootstrap) .m-xxl-auto {
    margin: auto !important;
  }
  :global(.bootstrap) .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  :global(.bootstrap) .mx-xxl-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  :global(.bootstrap) .mx-xxl-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  :global(.bootstrap) .mx-xxl-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  :global(.bootstrap) .mx-xxl-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  :global(.bootstrap) .mx-xxl-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  :global(.bootstrap) .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  :global(.bootstrap) .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  :global(.bootstrap) .my-xxl-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .my-xxl-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .my-xxl-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .my-xxl-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .my-xxl-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  :global(.bootstrap) .mt-xxl-0 {
    margin-top: 0 !important;
  }
  :global(.bootstrap) .mt-xxl-1 {
    margin-top: 0.375rem !important;
  }
  :global(.bootstrap) .mt-xxl-2 {
    margin-top: 0.75rem !important;
  }
  :global(.bootstrap) .mt-xxl-3 {
    margin-top: 1.5rem !important;
  }
  :global(.bootstrap) .mt-xxl-4 {
    margin-top: 2.25rem !important;
  }
  :global(.bootstrap) .mt-xxl-5 {
    margin-top: 4.5rem !important;
  }
  :global(.bootstrap) .mt-xxl-auto {
    margin-top: auto !important;
  }
  :global(.bootstrap) .me-xxl-0 {
    margin-right: 0 !important;
  }
  :global(.bootstrap) .me-xxl-1 {
    margin-right: 0.375rem !important;
  }
  :global(.bootstrap) .me-xxl-2 {
    margin-right: 0.75rem !important;
  }
  :global(.bootstrap) .me-xxl-3 {
    margin-right: 1.5rem !important;
  }
  :global(.bootstrap) .me-xxl-4 {
    margin-right: 2.25rem !important;
  }
  :global(.bootstrap) .me-xxl-5 {
    margin-right: 4.5rem !important;
  }
  :global(.bootstrap) .me-xxl-auto {
    margin-right: auto !important;
  }
  :global(.bootstrap) .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  :global(.bootstrap) .mb-xxl-1 {
    margin-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .mb-xxl-2 {
    margin-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .mb-xxl-3 {
    margin-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .mb-xxl-4 {
    margin-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .mb-xxl-5 {
    margin-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  :global(.bootstrap) .ms-xxl-0 {
    margin-left: 0 !important;
  }
  :global(.bootstrap) .ms-xxl-1 {
    margin-left: 0.375rem !important;
  }
  :global(.bootstrap) .ms-xxl-2 {
    margin-left: 0.75rem !important;
  }
  :global(.bootstrap) .ms-xxl-3 {
    margin-left: 1.5rem !important;
  }
  :global(.bootstrap) .ms-xxl-4 {
    margin-left: 2.25rem !important;
  }
  :global(.bootstrap) .ms-xxl-5 {
    margin-left: 4.5rem !important;
  }
  :global(.bootstrap) .ms-xxl-auto {
    margin-left: auto !important;
  }
  :global(.bootstrap) .p-xxl-0 {
    padding: 0 !important;
  }
  :global(.bootstrap) .p-xxl-1 {
    padding: 0.375rem !important;
  }
  :global(.bootstrap) .p-xxl-2 {
    padding: 0.75rem !important;
  }
  :global(.bootstrap) .p-xxl-3 {
    padding: 1.5rem !important;
  }
  :global(.bootstrap) .p-xxl-4 {
    padding: 2.25rem !important;
  }
  :global(.bootstrap) .p-xxl-5 {
    padding: 4.5rem !important;
  }
  :global(.bootstrap) .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  :global(.bootstrap) .px-xxl-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  :global(.bootstrap) .px-xxl-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  :global(.bootstrap) .px-xxl-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  :global(.bootstrap) .px-xxl-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  :global(.bootstrap) .px-xxl-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  :global(.bootstrap) .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  :global(.bootstrap) .py-xxl-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .py-xxl-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .py-xxl-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .py-xxl-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .py-xxl-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .pt-xxl-0 {
    padding-top: 0 !important;
  }
  :global(.bootstrap) .pt-xxl-1 {
    padding-top: 0.375rem !important;
  }
  :global(.bootstrap) .pt-xxl-2 {
    padding-top: 0.75rem !important;
  }
  :global(.bootstrap) .pt-xxl-3 {
    padding-top: 1.5rem !important;
  }
  :global(.bootstrap) .pt-xxl-4 {
    padding-top: 2.25rem !important;
  }
  :global(.bootstrap) .pt-xxl-5 {
    padding-top: 4.5rem !important;
  }
  :global(.bootstrap) .pe-xxl-0 {
    padding-right: 0 !important;
  }
  :global(.bootstrap) .pe-xxl-1 {
    padding-right: 0.375rem !important;
  }
  :global(.bootstrap) .pe-xxl-2 {
    padding-right: 0.75rem !important;
  }
  :global(.bootstrap) .pe-xxl-3 {
    padding-right: 1.5rem !important;
  }
  :global(.bootstrap) .pe-xxl-4 {
    padding-right: 2.25rem !important;
  }
  :global(.bootstrap) .pe-xxl-5 {
    padding-right: 4.5rem !important;
  }
  :global(.bootstrap) .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  :global(.bootstrap) .pb-xxl-1 {
    padding-bottom: 0.375rem !important;
  }
  :global(.bootstrap) .pb-xxl-2 {
    padding-bottom: 0.75rem !important;
  }
  :global(.bootstrap) .pb-xxl-3 {
    padding-bottom: 1.5rem !important;
  }
  :global(.bootstrap) .pb-xxl-4 {
    padding-bottom: 2.25rem !important;
  }
  :global(.bootstrap) .pb-xxl-5 {
    padding-bottom: 4.5rem !important;
  }
  :global(.bootstrap) .ps-xxl-0 {
    padding-left: 0 !important;
  }
  :global(.bootstrap) .ps-xxl-1 {
    padding-left: 0.375rem !important;
  }
  :global(.bootstrap) .ps-xxl-2 {
    padding-left: 0.75rem !important;
  }
  :global(.bootstrap) .ps-xxl-3 {
    padding-left: 1.5rem !important;
  }
  :global(.bootstrap) .ps-xxl-4 {
    padding-left: 2.25rem !important;
  }
  :global(.bootstrap) .ps-xxl-5 {
    padding-left: 4.5rem !important;
  }
  :global(.bootstrap) .gap-xxl-0 {
    gap: 0 !important;
  }
  :global(.bootstrap) .gap-xxl-1 {
    gap: 0.375rem !important;
  }
  :global(.bootstrap) .gap-xxl-2 {
    gap: 0.75rem !important;
  }
  :global(.bootstrap) .gap-xxl-3 {
    gap: 1.5rem !important;
  }
  :global(.bootstrap) .gap-xxl-4 {
    gap: 2.25rem !important;
  }
  :global(.bootstrap) .gap-xxl-5 {
    gap: 4.5rem !important;
  }
  :global(.bootstrap) .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  :global(.bootstrap) .row-gap-xxl-1 {
    row-gap: 0.375rem !important;
  }
  :global(.bootstrap) .row-gap-xxl-2 {
    row-gap: 0.75rem !important;
  }
  :global(.bootstrap) .row-gap-xxl-3 {
    row-gap: 1.5rem !important;
  }
  :global(.bootstrap) .row-gap-xxl-4 {
    row-gap: 2.25rem !important;
  }
  :global(.bootstrap) .row-gap-xxl-5 {
    row-gap: 4.5rem !important;
  }
  :global(.bootstrap) .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  :global(.bootstrap) .column-gap-xxl-1 {
    column-gap: 0.375rem !important;
  }
  :global(.bootstrap) .column-gap-xxl-2 {
    column-gap: 0.75rem !important;
  }
  :global(.bootstrap) .column-gap-xxl-3 {
    column-gap: 1.5rem !important;
  }
  :global(.bootstrap) .column-gap-xxl-4 {
    column-gap: 2.25rem !important;
  }
  :global(.bootstrap) .column-gap-xxl-5 {
    column-gap: 4.5rem !important;
  }
  :global(.bootstrap) .fs-xxl-1 {
    font-size: 2.5rem !important;
  }
  :global(.bootstrap) .fs-xxl-2 {
    font-size: 2rem !important;
  }
  :global(.bootstrap) .fs-xxl-3 {
    font-size: 1.75rem !important;
  }
  :global(.bootstrap) .fs-xxl-4 {
    font-size: 1.5rem !important;
  }
  :global(.bootstrap) .fs-xxl-5 {
    font-size: 1.25rem !important;
  }
  :global(.bootstrap) .fs-xxl-6 {
    font-size: 1rem !important;
  }
  :global(.bootstrap) .fs-xxl-7 {
    font-size: 0.7875rem !important;
  }
  :global(.bootstrap) .text-xxl-start {
    text-align: left !important;
  }
  :global(.bootstrap) .text-xxl-end {
    text-align: right !important;
  }
  :global(.bootstrap) .text-xxl-center {
    text-align: center !important;
  }
}
@media print {
  :global(.bootstrap) .d-print-inline {
    display: inline !important;
  }
  :global(.bootstrap) .d-print-inline-block {
    display: inline-block !important;
  }
  :global(.bootstrap) .d-print-block {
    display: block !important;
  }
  :global(.bootstrap) .d-print-grid {
    display: grid !important;
  }
  :global(.bootstrap) .d-print-inline-grid {
    display: inline-grid !important;
  }
  :global(.bootstrap) .d-print-table {
    display: table !important;
  }
  :global(.bootstrap) .d-print-table-row {
    display: table-row !important;
  }
  :global(.bootstrap) .d-print-table-cell {
    display: table-cell !important;
  }
  :global(.bootstrap) .d-print-flex {
    display: flex !important;
  }
  :global(.bootstrap) .d-print-inline-flex {
    display: inline-flex !important;
  }
  :global(.bootstrap) .d-print-none {
    display: none !important;
  }
}
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 90%;
  }
}
@keyframes blink-cursor {
  from, to {
    border-color: transparent;
  }
  50% {
    border-color: #fff;
  }
}
@keyframes ping {
  75%, to {
    transform: scale(2);
    opacity: 0;
  }
}
:global(.bootstrap) .animate-ping-in-out {
  animation: ping 1.5s ease-in-out infinite;
}
:global(.bootstrap) .animate-pulse-in-out {
  animation: pulse 1.5s ease-in-out infinite;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
:global(.bootstrap) .animate-fadeIn {
  animation: fadeIn 0.5s ease-out forwards;
}
@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-10px);
  }
}
:global(.bootstrap) .animate-fadeOut {
  animation: fadeOut 0.4s ease-in forwards;
}
@keyframes pulse {
  50% {
    opacity: 0.5;
    transform: scale(1.1);
  }
  0%, to {
    opacity: 1;
    transform: scale(1);
  }
}
:global(.bootstrap) .animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@font-face {
  font-family: "Martel";
  src: url(../../fonts/Martel-ExtraLight.ttf);
  font-weight: 200;
  font-display: swap;
}
@font-face {
  font-family: "Martel";
  src: url(../../fonts/Martel-Light.ttf);
  font-weight: 300;
  font-display: swap;
}
@font-face {
  font-family: "Martel";
  src: url(../../fonts/Martel-Regular.ttf);
  font-weight: 400;
  font-display: swap;
}
@font-face {
  font-family: "Martel";
  src: url(../../fonts/Martel-SemiBold.ttf);
  font-weight: 600;
  font-display: swap;
}
@font-face {
  font-family: "Martel";
  src: url(../../fonts/Martel-Bold.ttf);
  font-weight: 700;
  font-display: swap;
}
@font-face {
  font-family: "Martel";
  src: url(../../fonts/Martel-ExtraBold.ttf);
  font-weight: 800;
  font-display: swap;
}
@font-face {
  font-family: "Martel";
  src: url(../../fonts/Martel-Black.ttf);
  font-weight: 900;
  font-display: swap;
}
@font-face {
  font-family: "Lato";
  src: url(../../fonts/Lato-Thin.ttf);
  font-weight: 100;
  font-display: swap;
}
@font-face {
  font-family: "Lato";
  src: url(../../fonts/Lato-ThinItalic.ttf);
  font-weight: 100;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "Lato";
  src: url(../../fonts/Lato-Light.ttf);
  font-weight: 300;
  font-display: swap;
}
@font-face {
  font-family: "Lato";
  src: url(../../fonts/Lato-LightItalic.ttf);
  font-weight: 300;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "Lato";
  src: url(../../fonts/Lato-Regular.ttf);
  font-weight: 400;
  font-display: swap;
}
@font-face {
  font-family: "Lato";
  src: url(../../fonts/Lato-Bold.ttf);
  font-weight: 700;
  font-display: swap;
}
@font-face {
  font-family: "Lato";
  src: url(../../fonts/Lato-BoldItalic.ttf);
  font-weight: 700;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "Lato";
  src: url(../../fonts/Lato-Black.ttf);
  font-weight: 900;
  font-display: swap;
}
@font-face {
  font-family: "Lato";
  src: url(../../fonts/Lato-BlackItalic.ttf);
  font-weight: 900;
  font-style: italic;
  font-display: swap;
}
:global(.bootstrap) :root {
  --collapsible-show-lines: 2;
  --collapsible-line-height: 1.7em;
  --collapsible-overlay-height: 100%;
  --collapsible-less: "Close";
  --collapsible-more: "Read more";
  --collapsible-overlay-color-start: rgba(255, 255, 255, 0);
  --collapsible-overlay-color-end: rgba(255, 255, 255, 1);
  --divider-overlay-bg: white;
}
:global(.bootstrap) body {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  background-color: #fff;
}
:global(.bootstrap) #posting_page h2, :global(.bootstrap) #posting_page .h2, :global(.bootstrap) #posting_page h3, :global(.bootstrap) #posting_page .h3, :global(.bootstrap) #posting_page h4, :global(.bootstrap) #posting_page .h4, :global(.bootstrap) #posting_page h5, :global(.bootstrap) #posting_page .h5, :global(.bootstrap) #posting_page h6, :global(.bootstrap) #posting_page .h6 {
  font-size: 20px;
}
:global(.bootstrap) #posting_page .page-body img {
  width: 100%;
}
:global(.bootstrap) .subheader {
  color: #848484;
  font-weight: 300;
  letter-spacing: 0.3px;
}
@media (min-width: 813px) {
  :global(.bootstrap) .subheader {
    font-size: 24px;
  }
}
@media (max-width: 812px) {
  :global(.bootstrap) .subheader {
    font-size: 18px;
  }
}
:global(.bootstrap) .subheader-sm {
  font-weight: 300;
  letter-spacing: 0.3px;
  color: #848484;
  font-size: 16px;
}
:global(.bootstrap) .subheader-xs {
  font-weight: 300;
  letter-spacing: 0.3px;
  color: #848484;
  font-size: 12px;
}
:global(.bootstrap) .bg-red {
  background: #FF0000;
}
:global(.bootstrap) .btn {
  font-weight: 700;
  padding: 0.8rem 1.9rem;
  word-wrap: normal;
}
:global(.bootstrap) .btn-md {
  padding: 0.45rem 0.9rem;
}
:global(.bootstrap) .btn-sm, :global(.bootstrap) .btn-group-sm > .btn {
  padding: 0.28rem 0.8rem;
}
:global(.bootstrap) .btn-tiny {
  font-size: 10px;
  padding: 4px 8px;
}
:global(.bootstrap) .btn-block {
  width: 100%; /* removed in Bootstrap 5 */
}
:global(.bootstrap) .btn-hover-cursor {
  position: relative;
}
:global(.bootstrap) .btn-hover-cursor:hover:before {
  position: absolute;
  content: "";
  right: 10px;
  top: 10px;
  width: 7px;
  height: 28px;
  background: #fff;
}
:global(.bootstrap) .btn:hover {
  border-color: transparent;
}
:global(.bootstrap) .btn-default-padding {
  padding: 0.45rem 0.9rem;
}
:global(.bootstrap) .btn-primary {
  color: #08090D;
}
:global(.bootstrap) .btn-primary:hover {
  background: #FFCC00;
  color: #08090D;
}
:global(.bootstrap) .btn-twitter {
  background: #0F1419;
  color: white;
}
:global(.bootstrap) .btn-twitter:hover {
  color: white;
  background: #050709;
}
:global(.bootstrap) .btn-x-twitter {
  background: #0F1419;
  color: white;
}
:global(.bootstrap) .btn-x-twitter:hover {
  color: white;
  background: #050709;
}
:global(.bootstrap) .btn-twitter-reverse {
  background: #E5E5E7;
  color: white;
}
:global(.bootstrap) .btn-twitter-reverse:hover {
  color: white;
  background: #d8d8db;
}
:global(.bootstrap) .btn-facebook {
  background: #4267B2;
  color: white;
}
:global(.bootstrap) .btn-facebook:hover {
  color: white;
  background: #3b5c9f;
}
:global(.bootstrap) .btn-linkedin {
  background: #0077B5;
  color: white;
}
:global(.bootstrap) .btn-linkedin:hover {
  color: white;
  background: #00669c;
}
:global(.bootstrap) .btn-youtube {
  background: #FF0000;
  color: white;
}
:global(.bootstrap) .btn-youtube:hover {
  color: white;
  background: #e60000;
}
:global(.bootstrap) .btn-whatsapp {
  background: #25D366;
  color: white;
}
:global(.bootstrap) .btn-whatsapp:hover {
  color: white;
  background: #21bd5c;
}
:global(.bootstrap) .primary-links a {
  color: #08090D !important;
  text-decoration: underline;
  text-decoration-color: #FFD700 !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 1px;
}
:global(.bootstrap) .primary-links a:hover {
  background: #FFD700;
  text-decoration: none !important;
}
:global(.bootstrap) .review-card {
  position: relative;
  background: #FFFFFF;
  padding: 0.8rem 1.2rem;
}
:global(.bootstrap) .review-card a.block-link:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  content: " ";
  cursor: pointer;
}
:global(.bootstrap) .review-card a:not(.block-link), :global(.bootstrap) .review-card a[onclick^=location] {
  position: relative;
  z-index: 2;
}
:global(.bootstrap) .review-card :is(a:not(.block-link), div) [data-bs-toggle=tooltip], :global(.bootstrap) .review-card i {
  position: relative;
  z-index: 2;
}
@media (min-width: 813px) {
  :global(.bootstrap) .review-card {
    display: flex;
    flex-direction: column;
  }
}
@media (max-width: 812px) {
  :global(.bootstrap) .review-card {
    margin-bottom: 2em;
  }
}
:global(.bootstrap) .review-card.pro_point {
  border-left: 3px solid #07C960 !important;
}
:global(.bootstrap) .review-card.con_point {
  border-left: 3px solid #bc0505 !important;
}
:global(.bootstrap) .review-card[onclick^=location] {
  cursor: pointer;
}
:global(.bootstrap) .review-card.card {
  border: 1px solid #E5E6E1;
  box-sizing: border-box;
  box-shadow: 0 20px 30px -16px rgba(0, 0, 0, 0.01), 0 6px 15px rgba(0, 0, 0, 0.01), 0 5px 9px -5px rgba(0, 0, 0, 0.02);
  border-radius: 3px;
}
:global(.bootstrap) .review-card .user-card {
  padding: 1rem 0;
  margin-bottom: 1rem;
}
:global(.bootstrap) .review-card .product {
  position: relative;
  display: flex;
  align-items: center;
  padding: 1rem 0;
  line-height: 1.2;
  margin-bottom: 1rem;
  border-bottom: 1px solid #E5E6E1;
}
:global(.bootstrap) .review-card .product a.block-link:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  content: " ";
  cursor: pointer;
}
:global(.bootstrap) .review-card .product a:not(.block-link), :global(.bootstrap) .review-card .product a[onclick^=location] {
  position: relative;
  z-index: 3;
}
:global(.bootstrap) .review-card .product :is(a:not(.block-link), div) [data-bs-toggle=tooltip], :global(.bootstrap) .review-card .product i {
  position: relative;
  z-index: 3;
}
:global(.bootstrap) .review-card .product img {
  margin-right: 1rem;
}
@media (min-width: 813px) {
  :global(.bootstrap) .review-card .product {
    height: 75px;
  }
}
:global(.bootstrap) .review-card .product .name {
  font-weight: 400;
  color: #4D4D4D;
  font-size: 18px;
}
@media (max-width: 1119px) and (min-width: 813px) {
  :global(.bootstrap) .review-card .product .name {
    font-size: 14px;
  }
}
:global(.bootstrap) .review-card .product .name:hover, :global(.bootstrap) .review-card .product .name:focus-within {
  color: #1a1a1a;
  text-decoration: underline;
}
:global(.bootstrap) .review-card .content {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex-grow: 1;
}
:global(.bootstrap) .review-card .content .rating {
  margin-bottom: 20px;
  display: flex;
}
:global(.bootstrap) .review-card .content .rating .date {
  margin-left: auto;
  font-size: 14px;
  color: #A9A9A9;
}
:global(.bootstrap) .review-card .content .title {
  color: #4D4D4D;
  font-size: 20px;
  margin-bottom: 20px;
  line-height: 1.2;
}
@media (min-width: 813px) {
  :global(.bootstrap) .review-card .content .title:not(.title-full) {
    font-weight: 600;
    line-clamp: 2;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .review-card .content .title.title-full {
    line-clamp: 6;
    display: -webkit-box;
    -webkit-line-clamp: 6 !important;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 140px !important;
    margin-bottom: 5px;
    font-size: 18px;
    line-height: 1.5;
  }
}
@media (max-width: 1119px) and (min-width: 813px) {
  :global(.bootstrap) .review-card .content .title {
    font-size: 16px;
    line-height: 1.3;
  }
}
:global(.bootstrap) .review-card .content .snippet {
  font-size: 16px;
  font-weight: 300;
  color: #666560;
  margin-bottom: auto;
  line-clamp: 6;
  display: -webkit-box;
  -webkit-line-clamp: 6 !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
:global(.bootstrap) .review-card .content h4, :global(.bootstrap) .review-card .content .h4, :global(.bootstrap) .review-card .content h3, :global(.bootstrap) .review-card .content .h3 {
  font-size: 18px;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  line-height: 1.3;
  padding: 20px 0 0;
}
:global(.bootstrap) .comparison-card {
  container: comparison-card/inline-size;
  padding: 1em !important;
}
:global(.bootstrap) .comparison-card:not(.vertical) .product-col {
  position: relative;
}
:global(.bootstrap) .comparison-card:not(.vertical) .product-col:not(.vertical-comparison):not(:first-child) {
  border-left: 1px solid #E5E6E1;
}
@container comparison-card (min-width: 540px) {
  :global(.bootstrap) .comparison-card:not(.vertical) .product-col:not(.vertical-comparison):not(:first-child) {
    padding-left: 1.5rem;
  }
}
:global(.bootstrap) .comparison-card:not(.vertical) .product-col:not(.vertical-comparison):not(:first-child):before {
  position: absolute;
  content: "Vs";
  left: -8px;
  background: #fff;
  color: #848484;
  font-size: 14px;
  padding: 0.25em 0;
}
@media (min-width: 813px) {
  :global(.bootstrap) .comparison-card:not(.vertical) .product-col:not(.vertical-comparison):not(:first-child):before {
    top: 30%;
  }
}
@media (max-width: 812px) {
  :global(.bootstrap) .comparison-card:not(.vertical) .product-col:not(.vertical-comparison):not(:first-child):before {
    top: 50%;
  }
}
@container comparison-card (max-width: 540px) {
  :global(.bootstrap) .comparison-card:not(.vertical) .product-col:not(.vertical-comparison) .product-card .product-content .product-logo img {
    max-width: 40px;
    max-height: 40px;
  }
}
@container product (max-width: 240px) {
  :global(.bootstrap) .comparison-card:not(.comparison-widget):not(.vertical) .product-col .product-card .product-content {
    /* display as vertical when the product is smaller than a mobile device */
    flex-wrap: wrap;
  }
  :global(.bootstrap) .comparison-card:not(.comparison-widget):not(.vertical) .product-col .product-card .product-content .product-logo {
    width: 100%;
    text-align: center;
  }
  :global(.bootstrap) .comparison-card:not(.comparison-widget):not(.vertical) .product-col .product-card .product-content .product-details {
    align-items: center;
    text-align: center;
    width: 100%;
    padding: 0 !important;
  }
  :global(.bootstrap) .comparison-card:not(.comparison-widget):not(.vertical) .product-col .product-card .product-content .product-details > * {
    text-align: center;
    align-self: center;
    margin: 0 0 0.5rem;
  }
  :global(.bootstrap) .comparison-card:not(.comparison-widget):not(.vertical) .product-col .product-card .product-content .product-details > *:first-child {
    margin-top: 0.8rem;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .comparison-card:not(.comparison-widget) .product-col.vertical-comparison {
    padding: 20px 0;
    width: 100%;
    flex: 0 0 auto;
    margin: 0 0.75rem;
  }
  :global(.bootstrap) .comparison-card:not(.comparison-widget) .product-col.vertical-comparison:first-child {
    padding-top: 0;
  }
  :global(.bootstrap) .comparison-card:not(.comparison-widget) .product-col.vertical-comparison:not(:first-child) {
    border-top: 1px solid #adb5bd;
    position: relative;
  }
  :global(.bootstrap) .comparison-card:not(.comparison-widget) .product-col.vertical-comparison:not(:first-child):before {
    position: absolute;
    content: "Vs";
    background: #fff;
    color: #848484;
    font-size: 14px;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 0 0.35em;
    top: -10px !important;
    width: 40px;
    text-align: center;
    line-height: 1;
  }
}
@media (max-width: 813px) {
  :global(.bootstrap) .comparison-card:not(.comparison-widget) .product-col.vertical-comparison:not(:first-child) {
    border-left: 1px solid #E5E6E1;
  }
  :global(.bootstrap) .comparison-card:not(.comparison-widget) .product-col.vertical-comparison:not(:first-child):before {
    position: absolute;
    content: "Vs";
    left: -8px;
    background: #fff;
    color: #848484;
    font-size: 14px;
    padding: 0.25em 0;
  }
}
@media (max-width: 813px) and (min-width: 813px) {
  :global(.bootstrap) .comparison-card:not(.comparison-widget) .product-col.vertical-comparison:not(:first-child):before {
    top: 30%;
  }
}
@media (max-width: 813px) and (max-width: 812px) {
  :global(.bootstrap) .comparison-card:not(.comparison-widget) .product-col.vertical-comparison:not(:first-child):before {
    top: 50%;
  }
}
:global(.bootstrap) .comparison-card.comparison-widget .comparison-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
:global(.bootstrap) .comparison-card.comparison-widget .comparison-row > .product-col {
  width: 41.6666666667%;
  padding-right: 12px;
}
:global(.bootstrap) .comparison-card.comparison-widget .comparison-row > .product-col .btn:active {
  border: 0;
}
:global(.bootstrap) .comparison-card.comparison-widget .comparison-row .comparison-go {
  width: 16.6666666667%;
}
@container comparison-card (max-width: 540px) {
  :global(.bootstrap) .comparison-card.comparison-widget .comparison-row {
    flex-wrap: wrap;
  }
  :global(.bootstrap) .comparison-card.comparison-widget .comparison-row > .product-col {
    width: 50%;
  }
  :global(.bootstrap) .comparison-card.comparison-widget .comparison-row .comparison-go {
    width: 100%;
    margin-top: 12px;
  }
}
@container comparison-card (max-width: map-get($container-max-widths, "sm")) {
  :global(.bootstrap) .comparison-card.comparison-widget .dropdown-toggle:has(.product-card) {
    justify-content: center;
  }
  :global(.bootstrap) .comparison-card.comparison-widget .dropdown-item .product-card > * {
    flex-direction: row !important;
    flex-wrap: nowrap !important;
  }
}
:global(.bootstrap) .comparison-card.comparison-widget.vertical .comparison-row {
  flex-wrap: wrap;
}
:global(.bootstrap) .comparison-card.comparison-widget.vertical .comparison-row > * {
  width: 100%;
  padding: 0;
}
:global(.bootstrap) .comparison-card.comparison-widget.vertical .comparison-row .comparison-go {
  margin-top: 12px;
}
:global(.bootstrap) .comparison-card.comparison-widget.vertical .product-col.vertical-comparison {
  position: relative;
  width: 100%;
  flex: 0 0 auto;
}
:global(.bootstrap) .comparison-card.comparison-widget.vertical .product-col.vertical-comparison:first-child {
  padding-top: 0;
}
:global(.bootstrap) .comparison-card.comparison-widget.vertical .product-col.vertical-comparison:not(:has(.dropdown-toggle .product-card)) {
  padding: 20px 0;
}
:global(.bootstrap) .comparison-card.comparison-widget.vertical .product-col.vertical-comparison:not(:first-child) {
  border-top: 1px solid #adb5bd;
}
:global(.bootstrap) .comparison-card.comparison-widget.vertical .product-col.vertical-comparison:not(:first-child):before {
  position: absolute;
  content: "Vs";
  background: #fff;
  color: #848484;
  font-size: 14px;
  left: 0;
  right: 0;
  margin: 0 auto;
  padding: 0 0.35em;
  top: -10px !important;
  width: 40px;
  text-align: center;
  line-height: 1;
}
:global(.bootstrap) .comparison-card.comparison-widget.vertical .dropdown-toggle {
  justify-content: center;
  white-space: normal;
}
:global(.bootstrap) .comparison-card.comparison-widget.vertical .dropdown-toggle .product-card div {
  display: flex;
  justify-content: center;
}
:global(.bootstrap) .comparison-card.comparison-widget .product-col:not(.vertical-comparison) .dropdown-toggle {
  white-space: normal;
}
:global(.bootstrap) .comparison-card.comparison-widget .product-col:not(.vertical-comparison) .dropdown-toggle:not(.btn-light) {
  padding: 0;
}
@container comparison-card (max-width: 540px) {
  :global(.bootstrap) .comparison-card.comparison-widget .product-col:not(.vertical-comparison) {
    position: static;
  }
  :global(.bootstrap) .comparison-card.comparison-widget .product-col:not(.vertical-comparison) .dropdown {
    position: static;
  }
  :global(.bootstrap) .comparison-card.comparison-widget .product-col:not(.vertical-comparison) .dropdown-menu {
    top: 50% !important;
    min-width: 250px;
  }
  :global(.bootstrap) .comparison-card.comparison-widget .product-col:not(.vertical-comparison) .dropdown-item .product-card .name {
    font-size: 14px;
  }
  :global(.bootstrap) .comparison-card.comparison-widget .product-col:not(.vertical-comparison):not(:first-child):before {
    content: "";
  }
  :global(.bootstrap) .comparison-card.comparison-widget .product-col:not(.vertical-comparison):not(:first-child) .dropdown-toggle {
    position: relative;
  }
  :global(.bootstrap) .comparison-card.comparison-widget .product-col:not(.vertical-comparison):not(:first-child) .dropdown-toggle:before {
    position: absolute;
    content: "Vs";
    left: -8px;
    background: #fff;
    color: #848484;
    font-size: 14px;
    padding: 0.25em 0;
    left: -33px;
    opacity: 1;
    font-weight: 400;
  }
  @media (min-width: 813px) {
    :global(.bootstrap) .comparison-card.comparison-widget .product-col:not(.vertical-comparison):not(:first-child) .dropdown-toggle:before {
      top: 30%;
    }
  }
  @media (max-width: 812px) {
    :global(.bootstrap) .comparison-card.comparison-widget .product-col:not(.vertical-comparison):not(:first-child) .dropdown-toggle:before {
      top: 50%;
    }
  }
}
:global(.bootstrap) .comparison-card.comparison-widget .product-col:not(.vertical-comparison).vertical {
  margin: 0;
}
:global(.bootstrap) .product-card {
  container: product/inline-size;
  width: 100%;
}
:global(.bootstrap) .product-card .product-content {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  align-items: center;
}
:global(.bootstrap) .product-card .product-content .product-logo {
  width: auto;
}
:global(.bootstrap) .product-card .product-content .product-details {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  padding-left: 12px;
  text-align: left;
  font-weight: 300;
  letter-spacing: 0.3px;
}
:global(.bootstrap) .product-card .product-content .product-details > * {
  white-space: normal;
}
:global(.bootstrap) .product-card .product-content.vertical {
  flex-wrap: wrap;
}
:global(.bootstrap) .product-card .product-content.vertical .product-logo {
  width: 100%;
  text-align: center;
}
:global(.bootstrap) .product-card .product-content.vertical .product-details {
  align-items: center;
  text-align: center;
  width: 100%;
  padding: 0 !important;
}
:global(.bootstrap) .product-card .product-content.vertical .product-details > * {
  text-align: center;
  align-self: center;
  margin: 0 0 0.5rem;
}
:global(.bootstrap) .product-card .product-content.vertical .product-details > *:first-child {
  margin-top: 0.8rem;
}
:global(.bootstrap) .product-card .product-content.two-column-layout {
  align-items: stretch;
}
:global(.bootstrap) .product-card .product-content.two-column-layout .product-logo {
  padding-right: 12px;
}
:global(.bootstrap) .product-card .product-content.two-column-layout .product-details {
  width: 58.3333333333%;
  align-items: flex-start;
  text-align: left;
}
@media (min-width: 813px) {
  :global(.bootstrap) .product-card .product-content.two-column-layout .product-details {
    border-right: 1px solid #ededed;
    padding-right: 1.5rem;
    margin-right: 1.5rem;
  }
}
@media (max-width: 813px) {
  :global(.bootstrap) .product-card .product-content.two-column-layout {
    flex-wrap: wrap;
  }
  :global(.bootstrap) .product-card .product-content.two-column-layout .product-logo {
    width: 100%;
    text-align: center;
  }
  :global(.bootstrap) .product-card .product-content.two-column-layout .product-details {
    align-items: center;
    text-align: center;
    width: 100%;
    padding: 0 !important;
  }
  :global(.bootstrap) .product-card .product-content.two-column-layout .product-details > * {
    text-align: center;
    align-self: center;
    margin: 0 0 0.5rem;
  }
  :global(.bootstrap) .product-card .product-content.two-column-layout .product-details > *:first-child {
    margin-top: 0.8rem;
  }
  :global(.bootstrap) .product-card .product-content.two-column-layout .product-details > * {
    align-self: flex-start;
    text-align: left;
  }
}
@container product (max-width: 170px) {
  :global(.bootstrap) .product-card .product-content:not(.two-column-layout) {
    /* display as vertical when the product is smaller than a mobile device */
    flex-wrap: wrap;
  }
  :global(.bootstrap) .product-card .product-content:not(.two-column-layout) .product-logo {
    width: 100%;
    text-align: center;
  }
  :global(.bootstrap) .product-card .product-content:not(.two-column-layout) .product-details {
    align-items: center;
    text-align: center;
    width: 100%;
    padding: 0 !important;
  }
  :global(.bootstrap) .product-card .product-content:not(.two-column-layout) .product-details > * {
    text-align: center;
    align-self: center;
    margin: 0 0 0.5rem;
  }
  :global(.bootstrap) .product-card .product-content:not(.two-column-layout) .product-details > *:first-child {
    margin-top: 0.8rem;
  }
}
:global(.bootstrap) .product-card.product-block-link {
  position: relative;
}
:global(.bootstrap) .product-card.product-block-link a.block-link:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  content: " ";
  cursor: pointer;
}
:global(.bootstrap) .product-card.product-block-link a:not(.block-link), :global(.bootstrap) .product-card.product-block-link a[onclick^=location] {
  position: relative;
  z-index: 2;
}
:global(.bootstrap) .product-card.product-block-link :is(a:not(.block-link), div) [data-bs-toggle=tooltip], :global(.bootstrap) .product-card.product-block-link i {
  position: relative;
  z-index: 2;
}
:global(.bootstrap) .product-card.card {
  padding: 1.2em;
}
:global(.bootstrap) .product-card .product-name {
  font-weight: 700;
  color: #08090D;
  font-size: 17px;
  line-height: 1.2;
}
:global(.bootstrap) .product-card .product-name.row {
  height: 65px;
}
:global(.bootstrap) .product-card .product-name.name-sm {
  font-size: 14px;
  font-weight: normal;
}
@media (min-width: 813px) {
  :global(.bootstrap) .product-card .product-name {
    text-align: left;
  }
  :global(.bootstrap) .product-card .product-name.name-lg {
    font-size: 24px;
  }
}
@media (max-width: 1367px) and (min-width: 576px) {
  :global(.bootstrap) .product-card .product-name {
    font-size: 14px;
  }
}
@media (max-width: 812px) {
  :global(.bootstrap) .product-card .product-name {
    height: auto;
    overflow: hidden;
  }
}
@media (max-width: 477px) {
  :global(.bootstrap) .product-card .product-name {
    font-size: 13px;
    height: auto;
  }
  :global(.bootstrap) .product-card .product-name.name-lg {
    font-size: 16px;
  }
}
:global(.bootstrap) .product-card .flashy-stats > :not(:first-child) {
  border-left: 1px solid #f3f3f3;
  padding-left: 10px;
}
:global(.bootstrap) .product-card .stats {
  font-weight: 300;
  letter-spacing: 0.3px;
  font-size: 14px;
  color: #848484;
}
@media (max-width: 477px) {
  :global(.bootstrap) .product-card .stats {
    font-size: 11px;
  }
}
:global(.bootstrap) .product-card .product-badge {
  position: absolute;
  width: 0;
  height: 0;
  border-top: 80px solid #FFF7CC;
  border-right: 80px solid transparent;
  left: 0;
  top: 0;
}
:global(.bootstrap) .product-card .product-badge span {
  position: absolute;
  width: 80px;
  transform: rotate(-45deg);
  text-align: center;
  top: -80px;
  left: -20px;
}
:global(.bootstrap) .user-card {
  display: flex;
  line-height: 1.2;
}
:global(.bootstrap) .user-card img {
  object-fit: cover; /* for non-square images */
}
@media (max-width: 813px) {
  :global(.bootstrap) .user-card {
    flex-wrap: wrap;
  }
}
:global(.bootstrap) .user-card-horizontal {
  align-items: center;
}
@media (min-width: 1120px) {
  :global(.bootstrap) .user-card-horizontal {
    height: 95px;
  }
}
@media (max-width: 1119px) and (min-width: 813px) {
  :global(.bootstrap) .user-card-horizontal {
    height: 115px;
  }
}
@media (max-width: 1367px) and (min-width: 813px) {
  :global(.bootstrap) .user-card-horizontal {
    word-break: break-word;
  }
  :global(.bootstrap) .user-card-horizontal .info {
    line-clamp: 5;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
:global(.bootstrap) .user-card-horizontal .labels:not(.label-block) {
  flex: 1 0 auto;
}
@media (min-width: 813px) {
  :global(.bootstrap) .user-card-horizontal .labels:not(.label-block) {
    text-align: right;
  }
}
@media (max-width: 813px) {
  :global(.bootstrap) .user-card-horizontal .labels:not(.label-block) {
    padding-top: 15px;
    flex-basis: 100%;
  }
}
:global(.bootstrap) .user-card-horizontal .labels.label-block {
  padding-top: 15px;
  flex-basis: 100%;
}
:global(.bootstrap) .user-card-horizontal .labels .badge {
  margin-left: 5px;
}
:global(.bootstrap) .user-card-vertical, :global(.bootstrap) .user-card-vertical-compact {
  width: 100%;
}
@media (min-width: 992px) {
  :global(.bootstrap) .user-card-vertical, :global(.bootstrap) .user-card-vertical-compact {
    flex-direction: column;
    align-items: flex-start;
  }
}
:global(.bootstrap) .user-card-vertical .labels, :global(.bootstrap) .user-card-vertical-compact .labels {
  padding-top: 2rem;
}
@media (max-width: 992px) {
  :global(.bootstrap) .user-card-vertical .labels, :global(.bootstrap) .user-card-vertical-compact .labels {
    padding-top: 0.6rem;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .user-card-vertical .user-details, :global(.bootstrap) .user-card-vertical-compact .user-details {
    flex-direction: column;
    align-items: flex-start !important;
  }
}
@media (max-width: 813px) {
  :global(.bootstrap) .user-card-vertical .user-details.user-details-mobile-vertical, :global(.bootstrap) .user-card-vertical-compact .user-details.user-details-mobile-vertical {
    flex-direction: column;
    align-items: center !important;
  }
  :global(.bootstrap) .user-card-vertical .user-details.user-details-mobile-vertical .details, :global(.bootstrap) .user-card-vertical-compact .user-details.user-details-mobile-vertical .details {
    text-align: center;
    margin-top: 5px;
  }
}
@media (max-width: 813px) {
  :global(.bootstrap) .user-card-vertical .user-details img, :global(.bootstrap) .user-card-vertical-compact .user-details img {
    margin-right: 1rem;
  }
}
:global(.bootstrap) .user-card-vertical .user-details .details, :global(.bootstrap) .user-card-vertical-compact .user-details .details {
  width: 100%;
}
@media (min-width: 813px) {
  :global(.bootstrap) .user-card-vertical .user-details .details, :global(.bootstrap) .user-card-vertical-compact .user-details .details {
    margin: 10px 0;
    border-top: 1px solid #E5E6E1;
    padding-top: 10px;
  }
}
:global(.bootstrap) .user-card-vertical .user-details .name > *, :global(.bootstrap) .user-card-vertical-compact .user-details .name > * {
  font-weight: 600;
  font-size: 16px;
  color: #08090D;
}
:global(.bootstrap) .user-card-vertical .user-details .name a, :global(.bootstrap) .user-card-vertical-compact .user-details .name a {
  color: #08090D !important;
  text-decoration: underline;
  text-decoration-color: #FFD700 !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 1px;
}
:global(.bootstrap) .user-card-vertical .user-details .name a:hover, :global(.bootstrap) .user-card-vertical-compact .user-details .name a:hover {
  background: #FFD700;
  text-decoration: none !important;
}
:global(.bootstrap) .user-card-vertical .user-details .info, :global(.bootstrap) .user-card-vertical-compact .user-details .info {
  font-size: 12px;
  line-height: 18px;
  padding-top: 5px;
}
:global(.bootstrap) .user-card-vertical-compact .labels {
  padding-top: 0.2rem;
}
:global(.bootstrap) .user-card .user-details {
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
}
:global(.bootstrap) .user-card .user-details a.block-link:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2 !important;
  content: " ";
  cursor: pointer;
}
:global(.bootstrap) .user-card .user-details a:not(.block-link), :global(.bootstrap) .user-card .user-details a[onclick^=location] {
  position: relative;
  z-index: 2 !important1;
}
:global(.bootstrap) .user-card .user-details :is(a:not(.block-link), div) [data-bs-toggle=tooltip], :global(.bootstrap) .user-card .user-details i {
  position: relative;
  z-index: 2 !important1;
}
:global(.bootstrap) .user-card .user-details-horizontal {
  flex-direction: row;
  align-items: center;
}
:global(.bootstrap) .user-card .user-details-horizontal img {
  margin-right: 1rem;
}
@media (max-width: 576px) {
  :global(.bootstrap) .user-card .user-details-horizontal .details {
    width: 80%;
  }
}
:global(.bootstrap) .user-card .user-details-horizontal .name {
  font-size: 18px;
  word-break: break-all;
}
:global(.bootstrap) .user-card .user-details-horizontal .name a {
  color: #08090D !important;
  text-decoration: underline;
  text-decoration-color: #FFD700 !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 1px;
  margin-bottom: 6px;
}
:global(.bootstrap) .user-card .user-details-horizontal .name a:hover {
  background: #FFD700;
  text-decoration: none !important;
}
:global(.bootstrap) .user-card .user-details-horizontal .name :not(a) {
  color: #08090D;
}
@media (max-width: 1119px) and (min-width: 813px) {
  :global(.bootstrap) .user-card .user-details-horizontal .name {
    font-size: 16px;
  }
}
:global(.bootstrap) .user-card .user-details-horizontal .info {
  padding-top: 3px;
  line-height: 1.4;
  font-size: 12px;
}
:global(.bootstrap) .user-card .user-details-vertical-compact .name a {
  font-weight: 400;
}
:global(.bootstrap) .user-card .user-details-vertical-compact .info {
  font-size: 12px;
  padding-top: 3px;
}
:global(.bootstrap) .user-card .info {
  font-weight: 300;
  letter-spacing: 0.3px;
  color: #A9A9A9;
}
:global(.bootstrap) .question-card:not(:last-child) {
  border-bottom: 1px solid #E5E6E1;
}
:global(.bootstrap) .question-card:not(:only-child) {
  padding: 1rem 0;
}
:global(.bootstrap) .question-card .content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}
@media (min-width: 992px) {
  :global(.bootstrap) .question-card .content {
    margin-left: 2.25rem;
  }
}
@media (max-width: 992px) {
  :global(.bootstrap) .question-card .content .taggings {
    display: none;
  }
}
:global(.bootstrap) .question-card .info, :global(.bootstrap) .question-card .date {
  color: #666560;
  font-weight: 300;
  letter-spacing: 0.3px;
  font-size: 14px;
}
:global(.bootstrap) .question-card .info i, :global(.bootstrap) .question-card .date i {
  margin-right: 5px;
}
@media (max-width: 576px) {
  :global(.bootstrap) .question-card .info, :global(.bootstrap) .question-card .date {
    font-size: 12px;
  }
}
:global(.bootstrap) .question-card .stats {
  display: flex;
}
:global(.bootstrap) .question-card .stats > * {
  margin-right: 1.8em;
}
:global(.bootstrap) .question-card .taggings {
  font-size: 1.1em;
}
:global(.bootstrap) .question-card .title {
  flex-basis: 100%;
  padding: 1.5rem 0;
}
:global(.bootstrap) .question-card .title a {
  color: #4D4D4D;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
}
:global(.bootstrap) .question-card .title a:hover {
  color: gray;
}
@media (max-width: 576px) {
  :global(.bootstrap) .question-card .title a {
    font-size: 18px;
  }
}
:global(.bootstrap) .comment-form-card {
  background-color: #FAFAFA;
  border: 1px solid #E5E6E1;
  padding: 1rem;
  display: flex;
  flex-direction: row;
  position: relative;
}
:global(.bootstrap) .comment-form-card form {
  width: 100%;
  margin-left: 15px;
  box-sizing: border-box;
}
:global(.bootstrap) .comment-form-card form .embedded-comment-bottom {
  display: none;
  margin-top: 15px;
}
:global(.bootstrap) .comment-form-card form ul.parsley-errors-list, :global(.bootstrap) .comment-form-card form .errors-box {
  display: none;
}
:global(.bootstrap) .comment-form-card form .redactor-styles {
  overflow: hidden;
  font-family: "Lato", sans-serif;
  height: 55px;
  transition: all 0.3s ease-out;
}
:global(.bootstrap) .comment-form-card form .redactor-styles p {
  font-family: "Lato", sans-serif;
}
:global(.bootstrap) .comment-form-card form:focus-within .redactor-styles {
  height: 200px;
  overflow: auto;
}
:global(.bootstrap) .comment-form-card form:focus-within .embedded-comment-bottom {
  display: block;
}
:global(.bootstrap) .comment-form-card form:focus-within ul.parsley-errors-list, :global(.bootstrap) .comment-form-card form:focus-within .errors-box {
  display: list-item;
  top: 113%;
  position: absolute;
  left: 0;
  margin: 0;
  font-family: "Lato", sans-serif;
  font-size: 12px;
  padding: 0 !important;
  overflow: hidden;
}
:global(.bootstrap) .comment-form-card form:focus-within ul.parsley-errors-list li, :global(.bootstrap) .comment-form-card form:focus-within .errors-box li {
  margin: 0;
}
:global(.bootstrap) .comment-form-card form:focus-within .errors-box {
  top: 85%;
  left: 80px;
  color: #bc0505;
}
:global(.bootstrap) .comment-form-card form fieldset {
  border: 1px solid #E5E6E1;
  margin-top: 15px;
}
:global(.bootstrap) .comment-form-card form fieldset legend {
  padding: 0 8px;
  color: #4D4D4D;
}
@media (max-width: 576px) {
  :global(.bootstrap) .comment-form-card {
    padding: 0.5rem;
  }
  :global(.bootstrap) .comment-form-card img, :global(.bootstrap) .comment-form-card .css-avatar {
    display: none;
  }
  :global(.bootstrap) .comment-form-card form {
    margin-left: 0;
  }
  :global(.bootstrap) .comment-form-card form .btn {
    flex-basis: 100%;
  }
  :global(.bootstrap) .comment-form-card form ul.parsley-errors-list, :global(.bootstrap) .comment-form-card form .errors-box {
    top: 103% !important;
  }
}
:global(.bootstrap) .comment-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #E5E6E1;
  border-radius: 5px;
  background: #fff;
  padding: 20px;
  margin: 20px 0;
  font-size: 15px;
  line-height: 1.7;
  position: relative;
}
:global(.bootstrap) .comment-card > * {
  flex-basis: 100%;
}
:global(.bootstrap) .comment-card .featured {
  position: absolute;
  top: -10px;
  right: -7px;
}
:global(.bootstrap) .comment-card .user-card {
  padding: 0;
  margin: 0;
  height: auto;
}
@media (max-width: 992px) {
  :global(.bootstrap) .comment-card .badge {
    display: none;
  }
}
:global(.bootstrap) .comment-card p:empty, :global(.bootstrap) .comment-card :is(ul, ol, li, p) br:first-child, :global(.bootstrap) .comment-card :is(ul, ol, p, br, li) + br {
  display: none;
}
:global(.bootstrap) .comment-card p:empty + p {
  margin-top: 0;
}
:global(.bootstrap) .comment-card .comment-body {
  font-weight: 300;
  letter-spacing: 0.3px;
  font-size: 18px;
  color: #08090D;
  line-height: var(--bs-body-line-height);
}
:global(.bootstrap) .comment-card .comment-body p {
  font-family: "Lato", sans-serif !important;
  margin: 20px 0 0;
  padding: 0;
  word-wrap: break-word;
}
:global(.bootstrap) .comment-card .comment-body p:first-child {
  margin: 0;
}
:global(.bootstrap) .comment-card .comment-body [class*=gitb-expander]:after {
  font-weight: 600;
  font-size: 16px;
  font-family: "Lato", sans-serif;
  bottom: -5px;
  right: auto;
  color: #08090D !important;
  text-decoration: underline;
  text-decoration-color: #FFD700 !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 1px;
  text-underline-offset: 0;
}
:global(.bootstrap) .comment-card .comment-body [class*=gitb-expander]:after:hover {
  background: #FFD700;
  text-decoration: none !important;
}
:global(.bootstrap) .comment-card .comment-body [class*=gitb-expander]:hover::after {
  background: #FFD700;
  text-decoration: none !important;
}
:global(.bootstrap) .comment-card.reply {
  border: none;
  padding: 0;
  position: relative;
  padding-left: 60px;
}
:global(.bootstrap) .comment-card.reply:last-child {
  margin-bottom: 0;
}
:global(.bootstrap) .comment-card.reply:before {
  font-family: "Font Awesome 6 Pro";
  font-weight: 300;
  content: "\e3d6";
  position: absolute;
  top: 3px;
  left: 0;
  color: #E5E6E1;
  font-size: 30px;
  line-height: 1;
}
@media (max-width: 576px) {
  :global(.bootstrap) .comment-card.reply {
    padding-left: 50px;
  }
  :global(.bootstrap) .comment-card.reply .user-details-horizontal {
    align-items: flex-start;
  }
  :global(.bootstrap) .comment-card.reply:before {
    font-size: 25px;
    top: 0;
  }
}
:global(.bootstrap) .comment-card.reply:last-of-type .comment-body {
  border-bottom: none;
}
:global(.bootstrap) .comment-card a[data-gitb-tagged] {
  color: #08090D;
  text-decoration: underline;
  text-decoration-color: #FFD700;
  text-decoration-thickness: 2px;
  text-underline-offset: 2px;
  cursor: pointer;
}
:global(.bootstrap) .comment-card a[data-gitb-tagged]:hover {
  background-color: #FFD700;
}
:global(.bootstrap) .comment-card .open-reply-form.open {
  position: relative;
  color: transparent !important;
}
:global(.bootstrap) .comment-card .open-reply-form.open:before {
  color: #08090D;
  font-weight: bold;
  position: absolute;
  left: 18px;
  content: "Close";
}
:global(.bootstrap) .comment-card .open-reply-form.open:hover:before {
  color: #0a4d78;
}
:global(.bootstrap) .report-download {
  border: 1px solid #E5E6E1;
  border-radius: 5px;
  padding: 20px;
  margin: 20px 0;
  container: report-banner/inline-size;
}
@container report-banner (min-width: 795px) {
  :global(.bootstrap) .report-download > div {
    flex-wrap: nowrap;
  }
  :global(.bootstrap) .report-download > div > div:nth-child(1) {
    flex-basis: 25%;
  }
  :global(.bootstrap) .report-download > div > div:nth-child(2) {
    flex-basis: 75%;
    font-size: 18px;
  }
  :global(.bootstrap) .report-download > div > div:nth-child(2) b {
    display: block;
  }
}
@container report-banner (min-width: 575px) and (max-width: 795px) {
  :global(.bootstrap) .report-download > div {
    flex-wrap: nowrap;
  }
  :global(.bootstrap) .report-download > div > div:nth-child(1) {
    flex-basis: 33.33333333%;
  }
  :global(.bootstrap) .report-download > div > div:nth-child(2) {
    flex-basis: 66.66666667%;
  }
}
@container report-banner (max-width: 575px) {
  :global(.bootstrap) .report-download .report_image {
    margin: 0 !important;
  }
  :global(.bootstrap) .report-download .report_image .report-inner-wrapper {
    padding: 35px 8px 5px !important;
  }
  :global(.bootstrap) .report-download .report_image .report-title, :global(.bootstrap) .report-download .report_image .report-subtext {
    font-size: 0.6rem !important;
    line-height: 1.3;
    margin: 0;
  }
  :global(.bootstrap) .report-download .report_image .ps-logo {
    margin-top: 1%;
  }
  :global(.bootstrap) .report-download .report_image .ps-logo img {
    height: 15px;
    width: auto;
  }
  :global(.bootstrap) .report-download .report_image:after {
    width: 30px !important;
    height: 15px !important;
    font-weight: 400 !important;
    font-size: 0.7rem !important;
    padding: 2px !important;
  }
  @media (min-width: 410px) {
    :global(.bootstrap) .report-download .report_image .report-title, :global(.bootstrap) .report-download .report_image .report-subtext {
      font-size: 0.9rem !important;
      line-height: 1.4;
    }
    :global(.bootstrap) .report-download .report_image:after {
      width: 35px;
      height: 22px;
      font-weight: 600;
      font-size: 0.9rem;
      padding: 4px;
    }
  }
  :global(.bootstrap) .report-download > div {
    flex-wrap: nowrap;
    position: relative;
    font-size: 12px;
  }
  :global(.bootstrap) .report-download > div > div:nth-child(1) {
    flex-basis: 41.66666667%;
  }
  :global(.bootstrap) .report-download > div > div:nth-child(2) {
    flex-basis: 58.33333333%;
  }
  :global(.bootstrap) .report-download > div .btn {
    padding: 0.5rem 1.1rem;
    font-size: 14px !important;
    background: #FFD700;
    color: #08090D;
    border: none;
    margin: 0 !important;
  }
  :global(.bootstrap) .report-download > div .btn i {
    display: none;
  }
  :global(.bootstrap) .report-download > div .btn:hover {
    background: #e6c200;
  }
  :global(.bootstrap) .report-download > div > * {
    z-index: 999;
  }
  :global(.bootstrap) .report-download > div .container-sm-none {
    display: none;
  }
  :global(.bootstrap) .report-download > div:after {
    position: absolute;
    top: 10px;
    bottom: 10px;
    left: -10px;
    right: -10px;
    content: " ";
    background: #FFF7CC;
    border-bottom: 1px solid #E5E6E1;
  }
}
@media (max-width: 665px) {
  :global(.bootstrap) .report-download {
    border: none;
    padding: 0;
    background: none !important;
  }
}
@media (max-width: 576px) {
  :global(.bootstrap) .lead-gen {
    position: relative;
    font-size: 12px;
  }
  :global(.bootstrap) .lead-gen .btn {
    padding: 0.5rem 1.1rem;
    font-size: 14px !important;
    background: #FFD700;
    color: #08090D;
    border: none;
    margin: 0 !important;
  }
  :global(.bootstrap) .lead-gen .btn i {
    display: none;
  }
  :global(.bootstrap) .lead-gen .btn:hover {
    background: #e6c200;
  }
  :global(.bootstrap) .lead-gen > * {
    z-index: 999;
  }
  :global(.bootstrap) .lead-gen .container-sm-none {
    display: none;
  }
  :global(.bootstrap) .lead-gen:after {
    position: absolute;
    top: 10px;
    bottom: 10px;
    left: -10px;
    right: -10px;
    content: " ";
    background: #FFF7CC;
    border-bottom: 1px solid #E5E6E1;
  }
}
:global(.bootstrap) .list-links a {
  display: block;
  padding-bottom: 20px;
  color: #848484;
}
:global(.bootstrap) .list-links a:hover:not(.disabled) {
  color: #5e5e5e;
}
:global(.bootstrap) .list-links a.disabled {
  color: #b7b7b7;
}
:global(.bootstrap) .list-links a[data-count] {
  position: relative;
  padding-right: 40px;
}
:global(.bootstrap) .list-links a[data-count]:after {
  content: "(" attr(data-count) ")";
  position: absolute;
  right: 0;
  top: 0;
}
:global(.bootstrap) .list-links.list-compact a {
  padding-bottom: 10px;
}
:global(.bootstrap) div:has(> .posting-card) {
  container: posting/inline-size;
}
:global(.bootstrap) .posting-card {
  position: relative;
}
:global(.bootstrap) .posting-card a.block-link:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  content: " ";
  cursor: pointer;
}
:global(.bootstrap) .posting-card a:not(.block-link), :global(.bootstrap) .posting-card a[onclick^=location] {
  position: relative;
  z-index: 2;
}
:global(.bootstrap) .posting-card :is(a:not(.block-link), div) [data-bs-toggle=tooltip], :global(.bootstrap) .posting-card i {
  position: relative;
  z-index: 2;
}
:global(.bootstrap) .posting-card p:empty, :global(.bootstrap) .posting-card :is(ul, ol, li, p) br:first-child, :global(.bootstrap) .posting-card :is(ul, ol, p, br, li) + br {
  display: none;
}
:global(.bootstrap) .posting-card p:empty + p {
  margin-top: 0;
}
:global(.bootstrap) .posting-card .date-lg {
  display: none;
}
@container posting (min-width: 1000px) {
  :global(.bootstrap) .posting-card {
    display: grid;
    grid-template-columns: 25% 75%;
    grid-template-rows: auto;
  }
  :global(.bootstrap) .posting-card .date-lg {
    display: flex;
  }
  :global(.bootstrap) .posting-card > .row:first-child {
    grid-column: 1;
    grid-row: span 3;
    align-self: start;
  }
  :global(.bootstrap) .posting-card > .row:first-child > * {
    width: 90%;
  }
  :global(.bootstrap) .posting-card > .row:first-child .user-card {
    width: 100%;
  }
  @media (min-width: 992px) {
    :global(.bootstrap) .posting-card > .row:first-child .user-card {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  :global(.bootstrap) .posting-card > .row:first-child .user-card .labels {
    padding-top: 2rem;
  }
  @media (max-width: 992px) {
    :global(.bootstrap) .posting-card > .row:first-child .user-card .labels {
      padding-top: 0.6rem;
    }
  }
  @media (min-width: 813px) {
    :global(.bootstrap) .posting-card > .row:first-child .user-card .user-details {
      flex-direction: column;
      align-items: flex-start !important;
    }
  }
  @media (max-width: 813px) {
    :global(.bootstrap) .posting-card > .row:first-child .user-card .user-details.user-details-mobile-vertical {
      flex-direction: column;
      align-items: center !important;
    }
    :global(.bootstrap) .posting-card > .row:first-child .user-card .user-details.user-details-mobile-vertical .details {
      text-align: center;
      margin-top: 5px;
    }
  }
  @media (max-width: 813px) {
    :global(.bootstrap) .posting-card > .row:first-child .user-card .user-details img {
      margin-right: 1rem;
    }
  }
  :global(.bootstrap) .posting-card > .row:first-child .user-card .user-details .details {
    width: 100%;
  }
  @media (min-width: 813px) {
    :global(.bootstrap) .posting-card > .row:first-child .user-card .user-details .details {
      margin: 10px 0;
      border-top: 1px solid #E5E6E1;
      padding-top: 10px;
    }
  }
  :global(.bootstrap) .posting-card > .row:first-child .user-card .user-details .name > * {
    font-weight: 600;
    font-size: 16px;
    color: #08090D;
  }
  :global(.bootstrap) .posting-card > .row:first-child .user-card .user-details .name a {
    color: #08090D !important;
    text-decoration: underline;
    text-decoration-color: #FFD700 !important;
    text-decoration-thickness: 1px !important;
    text-underline-offset: 1px;
  }
  :global(.bootstrap) .posting-card > .row:first-child .user-card .user-details .name a:hover {
    background: #FFD700;
    text-decoration: none !important;
  }
  :global(.bootstrap) .posting-card > .row:first-child .user-card .user-details .info {
    font-size: 12px;
    line-height: 18px;
    padding-top: 5px;
  }
  :global(.bootstrap) .posting-card > .row:first-child > :not(:has(.user-card)) {
    display: none;
  }
  :global(.bootstrap) .posting-card > .row:not(:first-child) {
    grid-column: 2;
  }
}
:global(.bootstrap) .branded-top-bar {
  padding-top: 15px;
  border-top: 1px solid #FFD700;
}
:global(.bootstrap) .report_image {
  box-sizing: border-box;
  font-family: "Lato", sans-serif;
  background-color: none;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
:global(.bootstrap) .report_image:not(.report-triple-thumb) {
  background: right url("https://images.peerspot.com/image/upload/f_auto,q_auto/v1707635957/reports/thumbnail_bg.png") no-repeat;
  max-width: 194px;
  box-shadow: 12px 12px 25px 0 rgba(50, 50, 50, 0.3);
  padding-top: min(137%, 271px);
  width: 100%;
  background-size: cover;
  margin: 0 auto 20px;
  justify-self: center;
}
:global(.bootstrap) .report_image:not(.report-triple-thumb) .report-inner-wrapper {
  padding: 65px 15px 10px;
}
:global(.bootstrap) .report_image:not(.report-triple-thumb) .report-title {
  font-size: 1.3rem;
}
:global(.bootstrap) .report_image:not(.report-triple-thumb) .report-title-md {
  font-size: 1rem;
  line-height: 1.4;
}
:global(.bootstrap) .report_image:not(.report-triple-thumb) .report-title-sm {
  font-size: 0.8rem;
  line-height: 1.4;
  margin: 3px 0;
}
@media (min-width: 576px) and (max-width: 992px) {
  :global(.bootstrap) .report_image:not(.report-triple-thumb) .report-title {
    font-size: 1.1rem;
  }
  :global(.bootstrap) .report_image:not(.report-triple-thumb) .report-title-md {
    font-size: 0.7rem;
    line-height: 1.4;
  }
  :global(.bootstrap) .report_image:not(.report-triple-thumb) .report-title-sm {
    font-size: 0.7rem;
    line-height: 1.4;
    margin: 3px 0;
  }
}
:global(.bootstrap) .report_image:not(.report-triple-thumb) .report-subtext {
  font-size: 14px;
}
@media (min-width: 576px) and (max-width: 992px) {
  :global(.bootstrap) .report_image:not(.report-triple-thumb) .report-subtext {
    font-size: 0.7rem;
  }
}
:global(.bootstrap) .report_image:not(.report-triple-thumb):after {
  content: "PDF";
  position: absolute;
  top: 15px;
  right: -5px;
  width: 55px;
  height: 30px;
  line-height: 1;
  font-weight: 600;
  font-size: 1.3rem;
  background-color: #bc0505;
  color: white;
  padding: 5px;
  text-align: center;
}
:global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-2 {
  flex: 0 0 auto;
}
:global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-2:first-child {
  transform: rotate(-10deg);
}
:global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-2:last-child {
  transform: rotate(10deg);
}
@media (min-width: 813px) {
  :global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-2:last-child {
    margin-left: -100px;
  }
}
@media (max-width: 813px) {
  :global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-2:last-child {
    margin-left: -30vw;
  }
}
:global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-3 {
  flex: 0 0 auto;
  overflow-x: hidden;
}
:global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-3:nth-child(1) {
  transform: rotate(-10deg);
  margin-right: -150px;
}
:global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-3:nth-child(2) {
  margin-top: -30px;
}
@media (min-width: 813px) {
  :global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-3:nth-child(2) {
    margin-right: -80px;
  }
  :global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-3:nth-child(2):after {
    display: none;
  }
}
@media (min-width: 576px) and (max-width: 813px) {
  :global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-3:nth-child(2) {
    margin-right: auto;
  }
}
@media (max-width: 576px) {
  :global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-3:nth-child(2) {
    margin-right: -80px;
  }
}
:global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-3:nth-child(3) {
  transform: rotate(10deg);
  overflow-x: visible;
  margin-top: 20px;
}
@media (min-width: 813px) {
  :global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-3:nth-child(3) {
    margin-left: -40px;
  }
}
@media (min-width: 576px) and (max-width: 813px) {
  :global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-3:nth-child(3) {
    margin-left: -20vw;
  }
}
@media (max-width: 576px) {
  :global(.bootstrap) .report_image:not(.report-triple-thumb).report-bundle-3:nth-child(3) {
    margin-left: -40px;
  }
}
@media (max-width: 576px) {
  :global(.bootstrap) .report_image.report-triple-thumb {
    background: right url("https://images.peerspot.com/image/upload/f_auto,q_auto/v1707635957/reports/thumbnail_bg.png") no-repeat;
    max-width: 194px;
    box-shadow: 12px 12px 25px 0 rgba(50, 50, 50, 0.3);
    padding-top: min(137%, 271px);
    width: 100%;
    background-size: cover;
    margin: 0 auto 20px;
    justify-self: center;
    margin: 0 !important;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-inner-wrapper {
    padding: 65px 15px 10px;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-title {
    font-size: 1.3rem;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-title-md {
    font-size: 1rem;
    line-height: 1.4;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-title-sm {
    font-size: 0.8rem;
    line-height: 1.4;
    margin: 3px 0;
  }
}
@media (max-width: 576px) and (min-width: 576px) and (max-width: 992px) {
  :global(.bootstrap) .report_image.report-triple-thumb .report-title {
    font-size: 1.1rem;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-title-md {
    font-size: 0.7rem;
    line-height: 1.4;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-title-sm {
    font-size: 0.7rem;
    line-height: 1.4;
    margin: 3px 0;
  }
}
@media (max-width: 576px) {
  :global(.bootstrap) .report_image.report-triple-thumb .report-subtext {
    font-size: 14px;
  }
}
@media (max-width: 576px) and (min-width: 576px) and (max-width: 992px) {
  :global(.bootstrap) .report_image.report-triple-thumb .report-subtext {
    font-size: 0.7rem;
  }
}
@media (max-width: 576px) {
  :global(.bootstrap) .report_image.report-triple-thumb:after {
    content: "PDF";
    position: absolute;
    top: 15px;
    right: -5px;
    width: 55px;
    height: 30px;
    line-height: 1;
    font-weight: 600;
    font-size: 1.3rem;
    background-color: #bc0505;
    color: white;
    padding: 5px;
    text-align: center;
  }
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-2 {
    flex: 0 0 auto;
  }
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-2:first-child {
    transform: rotate(-10deg);
  }
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-2:last-child {
    transform: rotate(10deg);
  }
}
@media (max-width: 576px) and (min-width: 813px) {
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-2:last-child {
    margin-left: -100px;
  }
}
@media (max-width: 576px) and (max-width: 813px) {
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-2:last-child {
    margin-left: -30vw;
  }
}
@media (max-width: 576px) {
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-3 {
    flex: 0 0 auto;
    overflow-x: hidden;
  }
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-3:nth-child(1) {
    transform: rotate(-10deg);
    margin-right: -150px;
  }
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-3:nth-child(2) {
    margin-top: -30px;
  }
}
@media (max-width: 576px) and (min-width: 813px) {
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-3:nth-child(2) {
    margin-right: -80px;
  }
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-3:nth-child(2):after {
    display: none;
  }
}
@media (max-width: 576px) and (min-width: 576px) and (max-width: 813px) {
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-3:nth-child(2) {
    margin-right: auto;
  }
}
@media (max-width: 576px) and (max-width: 576px) {
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-3:nth-child(2) {
    margin-right: -80px;
  }
}
@media (max-width: 576px) {
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-3:nth-child(3) {
    transform: rotate(10deg);
    overflow-x: visible;
    margin-top: 20px;
  }
}
@media (max-width: 576px) and (min-width: 813px) {
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-3:nth-child(3) {
    margin-left: -40px;
  }
}
@media (max-width: 576px) and (min-width: 576px) and (max-width: 813px) {
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-3:nth-child(3) {
    margin-left: -20vw;
  }
}
@media (max-width: 576px) and (max-width: 576px) {
  :global(.bootstrap) .report_image.report-triple-thumb.report-bundle-3:nth-child(3) {
    margin-left: -40px;
  }
}
@media (max-width: 576px) {
  :global(.bootstrap) .report_image.report-triple-thumb .report-inner-wrapper {
    padding: 35px 8px 5px !important;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-title, :global(.bootstrap) .report_image.report-triple-thumb .report-subtext {
    font-size: 0.6rem !important;
    line-height: 1.3;
    margin: 0;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .ps-logo {
    margin-top: 1%;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .ps-logo img {
    height: 15px;
    width: auto;
  }
  :global(.bootstrap) .report_image.report-triple-thumb:after {
    width: 30px !important;
    height: 15px !important;
    font-weight: 400 !important;
    font-size: 0.7rem !important;
    padding: 2px !important;
  }
}
@media (max-width: 576px) and (min-width: 410px) {
  :global(.bootstrap) .report_image.report-triple-thumb .report-title, :global(.bootstrap) .report_image.report-triple-thumb .report-subtext {
    font-size: 0.9rem !important;
    line-height: 1.4;
  }
  :global(.bootstrap) .report_image.report-triple-thumb:after {
    width: 35px;
    height: 22px;
    font-weight: 600;
    font-size: 0.9rem;
    padding: 4px;
  }
}
@media (min-width: 576px) {
  :global(.bootstrap) .report_image.report-triple-thumb {
    background: center url(../../images/reports/triple_thumbnail_bg.webp) no-repeat;
    padding-top: min(137%, 310px);
    align-items: flex-end;
    width: min(100%, 416px);
    background-size: min(100%, 416px);
    margin: 0 auto;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-inner-wrapper {
    max-width: 160px;
    transform: rotate(10deg);
    padding: 100px 15px 50px;
    margin-right: 30px;
    /* Fixes for specific points where the text overlay breaks */
  }
}
@media (min-width: 576px) and (min-width: 813px) and (max-width: 865px), (min-width: 576px) and (min-width: 992px) and (max-width: 1050px) {
  :global(.bootstrap) .report_image.report-triple-thumb .report-inner-wrapper {
    max-width: 150px;
    padding: 100px 10px 60px;
    margin-right: 25px;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-inner-wrapper:has(.report-title-sm) {
    max-width: 145px;
    margin-right: 30px;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-inner-wrapper:has(.report-title-md) {
    margin-right: 23px;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-inner-wrapper .report-title-md {
    font-size: 0.8rem;
    line-height: 1.3;
    margin: 3px 0;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-inner-wrapper .report-title-sm {
    font-size: 0.7rem;
    line-height: 1.3;
    margin: 3px 0;
  }
}
@media (min-width: 576px) {
  :global(.bootstrap) .report_image.report-triple-thumb .report-title {
    font-size: 1rem;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-title-md {
    font-size: 0.9rem;
    line-height: 1.4;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-title-sm {
    font-size: 0.8rem;
    line-height: 1.4;
    margin: 3px 0;
  }
  :global(.bootstrap) .report_image.report-triple-thumb .report-subtext {
    font-size: 12px;
  }
}
:global(.bootstrap) .report_image .report-inner-wrapper {
  position: absolute;
  text-decoration: none;
  text-align: left;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
:global(.bootstrap) .report_image .report-cover-txt {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
:global(.bootstrap) .report_image img.generic {
  margin: -20px;
}
:global(.bootstrap) .report_image:hover {
  text-decoration: none;
  background-color: transparent !important;
}
:global(.bootstrap) .report_image .report-subtext {
  color: #A9A9A9;
}
:global(.bootstrap) .report_image .report-title {
  color: #08090D;
  line-height: 1.2;
  font-weight: 600;
}
:global(.bootstrap) .report_image .ps-logo {
  text-align: center;
  margin-top: 10px;
}
:global(.bootstrap) .block-link-element {
  position: relative;
}
:global(.bootstrap) .block-link-element a.block-link:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  content: " ";
  cursor: pointer;
}
:global(.bootstrap) .block-link-element a:not(.block-link), :global(.bootstrap) .block-link-element a[onclick^=location] {
  position: relative;
  z-index: 2;
}
:global(.bootstrap) .block-link-element :is(a:not(.block-link), div) [data-bs-toggle=tooltip], :global(.bootstrap) .block-link-element i {
  position: relative;
  z-index: 2;
}
:global(.bootstrap) .badge {
  margin: 0 0.5em 0.5em 0;
  text-transform: uppercase;
}
:global(.bootstrap) .badge i {
  margin-right: 0.375rem;
}
:global(.bootstrap) .badge-real-user, :global(.bootstrap) .badge-user, :global(.bootstrap) .badge-msp, :global(.bootstrap) .badge-reseller {
  background: #6ffaaf;
  color: #06b054;
}
:global(.bootstrap) .badge-community-manager {
  background: #ffefe3;
  color: #fd8733;
}
:global(.bootstrap) .badge-vendor {
  background: #cabfdd;
  color: #6c5298;
}
:global(.bootstrap) .badge-outlined {
  background: transparent;
}
:global(.bootstrap) .badge-outlined.badge-primary {
  border: 1px solid #FFD700;
  color: #FFD700;
}
:global(.bootstrap) .badge-outlined.badge-secondary {
  border: 1px solid #08090D;
  color: #08090D;
}
:global(.bootstrap) .badge-outlined.badge-success {
  border: 1px solid #07C960;
  color: #07C960;
}
:global(.bootstrap) .badge-outlined.badge-info {
  border: 1px solid #785CA7;
  color: #785CA7;
}
:global(.bootstrap) .badge-outlined.badge-warning {
  border: 1px solid #FD964C;
  color: #FD964C;
}
:global(.bootstrap) .badge-outlined.badge-danger {
  border: 1px solid #bc0505;
  color: #bc0505;
}
:global(.bootstrap) .badge-outlined.badge-light {
  border: 1px solid #F5F5F5;
  color: #F5F5F5;
}
:global(.bootstrap) .badge-outlined.badge-medium {
  border: 1px solid #848484;
  color: #848484;
}
:global(.bootstrap) .badge-outlined.badge-dark {
  border: 1px solid #4D4D4D;
  color: #4D4D4D;
}
:global(.bootstrap) .badge-outlined.badge-pro {
  border: 1px solid #07C960;
  color: #07C960;
}
:global(.bootstrap) .badge-outlined.badge-con {
  border: 1px solid #bc0505;
  color: #bc0505;
}
:global(.bootstrap) .css-avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--avatar_size);
  height: var(--avatar_size);
  margin-right: 1rem;
  font-size: min(var(--avatar_size) * 0.4, 15px);
  border-radius: 50%;
  background-color: #E5E6E1;
  color: #4D4D4D;
}
:global(.bootstrap) .avatar-palette:nth-child(10n+1 of .avatar-palette) .css-avatar {
  color: #A97F13;
  background-color: #FFF8E8;
  border: 1px solid #E5E6E1;
}
:global(.bootstrap) .avatar-palette:nth-child(10n+2 of .avatar-palette) .css-avatar {
  color: #1B7070;
  background-color: #EBFFFF;
  border: 1px solid #E5E6E1;
}
:global(.bootstrap) .avatar-palette:nth-child(10n+3 of .avatar-palette) .css-avatar {
  color: #BD9B13;
  background-color: #FFF7CC;
  border: 1px solid #E5E6E1;
}
:global(.bootstrap) .avatar-palette:nth-child(10n+4 of .avatar-palette) .css-avatar {
  color: #093A5A;
  background-color: #E4F4FF;
  border: 1px solid #E5E6E1;
}
:global(.bootstrap) .avatar-palette:nth-child(10n+5 of .avatar-palette) .css-avatar {
  color: #B44B00;
  background-color: #FFECDE;
  border: 1px solid #E5E6E1;
}
:global(.bootstrap) .avatar-palette:nth-child(10n+6 of .avatar-palette) .css-avatar {
  color: #007A38;
  background-color: #ECFBF3;
  border: 1px solid #E5E6E1;
}
:global(.bootstrap) .avatar-palette:nth-child(10n+7 of .avatar-palette) .css-avatar {
  color: #A31300;
  background-color: #F9EFEE;
  border: 1px solid #E5E6E1;
}
:global(.bootstrap) .avatar-palette:nth-child(10n+8 of .avatar-palette) .css-avatar {
  color: #3E216F;
  background-color: #F0E7FF;
  border: 1px solid #E5E6E1;
}
:global(.bootstrap) .avatar-palette:nth-child(10n+9 of .avatar-palette) .css-avatar {
  color: #674F3D;
  background-color: #EDE3DB;
  border: 1px solid #E5E6E1;
}
:global(.bootstrap) .avatar-palette:nth-child(10n+10 of .avatar-palette) .css-avatar {
  color: #B9003C;
  background-color: #FFDFEA;
  border: 1px solid #E5E6E1;
}
:global(.bootstrap) .avatar-gallery {
  display: flex;
  align-items: center;
}
:global(.bootstrap) .avatar-gallery .css-avatar, :global(.bootstrap) .avatar-gallery img {
  margin: 0 0 0 -10px;
}
:global(.bootstrap) .avatar-gallery .css-avatar:first-child, :global(.bootstrap) .avatar-gallery img:first-child {
  margin-left: 0;
}
:global(.bootstrap) .avatar-gallery img {
  box-shadow: -1px 1px 0px 0px rgba(0, 0, 0, 0.15);
  border: 1px solid white;
}
:global(.bootstrap) .redactor-box {
  width: 100%;
  flex-grow: 1;
}
:global(.bootstrap) .remove-item {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
:global(.bootstrap) .remove-item-input {
  right: 25px;
  top: 22%;
}
:global(.bootstrap) .remove-item-video {
  color: white;
  top: 10px;
  right: 25px;
}
:global(.bootstrap) .remove-item:before {
  font-family: "Font Awesome 6 Pro";
  font-weight: 400;
  content: "\f00d";
}
:global(.bootstrap) p > br {
  display: none;
}
:global(.bootstrap) .content-cleanup :is(h1, :global(.bootstrap) .h1, h2, :global(.bootstrap) .h2, h3, :global(.bootstrap) .h3, h4, :global(.bootstrap) .h4, h5, :global(.bootstrap) .h5, h6, :global(.bootstrap) .h6) {
  font-size: 16px;
  font-family: "Lato", sans-serif;
  font-weight: 700;
}
:global(.bootstrap) .search-form {
  padding: 10px 13px 10px 20px;
  border: 1px solid #E5E6E1;
  border-radius: 2px;
  position: relative;
}
:global(.bootstrap) .search-form .system-search-form form {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
:global(.bootstrap) .search-form .system-search-form input {
  color: #4D4D4D;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  box-sizing: border-box;
  border: 0;
  background: transparent;
  flex-grow: 1;
  font-size: 16px;
}
:global(.bootstrap) .search-form .system-search-form input::placeholder {
  color: #848484;
}
:global(.bootstrap) .search-form .system-search-form input:focus-visible {
  outline: none;
}
:global(.bootstrap) .search-form .system-search-form .search-submit {
  font-size: 20px;
  cursor: pointer;
}
:global(.bootstrap) .search-form .system-search-form .search-close {
  color: #4D4D4D;
  font-size: 16px;
  cursor: pointer;
  margin-right: 1em;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions {
  background: #FFFFFF;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1607843137);
  overflow: auto;
  top: 100%;
  left: 0;
  width: 100% !important;
  padding: 10px 0;
  box-sizing: border-box;
  text-align: left;
  /* Handle */
  /* Track */
}
@media (min-width: 813px) {
  :global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions {
    margin-top: 8px;
  }
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions::-webkit-scrollbar {
  max-width: 5px;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions::-webkit-scrollbar-thumb {
  background-color: #E5E6E1;
  border-radius: 10%;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions::-webkit-scrollbar-track {
  background-color: #FAFAFA;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions .autocomplete-suggestion {
  font-size: 15px;
  cursor: pointer;
  line-height: 1.2;
  color: #4D4D4D;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions .autocomplete-suggestion:not(:has(a)) {
  padding: 5px 15px;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions .autocomplete-suggestion a {
  display: block;
  width: 100%;
  padding: 5px 15px;
  color: #4D4D4D;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions .autocomplete-suggestion a:hover {
  background: #F5F5F5;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions .autocomplete-suggestion strong {
  font-weight: 600;
  color: #4D4D4D;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions .autocomplete-selected {
  background: #F5F5F5;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions .autocomplete-group {
  padding: 10px 15px;
  color: #848484;
  text-transform: uppercase;
  font-size: 13px;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions .autocomplete-group strong {
  display: block;
  border-bottom: 1px solid #E5E6E1;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions .autocomplete-group:not(:first-of-type) {
  border-top: 1px solid #E5E6E1;
  margin-top: 10px;
  padding-top: 20px;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions .autocomplete-group:empty {
  padding-top: 0;
}
:global(.bootstrap) .search-form .system-search-form .search-close {
  display: none;
}
:global(.bootstrap) .search-form .system-search-form .autocomplete-suggestions {
  margin-top: 1px;
}
:global(.bootstrap) .search .autocomplete-suggestions {
  background: #FFFFFF;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1607843137);
  overflow: auto;
  top: 100%;
  left: 0;
  width: 100% !important;
  padding: 10px 0;
  box-sizing: border-box;
  text-align: left;
  /* Handle */
  /* Track */
}
@media (min-width: 813px) {
  :global(.bootstrap) .search .autocomplete-suggestions {
    margin-top: 8px;
  }
}
:global(.bootstrap) .search .autocomplete-suggestions::-webkit-scrollbar {
  max-width: 5px;
}
:global(.bootstrap) .search .autocomplete-suggestions::-webkit-scrollbar-thumb {
  background-color: #E5E6E1;
  border-radius: 10%;
}
:global(.bootstrap) .search .autocomplete-suggestions::-webkit-scrollbar-track {
  background-color: #FAFAFA;
}
:global(.bootstrap) .search .autocomplete-suggestions .autocomplete-suggestion {
  font-size: 15px;
  cursor: pointer;
  line-height: 1.2;
  color: #4D4D4D;
}
:global(.bootstrap) .search .autocomplete-suggestions .autocomplete-suggestion:not(:has(a)) {
  padding: 5px 15px;
}
:global(.bootstrap) .search .autocomplete-suggestions .autocomplete-suggestion a {
  display: block;
  width: 100%;
  padding: 5px 15px;
  color: #4D4D4D;
}
:global(.bootstrap) .search .autocomplete-suggestions .autocomplete-suggestion a:hover {
  background: #F5F5F5;
}
:global(.bootstrap) .search .autocomplete-suggestions .autocomplete-suggestion strong {
  font-weight: 600;
  color: #4D4D4D;
}
:global(.bootstrap) .search .autocomplete-suggestions .autocomplete-selected {
  background: #F5F5F5;
}
:global(.bootstrap) .search .autocomplete-suggestions .autocomplete-group {
  padding: 10px 15px;
  color: #848484;
  text-transform: uppercase;
  font-size: 13px;
}
:global(.bootstrap) .search .autocomplete-suggestions .autocomplete-group strong {
  display: block;
  border-bottom: 1px solid #E5E6E1;
}
:global(.bootstrap) .search .autocomplete-suggestions .autocomplete-group:not(:first-of-type) {
  border-top: 1px solid #E5E6E1;
  margin-top: 10px;
  padding-top: 20px;
}
:global(.bootstrap) .search .autocomplete-suggestions .autocomplete-group:empty {
  padding-top: 0;
}
@media (max-width: 813px) {
  :global(.bootstrap) .scroll-nav:before {
    content: "\f054";
    font-family: "Font Awesome 6 Pro";
    font-size: 15px;
    font-weight: 300;
    color: #08090D;
    position: absolute;
    right: 0;
    width: 20px;
    height: 20px;
    margin-top: -33px;
    cursor: pointer;
  }
  :global(.bootstrap) .scroll-nav-left:before {
    content: "\f053";
    left: 0;
    right: unset;
    margin-top: 8px;
    padding-left: 10px;
  }
}
:global(.bootstrap) .after-topbar {
  top: -120px;
}
:global(.bootstrap) .after-stickybar {
  top: -47px;
}
:global(.bootstrap) .sticky {
  display: none;
}
:global(.bootstrap) .sticky.stick {
  display: block;
  position: fixed;
  top: 0;
  z-index: 1080;
}
@media (min-width: 813px) {
  :global(.bootstrap) .sticky-topbartabs {
    top: 145px !important;
  }
  :global(.bootstrap) .sticky-topbar {
    top: 85px !important;
  }
  :global(.bootstrap) .sticky-stickybar {
    top: 50px !important;
  }
}
@media (max-width: 813px) {
  :global(.bootstrap) .sticky-topbar, :global(.bootstrap) .sticky-stickybar {
    top: 50px !important;
  }
}
:global(.bootstrap) div:has(> .collapsible) {
  cursor: text;
}
:global(.bootstrap) .collapsible {
  position: relative;
  transition: all 300ms ease-out;
  --zero: 0px;
  pointer-events: none;
}
:global(.bootstrap) .collapsible a {
  pointer-events: auto !important;
  position: unset !important;
}
:global(.bootstrap) .collapsible:not(.open) {
  overflow: hidden;
}
:global(.bootstrap) .collapsible:not(.open):not(.collapsible-by-height) {
  line-clamp: var(--collapsible-show-lines);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--collapsible-show-lines);
}
:global(.bootstrap) .collapsible:not(.open):not(.collapsible-by-height) :is(p, ul, ol, li, ul br) {
  display: inline; /* fix for safari and FF */
}
:global(.bootstrap) .collapsible:not(.open):before {
  position: absolute;
  content: "";
  bottom: min(var(--zero), (100% + 5px - var(--collapsible-show-lines) * var(--collapsible-line-height)) * 999);
  height: var(--collapsible-overlay-height);
  width: 100%;
  background: linear-gradient(to bottom, var(--collapsible-overlay-color-start), var(--collapsible-overlay-color-end) 95%);
}
:global(.bootstrap) .collapsible:not(.open):not(.collapsible-hide-toggle):after {
  content: var(--collapsible-more);
  bottom: min(var(--zero), (100% + 5px - var(--collapsible-show-lines) * var(--collapsible-line-height)) * 999);
  left: 0;
}
:global(.bootstrap) .collapsible:not(.open).collapsible-by-height {
  max-height: calc(var(--collapsible-show-lines) * var(--collapsible-line-height));
}
:global(.bootstrap) .collapsible.open {
  height: auto;
  padding-bottom: 35px;
}
:global(.bootstrap) .collapsible.open.collapsible-toggle-button {
  padding-bottom: 65px;
}
:global(.bootstrap) .collapsible.open:not(.collapsible-hide-toggle):after {
  content: var(--collapsible-less);
  bottom: min(var(--zero), (100% + 5px - var(--collapsible-show-lines) * var(--collapsible-line-height)) * 999);
  left: 0;
}
:global(.bootstrap) .collapsible.collapsible-end:before {
  right: 0;
  width: 60% !important;
  height: var(--collapsible-line-height) !important;
  background: linear-gradient(to right, var(--collapsible-overlay-color-start), var(--collapsible-overlay-color-end) 70%) !important;
}
:global(.bootstrap) .collapsible.collapsible-end:not(.collapsible-hide-toggle):after {
  right: 0;
  left: unset;
}
:global(.bootstrap) .collapsible.collapsible-center:after {
  right: 0;
  left: 0;
  text-align: center;
  margin: 0 auto;
}
:global(.bootstrap) .collapsible:not(.collapsible-hide-toggle):after {
  position: absolute;
  z-index: 1070;
  pointer-events: all;
  width: auto;
  font-size: 16px;
  font-weight: bold;
  font-family: "Lato", sans-serif;
  color: #08090D !important;
  text-decoration: underline;
  text-decoration-color: #FFD700 !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 1px;
}
:global(.bootstrap) .collapsible:not(.collapsible-hide-toggle):after:hover {
  background: #FFD700;
  text-decoration: none !important;
}
:global(.bootstrap) .collapsible:not(.collapsible-hide-toggle):hover:after {
  background: #FFD700;
  text-decoration: none;
  cursor: pointer !important;
}
:global(.bootstrap) .collapsible:not(.collapsible-hide-toggle):has(a:hover):after {
  background: none !important; /* Remove hover styles if links are hovered over */
  text-decoration: underline;
}
:global(.bootstrap) .collapsible.collapsible-toggle-button:after {
  width: min(250px, 100vw) !important;
  text-decoration: none;
  background: #fff;
  border: 1px solid #08090D;
  border-radius: 3px;
  padding: 10px 0;
}
:global(.bootstrap) .collapsible.collapsible-toggle-button:hover:after {
  background: #ffeb80;
}
:global(.bootstrap) .rating i {
  margin-right: clamp(0.1rem, 0.2vw, 0.3rem);
  font-size: clamp(0.85rem, 2vw, 1rem);
}
:global(.bootstrap) .iti {
  display: block !important;
}
:global(.bootstrap) .iti .iti__search-input {
  padding: 0.5em;
}
:global(.bootstrap) .iti .iti__search-input:focus-visible {
  outline: none;
}
:global(.bootstrap) .intl-tel-input .arrow {
  pointer-events: none;
}
:global(.bootstrap) .list-with-checks, :global(.bootstrap) .list-with-primary-checks {
  display: flex;
  flex-flow: column wrap;
  text-align: left;
  row-gap: 10px;
}
:global(.bootstrap) .list-with-checks div, :global(.bootstrap) .list-with-primary-checks div {
  font-size: 16px;
  color: #08090D;
}
:global(.bootstrap) .list-with-checks div:before, :global(.bootstrap) .list-with-primary-checks div:before {
  color: #70CACA;
  font-size: 12px;
  font-family: "Font Awesome 6 Pro";
  font-weight: 400;
  content: "\f00c";
  padding-right: 25px;
}
:global(.bootstrap) .list-with-primary-checks div {
  display: flex;
  align-items: baseline;
}
:global(.bootstrap) .list-with-primary-checks div:before {
  display: inline-block;
  background: center url("../../images/v.png") no-repeat;
  height: 13px;
  width: 40px;
  font-family: unset;
  content: "";
  padding: 0;
  margin-right: 10px;
}
:global(.bootstrap) .remove-links a {
  color: currentColor !important;
  cursor: not-allowed;
  text-decoration: none !important;
}
:global(.bootstrap) .modal-lead-sizing {
  height: clamp(570px, 62vh, 100%);
}
:global(.bootstrap) .break {
  flex-basis: 100%;
  height: 0;
}
:global(.bootstrap) .product-img-fluid {
  width: clamp(40px, 15vw, 100px);
  height: clamp(40px, 15vw, 100px);
}
:global(.bootstrap) .dropdown-filter {
  font-family: "Lato", sans-serif;
}
:global(.bootstrap) .dropdown-filter .dropdown-toggle {
  display: flex;
  padding: 12px 0;
  position: relative;
  transition: all 0.4s;
  font-size: 1rem;
  font-weight: 700;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  color: #4D4D4D;
}
:global(.bootstrap) .dropdown-filter .dropdown-toggle:hover {
  color: #343434;
}
:global(.bootstrap) .dropdown-filter.show {
  z-index: 3; /* to prevent collapsed left menu on hover from going behind the PeerQuotes filters */
}
:global(.bootstrap) .dropdown-filter .filters-dropdown-menu {
  position: relative;
  width: 100%;
  box-shadow: none;
  border: none;
  padding: 0px;
  font-size: 0.8rem;
  overflow: hidden;
  overflow-y: auto;
}
:global(.bootstrap) .dropdown-filter .filters-dropdown-menu > ul {
  margin-bottom: 0px;
}
:global(.bootstrap) .dropdown-filter .filters-dropdown-menu:hover::-webkit-scrollbar-thumb {
  background-color: rgba(108, 117, 125, 0.3137254902);
}
:global(.bootstrap) .dropdown-filter .filters-dropdown-menu .dropdown-item {
  padding: 5px 0;
  display: block;
  position: relative;
  transition: all 0.4s;
  cursor: pointer;
  color: #08090D;
}
:global(.bootstrap) .dropdown-filter .filters-dropdown-menu .dropdown-item:hover {
  color: #4D4D4D;
  background-color: initial;
}
:global(.bootstrap) a#to-top {
  width: 40px;
  height: 40px;
  display: flex;
  background-color: rgba(232, 233, 234, 0.76);
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  position: fixed;
  bottom: 40px;
  right: 8%;
  transition: all 250ms linear;
}
:global(.bootstrap) a#to-top:hover {
  background-color: rgba(232, 233, 234, 0.96);
}
:global(.bootstrap) a#to-top:after {
  content: "";
  border: 2.5px solid #fff;
  border-bottom: 0;
  border-right: 0;
  border-radius: 2px;
  margin-top: 5px;
  width: 15px;
  height: 15px;
  transform: rotate(45deg);
}
:global(.bootstrap) .spyscroll-wrapper {
  position: relative;
  height: 500px;
  overflow: auto;
  padding: 0 10px;
}
:global(.bootstrap) .content-styling {
  font-weight: 300;
  letter-spacing: 0.3px;
}
:global(.bootstrap) .gitb-revealable {
  display: none;
}
@media (min-width: 813px) {
  :global(.bootstrap) .row:has(.hero-thumbnail) {
    position: relative;
    min-height: 320px;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .hero-thumbnail {
    position: absolute;
    right: 20px;
    bottom: -40px;
  }
}
@media (max-width: 813px) {
  :global(.bootstrap) .hero-thumbnail {
    display: none;
  }
}
@media (max-width: 813px) {
  :global(.bootstrap) .gallery {
    width: 100vw;
  }
}
:global(.bootstrap) .gallery .gallery-items {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
}
:global(.bootstrap) .gallery .gallery-items > * > * {
  height: 100%;
}
@media (max-width: 813px) {
  :global(.bootstrap) .gallery .gallery-items {
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    scroll-padding-left: 24px;
    box-sizing: border-box;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  :global(.bootstrap) .gallery .gallery-items::-webkit-scrollbar {
    display: none;
  }
  :global(.bootstrap) .gallery .gallery-items > * {
    scroll-snap-align: start;
    display: inline-block;
  }
  :global(.bootstrap) .gallery .gallery-items > *:first-child {
    box-sizing: content-box;
  }
  :global(.bootstrap) .gallery .gallery-items > *:first-child > * {
    margin-left: 24px;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .gallery .gallery-nav {
    display: none;
  }
}
@media (max-width: 813px) {
  :global(.bootstrap) .gallery .gallery-nav {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    gap: 20px;
    margin-top: 30px;
  }
  :global(.bootstrap) .gallery .gallery-nav > * {
    appearance: none;
    border: 0;
    background: none;
  }
  :global(.bootstrap) .gallery .gallery-nav > *:before {
    font-family: "Font Awesome 6 Pro";
    font-size: 15px;
    font-weight: 900;
    color: #adb5bd;
    content: "\f111";
    cursor: pointer;
  }
  :global(.bootstrap) .gallery .gallery-nav > *.active:before {
    color: #4D4D4D;
  }
}
:global(.bootstrap) .branded-flag {
  position: relative;
}
:global(.bootstrap) .branded-flag-end:after {
  position: absolute;
  content: "";
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
  border-bottom: var(--flag-size) solid var(--flag-color);
  border-left: var(--flag-size) solid transparent;
}
:global(.bootstrap) .branded-flag:not(-end):after {
  position: absolute;
  content: "";
  bottom: -var(--flag-size);
  left: 0;
  width: 0;
  height: 0;
  border-top: var(--flag-size) solid var(--flag-color);
  border-right: var(--flag-size) solid transparent;
}
:global(.bootstrap) .branded-flag:not(-end).flag-quote:after {
  bottom: calc(var(--flag-size) * -1);
  left: var(--flag-size);
}
:global(.bootstrap) .hover-play-icon {
  --play-icon-color: white;
  --play-icon-size: 60px;
  position: relative;
  z-index: 1;
}
:global(.bootstrap) .hover-play-icon:before {
  z-index: 10;
  content: "";
  font-family: "Font Awesome 6 Pro";
  font-size: var(--play-icon-size);
  font-weight: 900;
  color: var(--play-icon-color);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
:global(.bootstrap) .hover-play-icon:hover:before {
  content: "\f144";
  cursor: pointer;
}
:global(.bootstrap) .gitb-dynamic-video {
  cursor: pointer;
  border-top-left-radius: var(--bs-border-radius);
  border-top-right-radius: var(--bs-border-radius);
}
:global(.bootstrap) .gitb-dynamic-video:hover {
  opacity: 0.8;
}
:global(.bootstrap) .gitb-dynamic-video:hover .gitb-yt-play-button:before {
  color: #ff4d4d;
}
:global(.bootstrap) .gitb-yt-play-button:before {
  z-index: 10;
  font-family: "Font Awesome 6 Brands";
  content: "\f167";
  font-size: 60px;
  font-weight: 900;
  color: #FF0000;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
:global(.bootstrap) .gitb-yt-play-button:after {
  z-index: 9;
  content: "";
  width: 20px;
  height: 20px;
  background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
:global(.bootstrap) .scroll-sync {
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  transition: height 0.5s ease;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
:global(.bootstrap) .scroll-sync::-webkit-scrollbar {
  display: none;
}
:global(.bootstrap) .scroll-sync > * {
  scroll-snap-align: start;
}
:global(.bootstrap) .divider-horizontal {
  width: 100%;
  height: 1px;
  background: #E5E6E1;
}
:global(.bootstrap) .divider-horizontal.with-overlay {
  position: relative;
}
:global(.bootstrap) .divider-horizontal.with-overlay:before {
  position: absolute;
  content: var(--divider-overlay-txt);
  background-color: var(--divider-overlay-bg);
  color: #A9A9A9;
  font-size: 14px;
  padding: 0 0.75em;
  left: 50%;
  transform: translate(-50%, -50%);
}
:global(.bootstrap) .legend-marker {
  height: 5px;
  width: 20px;
  display: inline-block;
  border-radius: 0.25rem;
  margin-right: 0.5rem;
  vertical-align: middle;
}
:global(.bootstrap) .sortable th:not([data-sortable=false]) {
  cursor: pointer;
}
:global(.bootstrap) .sortable th:not([data-sortable=false]):after {
  font-family: "Font Awesome 6 Pro";
  font-weight: 300;
  content: "\f07d";
  color: #4D4D4D;
  margin-left: 10px;
  font-size: 13px;
}
:global(.bootstrap) audio {
  max-width: 100%;
}
:global(.bootstrap) audio.primary::-webkit-media-controls-panel {
  background: #FFD700;
}
:global(.bootstrap) audio.white::-webkit-media-controls-panel {
  background: #fff;
  padding: auto 0;
}
:global(.bootstrap) audio.light::-webkit-media-controls-panel {
  background: #FAFAFA;
  padding: auto 0;
}
:global(.bootstrap) audio.transparent-dark {
  filter: invert(1) hue-rotate(180deg) brightness(0.85) contrast(1.2); /* Adjust controls to white */
  background-color: transparent !important;
  color: white;
  outline: none !important;
  border: none !important;
  border-radius: 0 !important;
  -webkit-appearance: none;
  appearance: none;
  padding: 0;
  margin: 0;
  /* Remove border-radius from WebKit media controls */
}
:global(.bootstrap) audio.transparent-dark::-webkit-media-controls-panel {
  outline: none !important;
  border: none !important;
  border-radius: 0 !important;
  background-color: transparent !important;
  color: white;
  padding: 0 !important;
  margin: 0 !important;
}
:global(.bootstrap) audio.transparent-dark::-webkit-media-controls, :global(.bootstrap) audio.transparent-dark::-webkit-media-controls-enclosure {
  border-radius: 0 !important;
  color: white;
  background-color: transparent !important;
}
:global(.bootstrap) audio.transparent-dark::-webkit-media-controls-timeline, :global(.bootstrap) audio.transparent-dark::-webkit-media-controls-play-button, :global(.bootstrap) audio.transparent-dark::-webkit-media-controls-volume-slider-container {
  border-radius: 0 !important;
  color: white;
}
:global(.bootstrap) audio.dark::-webkit-media-controls-panel {
  background: #4D4D4D;
  color: white;
  padding: auto 0;
}
:global(.bootstrap) audio.dark::-webkit-media-controls-play-button, :global(.bootstrap) audio.dark::-webkit-media-controls-volume-slider, :global(.bootstrap) audio.dark::-webkit-media-controls-timeline, :global(.bootstrap) audio.dark::-webkit-media-controls-current-time-display, :global(.bootstrap) audio.dark::-webkit-media-controls-time-remaining-display {
  color: white;
}
:global(.bootstrap) .filler-dots {
  flex-grow: 1;
  overflow: hidden;
}
:global(.bootstrap) .filler-dots::after {
  content: "........................................................................................";
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:global(.bootstrap) .branding-p {
  z-index: 1;
  top: 0;
}
@media (min-width: 813px) {
  :global(.bootstrap) .branding-p.branding-p-xl {
    width: 180px;
    height: 180px;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-primary, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-primary {
    background: #FFD700;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-primary:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-primary:before {
    position: absolute;
    content: "";
    bottom: -90px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 90px solid #FFD700;
    border-right: 90px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-secondary, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-secondary {
    background: #08090D;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-secondary:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-secondary:before {
    position: absolute;
    content: "";
    bottom: -90px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 90px solid #08090D;
    border-right: 90px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-success, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-success {
    background: #07C960;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-success:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-success:before {
    position: absolute;
    content: "";
    bottom: -90px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 90px solid #07C960;
    border-right: 90px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-info, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-info {
    background: #785CA7;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-info:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-info:before {
    position: absolute;
    content: "";
    bottom: -90px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 90px solid #785CA7;
    border-right: 90px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-warning, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-warning {
    background: #FD964C;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-warning:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-warning:before {
    position: absolute;
    content: "";
    bottom: -90px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 90px solid #FD964C;
    border-right: 90px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-danger, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-danger {
    background: #bc0505;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-danger:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-danger:before {
    position: absolute;
    content: "";
    bottom: -90px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 90px solid #bc0505;
    border-right: 90px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-light, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-light {
    background: #F5F5F5;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-light:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-light:before {
    position: absolute;
    content: "";
    bottom: -90px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 90px solid #F5F5F5;
    border-right: 90px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-medium, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-medium {
    background: #848484;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-medium:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-medium:before {
    position: absolute;
    content: "";
    bottom: -90px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 90px solid #848484;
    border-right: 90px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-dark, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-dark {
    background: #4D4D4D;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-dark:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-dark:before {
    position: absolute;
    content: "";
    bottom: -90px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 90px solid #4D4D4D;
    border-right: 90px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-pro, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-pro {
    background: #07C960;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-pro:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-pro:before {
    position: absolute;
    content: "";
    bottom: -90px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 90px solid #07C960;
    border-right: 90px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-con, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-con {
    background: #bc0505;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-con:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-con:before {
    position: absolute;
    content: "";
    bottom: -90px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 90px solid #bc0505;
    border-right: 90px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl.with-border {
    border-right: 10px solid white;
    border-bottom: 10px solid white;
  }
  :global(.bootstrap) .branding-p.branding-p-xl.with-border:after {
    position: absolute;
    content: "";
    top: 180px;
    z-index: -1;
    left: 0;
    width: 0;
    height: 0;
    border-top: 95px solid white;
    border-right: 95px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl i {
    font-size: 50px;
  }
}
@media (max-width: 812px) {
  :global(.bootstrap) .branding-p.branding-p-xl {
    width: 72px;
    height: 72px;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-primary, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-primary {
    background: #FFD700;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-primary:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-primary:before {
    position: absolute;
    content: "";
    bottom: -36px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 36px solid #FFD700;
    border-right: 36px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-secondary, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-secondary {
    background: #08090D;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-secondary:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-secondary:before {
    position: absolute;
    content: "";
    bottom: -36px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 36px solid #08090D;
    border-right: 36px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-success, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-success {
    background: #07C960;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-success:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-success:before {
    position: absolute;
    content: "";
    bottom: -36px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 36px solid #07C960;
    border-right: 36px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-info, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-info {
    background: #785CA7;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-info:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-info:before {
    position: absolute;
    content: "";
    bottom: -36px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 36px solid #785CA7;
    border-right: 36px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-warning, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-warning {
    background: #FD964C;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-warning:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-warning:before {
    position: absolute;
    content: "";
    bottom: -36px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 36px solid #FD964C;
    border-right: 36px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-danger, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-danger {
    background: #bc0505;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-danger:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-danger:before {
    position: absolute;
    content: "";
    bottom: -36px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 36px solid #bc0505;
    border-right: 36px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-light, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-light {
    background: #F5F5F5;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-light:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-light:before {
    position: absolute;
    content: "";
    bottom: -36px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 36px solid #F5F5F5;
    border-right: 36px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-medium, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-medium {
    background: #848484;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-medium:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-medium:before {
    position: absolute;
    content: "";
    bottom: -36px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 36px solid #848484;
    border-right: 36px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-dark, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-dark {
    background: #4D4D4D;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-dark:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-dark:before {
    position: absolute;
    content: "";
    bottom: -36px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 36px solid #4D4D4D;
    border-right: 36px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-pro, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-pro {
    background: #07C960;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-pro:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-pro:before {
    position: absolute;
    content: "";
    bottom: -36px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 36px solid #07C960;
    border-right: 36px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-con, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-con {
    background: #bc0505;
  }
  :global(.bootstrap) .branding-p.branding-p-xl-con:before, :global(.bootstrap) .branding-p.branding-p-xl.branding-p-con:before {
    position: absolute;
    content: "";
    bottom: -36px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 36px solid #bc0505;
    border-right: 36px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl.with-border {
    border-right: 6px solid white;
    border-bottom: 6px solid white;
  }
  :global(.bootstrap) .branding-p.branding-p-xl.with-border:after {
    position: absolute;
    content: "";
    top: 72px;
    z-index: -1;
    left: 0;
    width: 0;
    height: 0;
    border-top: 37px solid white;
    border-right: 37px solid transparent;
  }
  :global(.bootstrap) .branding-p.branding-p-xl i {
    font-size: 30px;
  }
}
:global(.bootstrap) .branding-p.branding-p-sm {
  width: 17px;
  height: 17px;
}
:global(.bootstrap) .branding-p.branding-p-sm-primary, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-primary {
  background: #FFD700;
}
:global(.bootstrap) .branding-p.branding-p-sm-primary:before, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-primary:before {
  position: absolute;
  content: "";
  bottom: -8.5px;
  left: 0;
  width: 0;
  height: 0;
  border-top: 8.5px solid #FFD700;
  border-right: 8.5px solid transparent;
}
:global(.bootstrap) .branding-p.branding-p-sm-secondary, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-secondary {
  background: #08090D;
}
:global(.bootstrap) .branding-p.branding-p-sm-secondary:before, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-secondary:before {
  position: absolute;
  content: "";
  bottom: -8.5px;
  left: 0;
  width: 0;
  height: 0;
  border-top: 8.5px solid #08090D;
  border-right: 8.5px solid transparent;
}
:global(.bootstrap) .branding-p.branding-p-sm-success, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-success {
  background: #07C960;
}
:global(.bootstrap) .branding-p.branding-p-sm-success:before, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-success:before {
  position: absolute;
  content: "";
  bottom: -8.5px;
  left: 0;
  width: 0;
  height: 0;
  border-top: 8.5px solid #07C960;
  border-right: 8.5px solid transparent;
}
:global(.bootstrap) .branding-p.branding-p-sm-info, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-info {
  background: #785CA7;
}
:global(.bootstrap) .branding-p.branding-p-sm-info:before, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-info:before {
  position: absolute;
  content: "";
  bottom: -8.5px;
  left: 0;
  width: 0;
  height: 0;
  border-top: 8.5px solid #785CA7;
  border-right: 8.5px solid transparent;
}
:global(.bootstrap) .branding-p.branding-p-sm-warning, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-warning {
  background: #FD964C;
}
:global(.bootstrap) .branding-p.branding-p-sm-warning:before, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-warning:before {
  position: absolute;
  content: "";
  bottom: -8.5px;
  left: 0;
  width: 0;
  height: 0;
  border-top: 8.5px solid #FD964C;
  border-right: 8.5px solid transparent;
}
:global(.bootstrap) .branding-p.branding-p-sm-danger, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-danger {
  background: #bc0505;
}
:global(.bootstrap) .branding-p.branding-p-sm-danger:before, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-danger:before {
  position: absolute;
  content: "";
  bottom: -8.5px;
  left: 0;
  width: 0;
  height: 0;
  border-top: 8.5px solid #bc0505;
  border-right: 8.5px solid transparent;
}
:global(.bootstrap) .branding-p.branding-p-sm-light, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-light {
  background: #F5F5F5;
}
:global(.bootstrap) .branding-p.branding-p-sm-light:before, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-light:before {
  position: absolute;
  content: "";
  bottom: -8.5px;
  left: 0;
  width: 0;
  height: 0;
  border-top: 8.5px solid #F5F5F5;
  border-right: 8.5px solid transparent;
}
:global(.bootstrap) .branding-p.branding-p-sm-medium, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-medium {
  background: #848484;
}
:global(.bootstrap) .branding-p.branding-p-sm-medium:before, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-medium:before {
  position: absolute;
  content: "";
  bottom: -8.5px;
  left: 0;
  width: 0;
  height: 0;
  border-top: 8.5px solid #848484;
  border-right: 8.5px solid transparent;
}
:global(.bootstrap) .branding-p.branding-p-sm-dark, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-dark {
  background: #4D4D4D;
}
:global(.bootstrap) .branding-p.branding-p-sm-dark:before, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-dark:before {
  position: absolute;
  content: "";
  bottom: -8.5px;
  left: 0;
  width: 0;
  height: 0;
  border-top: 8.5px solid #4D4D4D;
  border-right: 8.5px solid transparent;
}
:global(.bootstrap) .branding-p.branding-p-sm-pro, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-pro {
  background: #07C960;
}
:global(.bootstrap) .branding-p.branding-p-sm-pro:before, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-pro:before {
  position: absolute;
  content: "";
  bottom: -8.5px;
  left: 0;
  width: 0;
  height: 0;
  border-top: 8.5px solid #07C960;
  border-right: 8.5px solid transparent;
}
:global(.bootstrap) .branding-p.branding-p-sm-con, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-con {
  background: #bc0505;
}
:global(.bootstrap) .branding-p.branding-p-sm-con:before, :global(.bootstrap) .branding-p.branding-p-sm.branding-p-con:before {
  position: absolute;
  content: "";
  bottom: -8.5px;
  left: 0;
  width: 0;
  height: 0;
  border-top: 8.5px solid #bc0505;
  border-right: 8.5px solid transparent;
}
:global(.bootstrap) .branding-p.branding-p-sm.with-border {
  border-right: 1px solid white;
  border-bottom: 1px solid white;
}
:global(.bootstrap) .branding-p.branding-p-sm.with-border:after {
  position: absolute;
  content: "";
  top: 17px;
  z-index: -1;
  left: 0;
  width: 0;
  height: 0;
  border-top: 4.5px solid white;
  border-right: 4.5px solid transparent;
}
:global(.bootstrap) .branding-p.branding-p-sm i {
  font-size: 12px;
}
@media (min-width: 1367px) {
  :global(.bootstrap) .yellow-banner-bg {
    background: url(https://images.peerspot.com/image/upload/v1742456886/site-images/home-page-hero-background-yellow.svg) no-repeat center center;
    background-size: cover;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    z-index: 0;
    height: 100vh;
  }
}
:global(.bootstrap) .screen-height {
  min-height: 100vh;
}
:global(.bootstrap) .screen-height-wo-topbar {
  min-height: calc(100vh - 50px);
}
:global(.bootstrap) .cursor-pointer {
  cursor: pointer;
}
:global(.bootstrap) label {
  font-weight: 700;
}
:global(.bootstrap) button:focus {
  outline: none;
}
:global(.bootstrap) fieldset {
  padding: 0 1rem;
}
:global(.bootstrap) fieldset legend {
  float: none;
  width: auto;
  margin: 0;
}
:global(.bootstrap) .h1,
:global(.bootstrap) .h2,
:global(.bootstrap) .h3,
:global(.bootstrap) .h4,
:global(.bootstrap) .h5,
:global(.bootstrap) .h6,
:global(.bootstrap) h1,
:global(.bootstrap) h2,
:global(.bootstrap) h3,
:global(.bootstrap) h4,
:global(.bootstrap) h5,
:global(.bootstrap) h6 {
  margin: 10px 0;
  font-family: "Martel", serif;
  font-weight: 900;
  line-height: 1.2;
  color: #08090D;
}
@media (min-width: 813px) {
  :global(.bootstrap) h1, :global(.bootstrap) .h1 {
    font-size: 32px;
  }
}
@media (max-width: 812px) {
  :global(.bootstrap) h1, :global(.bootstrap) .h1 {
    font-size: 24px;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) h2, :global(.bootstrap) .h2 {
    font-size: 24px;
  }
}
@media (max-width: 812px) {
  :global(.bootstrap) h2, :global(.bootstrap) .h2 {
    font-size: 18px;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) h3, :global(.bootstrap) .h3 {
    font-size: 22px;
  }
}
@media (max-width: 812px) {
  :global(.bootstrap) h3, :global(.bootstrap) .h3 {
    font-size: 15px;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) h4, :global(.bootstrap) .h4 {
    font-size: 20px;
  }
}
@media (max-width: 812px) {
  :global(.bootstrap) h4, :global(.bootstrap) .h4 {
    font-size: 15px;
  }
}
:global(.bootstrap) .font-9 {
  font-size: 9px !important;
}
:global(.bootstrap) .font-10 {
  font-size: 10px !important;
}
:global(.bootstrap) .font-11 {
  font-size: 11px !important;
}
:global(.bootstrap) .font-12 {
  font-size: 12px !important;
}
:global(.bootstrap) .font-13 {
  font-size: 13px !important;
}
:global(.bootstrap) .font-14 {
  font-size: 14px !important;
}
:global(.bootstrap) .font-15 {
  font-size: 15px !important;
}
:global(.bootstrap) .font-16 {
  font-size: 16px !important;
}
:global(.bootstrap) .font-17 {
  font-size: 17px !important;
}
:global(.bootstrap) .font-18 {
  font-size: 18px !important;
}
:global(.bootstrap) .font-19 {
  font-size: 19px !important;
}
:global(.bootstrap) .font-20 {
  font-size: 20px !important;
}
:global(.bootstrap) .font-21 {
  font-size: 21px !important;
}
:global(.bootstrap) .font-22 {
  font-size: 22px !important;
}
:global(.bootstrap) .font-23 {
  font-size: 23px !important;
}
:global(.bootstrap) .font-24 {
  font-size: 24px !important;
}
:global(.bootstrap) .font-25 {
  font-size: 25px !important;
}
:global(.bootstrap) .font-26 {
  font-size: 26px !important;
}
:global(.bootstrap) .font-27 {
  font-size: 27px !important;
}
:global(.bootstrap) .font-28 {
  font-size: 28px !important;
}
:global(.bootstrap) .font-weight-medium {
  font-weight: 500;
}
:global(.bootstrap) .font-weight-semibold {
  font-weight: 600;
}
:global(.bootstrap) .list-inline {
  margin-bottom: 0;
}
:global(.bootstrap) .list-inline .list-inline-item:not(:first-child):before {
  content: "|";
  color: #E5E6E1;
  padding: 0 10px;
}
:global(.bootstrap) .list-inline .list-inline-item:not(:last-child) {
  margin-right: 0;
}
:global(.bootstrap) .list-inline.list-justify-between {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
:global(.bootstrap) .list-inline.list-justify-between .list-inline-item {
  flex-grow: 1;
  flex-basis: auto;
  text-align: center;
  padding: 0 0.7em;
}
:global(.bootstrap) .list-inline.list-justify-between .list-inline-item:not(:first-child) {
  border-left: 1px solid #E5E6E1;
}
:global(.bootstrap) .list-inline.list-justify-between .list-inline-item:not(:first-child):before {
  content: "";
  padding: 0;
}
:global(.bootstrap) .avatar-xs {
  height: 1.5rem;
  width: 1.5rem;
}
:global(.bootstrap) .avatar-sm {
  height: 2.25rem;
  width: 2.25rem;
}
:global(.bootstrap) .avatar-md {
  height: 3.5rem;
  width: 3.5rem;
}
:global(.bootstrap) .avatar-lg {
  height: 4.5rem;
  width: 4.5rem;
}
:global(.bootstrap) .avatar-xl {
  height: 6rem;
  width: 6rem;
}
:global(.bootstrap) .avatar-xxl {
  height: 7.5rem;
  width: 7.5rem;
}
:global(.bootstrap) .avatar-title {
  align-items: center;
  color: #fff;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}
:global(.bootstrap) .avatar-group {
  padding-left: 12px;
}
:global(.bootstrap) .avatar-group .avatar-group-item {
  margin: 0 0 10px -12px;
  display: inline-block;
  border: 2px solid #fff;
  border-radius: 50%;
}
:global(.bootstrap) .width-xs {
  min-width: 80px;
}
:global(.bootstrap) .width-sm {
  min-width: 100px;
}
:global(.bootstrap) .width-md {
  min-width: 120px;
}
:global(.bootstrap) .width-lg {
  min-width: 140px;
}
:global(.bootstrap) .width-xl {
  min-width: 160px;
}
:global(.bootstrap) .font-family-primary {
  font-family: "Lato", sans-serif;
}
:global(.bootstrap) .font-family-secondary {
  font-family: "Lato", sans-serif;
}
:global(.bootstrap) .sp-line-1,
:global(.bootstrap) .sp-line-2,
:global(.bootstrap) .sp-line-3,
:global(.bootstrap) .sp-line-4,
:global(.bootstrap) .sp-line-5 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
:global(.bootstrap) .sp-line-1 {
  -webkit-line-clamp: 1 !important;
  line-clamp: 1 !important;
}
:global(.bootstrap) .sp-line-2 {
  -webkit-line-clamp: 2 !important;
  line-clamp: 2 !important;
}
:global(.bootstrap) .sp-line-3 {
  -webkit-line-clamp: 3 !important;
  line-clamp: 3 !important;
}
:global(.bootstrap) .sp-line-4 {
  -webkit-line-clamp: 4 !important;
  line-clamp: 4 !important;
}
:global(.bootstrap) .sp-line-5 {
  -webkit-line-clamp: 5 !important;
  line-clamp: 5 !important;
}
:global(.bootstrap) .icon-dual {
  color: #A9A9A9;
  fill: rgba(169, 169, 169, 0.12);
}
:global(.bootstrap) .icon-dual-primary {
  color: #FFD700;
  fill: rgba(255, 215, 0, 0.16);
}
:global(.bootstrap) .icon-dual-secondary {
  color: #08090D;
  fill: rgba(8, 9, 13, 0.16);
}
:global(.bootstrap) .icon-dual-success {
  color: #07C960;
  fill: rgba(7, 201, 96, 0.16);
}
:global(.bootstrap) .icon-dual-info {
  color: #785CA7;
  fill: rgba(120, 92, 167, 0.16);
}
:global(.bootstrap) .icon-dual-warning {
  color: #FD964C;
  fill: rgba(253, 150, 76, 0.16);
}
:global(.bootstrap) .icon-dual-danger {
  color: #bc0505;
  fill: rgba(188, 5, 5, 0.16);
}
:global(.bootstrap) .icon-dual-light {
  color: #F5F5F5;
  fill: rgba(245, 245, 245, 0.16);
}
:global(.bootstrap) .icon-dual-medium {
  color: #848484;
  fill: rgba(132, 132, 132, 0.16);
}
:global(.bootstrap) .icon-dual-dark {
  color: #4D4D4D;
  fill: rgba(77, 77, 77, 0.16);
}
:global(.bootstrap) .icon-dual-pro {
  color: #07C960;
  fill: rgba(7, 201, 96, 0.16);
}
:global(.bootstrap) .icon-dual-con {
  color: #bc0505;
  fill: rgba(188, 5, 5, 0.16);
}
:global(.bootstrap) .icons-xs {
  height: 16px;
  width: 16px;
}
:global(.bootstrap) .icons-sm {
  height: 24px;
  width: 24px;
}
:global(.bootstrap) .icons-md {
  height: 32px;
  width: 32px;
}
:global(.bootstrap) .icons-lg {
  height: 40px;
  width: 40px;
}
:global(.bootstrap) .icons-xl {
  height: 48px;
  width: 48px;
}
:global(.bootstrap) .icons-xxl {
  height: 60px;
  width: 60px;
}
:global(.bootstrap) .item-hovered:hover {
  background-color: #FAFAFA;
}
:global(.bootstrap) .gray-100 {
  color: #FAFAFA;
}
:global(.bootstrap) .bg-gray-100 {
  background: #FAFAFA;
}
:global(.bootstrap) .border-gray-100 {
  border-color: #FAFAFA !important;
}
:global(.bootstrap) .gray-200 {
  color: #F5F5F5;
}
:global(.bootstrap) .bg-gray-200 {
  background: #F5F5F5;
}
:global(.bootstrap) .border-gray-200 {
  border-color: #F5F5F5 !important;
}
:global(.bootstrap) .gray-300 {
  color: #ededed;
}
:global(.bootstrap) .bg-gray-300 {
  background: #ededed;
}
:global(.bootstrap) .border-gray-300 {
  border-color: #ededed !important;
}
:global(.bootstrap) .gray-400 {
  color: #E5E6E1;
}
:global(.bootstrap) .bg-gray-400 {
  background: #E5E6E1;
}
:global(.bootstrap) .border-gray-400 {
  border-color: #E5E6E1 !important;
}
:global(.bootstrap) .gray-500 {
  color: #adb5bd;
}
:global(.bootstrap) .bg-gray-500 {
  background: #adb5bd;
}
:global(.bootstrap) .border-gray-500 {
  border-color: #adb5bd !important;
}
:global(.bootstrap) .gray-600 {
  color: #A9A9A9;
}
:global(.bootstrap) .bg-gray-600 {
  background: #A9A9A9;
}
:global(.bootstrap) .border-gray-600 {
  border-color: #A9A9A9 !important;
}
:global(.bootstrap) .gray-700 {
  color: #848484;
}
:global(.bootstrap) .bg-gray-700 {
  background: #848484;
}
:global(.bootstrap) .border-gray-700 {
  border-color: #848484 !important;
}
:global(.bootstrap) .gray-800 {
  color: #666560;
}
:global(.bootstrap) .bg-gray-800 {
  background: #666560;
}
:global(.bootstrap) .border-gray-800 {
  border-color: #666560 !important;
}
:global(.bootstrap) .gray-900 {
  color: #4D4D4D;
}
:global(.bootstrap) .bg-gray-900 {
  background: #4D4D4D;
}
:global(.bootstrap) .border-gray-900 {
  border-color: #4D4D4D !important;
}
:global(.bootstrap) .hover-bg-primary:hover {
  background: #FFD700;
}
:global(.bootstrap) .hover-bg-soft-primary:hover {
  background-color: rgba(255, 215, 0, 0.06) !important;
}
:global(.bootstrap) .hover-primary:hover {
  color: #FFD700;
}
:global(.bootstrap) .hover-overlay-primary {
  --hover-overlay-opacity: 1;
  position: relative;
  z-index: 1;
}
:global(.bootstrap) .hover-overlay-primary:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  content: " ";
}
:global(.bootstrap) .hover-overlay-primary:hover:after {
  background: #FFD700;
  opacity: var(--hover-overlay-opacity);
  cursor: pointer;
}
:global(.bootstrap) .link-primary:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .hover-bg-secondary:hover {
  background: #08090D;
}
:global(.bootstrap) .hover-bg-soft-secondary:hover {
  background-color: rgba(8, 9, 13, 0.06) !important;
}
:global(.bootstrap) .hover-secondary:hover {
  color: #08090D;
}
:global(.bootstrap) .hover-overlay-secondary {
  --hover-overlay-opacity: 1;
  position: relative;
  z-index: 1;
}
:global(.bootstrap) .hover-overlay-secondary:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  content: " ";
}
:global(.bootstrap) .hover-overlay-secondary:hover:after {
  background: #08090D;
  opacity: var(--hover-overlay-opacity);
  cursor: pointer;
}
:global(.bootstrap) .link-secondary:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .hover-bg-success:hover {
  background: #07C960;
}
:global(.bootstrap) .hover-bg-soft-success:hover {
  background-color: rgba(7, 201, 96, 0.06) !important;
}
:global(.bootstrap) .hover-success:hover {
  color: #07C960;
}
:global(.bootstrap) .hover-overlay-success {
  --hover-overlay-opacity: 1;
  position: relative;
  z-index: 1;
}
:global(.bootstrap) .hover-overlay-success:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  content: " ";
}
:global(.bootstrap) .hover-overlay-success:hover:after {
  background: #07C960;
  opacity: var(--hover-overlay-opacity);
  cursor: pointer;
}
:global(.bootstrap) .link-success:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .hover-bg-info:hover {
  background: #785CA7;
}
:global(.bootstrap) .hover-bg-soft-info:hover {
  background-color: rgba(120, 92, 167, 0.06) !important;
}
:global(.bootstrap) .hover-info:hover {
  color: #785CA7;
}
:global(.bootstrap) .hover-overlay-info {
  --hover-overlay-opacity: 1;
  position: relative;
  z-index: 1;
}
:global(.bootstrap) .hover-overlay-info:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  content: " ";
}
:global(.bootstrap) .hover-overlay-info:hover:after {
  background: #785CA7;
  opacity: var(--hover-overlay-opacity);
  cursor: pointer;
}
:global(.bootstrap) .link-info:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .hover-bg-warning:hover {
  background: #FD964C;
}
:global(.bootstrap) .hover-bg-soft-warning:hover {
  background-color: rgba(253, 150, 76, 0.06) !important;
}
:global(.bootstrap) .hover-warning:hover {
  color: #FD964C;
}
:global(.bootstrap) .hover-overlay-warning {
  --hover-overlay-opacity: 1;
  position: relative;
  z-index: 1;
}
:global(.bootstrap) .hover-overlay-warning:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  content: " ";
}
:global(.bootstrap) .hover-overlay-warning:hover:after {
  background: #FD964C;
  opacity: var(--hover-overlay-opacity);
  cursor: pointer;
}
:global(.bootstrap) .link-warning:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .hover-bg-danger:hover {
  background: #bc0505;
}
:global(.bootstrap) .hover-bg-soft-danger:hover {
  background-color: rgba(188, 5, 5, 0.06) !important;
}
:global(.bootstrap) .hover-danger:hover {
  color: #bc0505;
}
:global(.bootstrap) .hover-overlay-danger {
  --hover-overlay-opacity: 1;
  position: relative;
  z-index: 1;
}
:global(.bootstrap) .hover-overlay-danger:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  content: " ";
}
:global(.bootstrap) .hover-overlay-danger:hover:after {
  background: #bc0505;
  opacity: var(--hover-overlay-opacity);
  cursor: pointer;
}
:global(.bootstrap) .link-danger:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .hover-bg-light:hover {
  background: #F5F5F5;
}
:global(.bootstrap) .hover-bg-soft-light:hover {
  background-color: rgba(245, 245, 245, 0.06) !important;
}
:global(.bootstrap) .hover-light:hover {
  color: #F5F5F5;
}
:global(.bootstrap) .hover-overlay-light {
  --hover-overlay-opacity: 1;
  position: relative;
  z-index: 1;
}
:global(.bootstrap) .hover-overlay-light:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  content: " ";
}
:global(.bootstrap) .hover-overlay-light:hover:after {
  background: #F5F5F5;
  opacity: var(--hover-overlay-opacity);
  cursor: pointer;
}
:global(.bootstrap) .link-light:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .hover-bg-medium:hover {
  background: #848484;
}
:global(.bootstrap) .hover-bg-soft-medium:hover {
  background-color: rgba(132, 132, 132, 0.06) !important;
}
:global(.bootstrap) .hover-medium:hover {
  color: #848484;
}
:global(.bootstrap) .hover-overlay-medium {
  --hover-overlay-opacity: 1;
  position: relative;
  z-index: 1;
}
:global(.bootstrap) .hover-overlay-medium:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  content: " ";
}
:global(.bootstrap) .hover-overlay-medium:hover:after {
  background: #848484;
  opacity: var(--hover-overlay-opacity);
  cursor: pointer;
}
:global(.bootstrap) .link-medium:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .hover-bg-dark:hover {
  background: #4D4D4D;
}
:global(.bootstrap) .hover-bg-soft-dark:hover {
  background-color: rgba(77, 77, 77, 0.06) !important;
}
:global(.bootstrap) .hover-dark:hover {
  color: #4D4D4D;
}
:global(.bootstrap) .hover-overlay-dark {
  --hover-overlay-opacity: 1;
  position: relative;
  z-index: 1;
}
:global(.bootstrap) .hover-overlay-dark:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  content: " ";
}
:global(.bootstrap) .hover-overlay-dark:hover:after {
  background: #4D4D4D;
  opacity: var(--hover-overlay-opacity);
  cursor: pointer;
}
:global(.bootstrap) .link-dark:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .hover-bg-pro:hover {
  background: #07C960;
}
:global(.bootstrap) .hover-bg-soft-pro:hover {
  background-color: rgba(7, 201, 96, 0.06) !important;
}
:global(.bootstrap) .hover-pro:hover {
  color: #07C960;
}
:global(.bootstrap) .hover-overlay-pro {
  --hover-overlay-opacity: 1;
  position: relative;
  z-index: 1;
}
:global(.bootstrap) .hover-overlay-pro:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  content: " ";
}
:global(.bootstrap) .hover-overlay-pro:hover:after {
  background: #07C960;
  opacity: var(--hover-overlay-opacity);
  cursor: pointer;
}
:global(.bootstrap) .link-pro:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .hover-bg-con:hover {
  background: #bc0505;
}
:global(.bootstrap) .hover-bg-soft-con:hover {
  background-color: rgba(188, 5, 5, 0.06) !important;
}
:global(.bootstrap) .hover-con:hover {
  color: #bc0505;
}
:global(.bootstrap) .hover-overlay-con {
  --hover-overlay-opacity: 1;
  position: relative;
  z-index: 1;
}
:global(.bootstrap) .hover-overlay-con:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  content: " ";
}
:global(.bootstrap) .hover-overlay-con:hover:after {
  background: #bc0505;
  opacity: var(--hover-overlay-opacity);
  cursor: pointer;
}
:global(.bootstrap) .link-con:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .text-blue {
  color: #36627F !important;
}
:global(.bootstrap) .bg-blue {
  background-color: #36627F !important;
}
:global(.bootstrap) .hover-bg-blue:hover {
  background: #36627F;
}
:global(.bootstrap) .hover-blue:hover {
  color: #36627F !important;
}
:global(.bootstrap) .link-blue:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .blue-links a {
  color: #36627F;
  text-decoration: underline;
}
:global(.bootstrap) .blue-links a:hover {
  color: #27465b;
}
:global(.bootstrap) .blue-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-blue-hover {
  color: #0a4d78 !important;
}
:global(.bootstrap) .bg-blue-hover {
  background-color: #0a4d78 !important;
}
:global(.bootstrap) .hover-bg-blue-hover:hover {
  background: #0a4d78;
}
:global(.bootstrap) .hover-blue-hover:hover {
  color: #0a4d78 !important;
}
:global(.bootstrap) .link-blue-hover:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .blue-hover-links a {
  color: #0a4d78;
  text-decoration: underline;
}
:global(.bootstrap) .blue-hover-links a:hover {
  color: #062f49;
}
:global(.bootstrap) .blue-hover-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-blue-link {
  color: #2a8ecf !important;
}
:global(.bootstrap) .bg-blue-link {
  background-color: #2a8ecf !important;
}
:global(.bootstrap) .hover-bg-blue-link:hover {
  background: #2a8ecf;
}
:global(.bootstrap) .hover-blue-link:hover {
  color: #2a8ecf !important;
}
:global(.bootstrap) .link-blue-link:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .blue-link-links a {
  color: #2a8ecf;
  text-decoration: underline;
}
:global(.bootstrap) .blue-link-links a:hover {
  color: #2171a5;
}
:global(.bootstrap) .blue-link-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-indigo {
  color: #785CA7 !important;
}
:global(.bootstrap) .bg-indigo {
  background-color: #785CA7 !important;
}
:global(.bootstrap) .hover-bg-indigo:hover {
  background: #785CA7;
}
:global(.bootstrap) .hover-indigo:hover {
  color: #785CA7 !important;
}
:global(.bootstrap) .link-indigo:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .indigo-links a {
  color: #785CA7;
  text-decoration: underline;
}
:global(.bootstrap) .indigo-links a:hover {
  color: #604987;
}
:global(.bootstrap) .indigo-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-purple {
  color: #785CA7 !important;
}
:global(.bootstrap) .bg-purple {
  background-color: #785CA7 !important;
}
:global(.bootstrap) .hover-bg-purple:hover {
  background: #785CA7;
}
:global(.bootstrap) .hover-purple:hover {
  color: #785CA7 !important;
}
:global(.bootstrap) .link-purple:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .purple-links a {
  color: #785CA7;
  text-decoration: underline;
}
:global(.bootstrap) .purple-links a:hover {
  color: #604987;
}
:global(.bootstrap) .purple-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-pink {
  color: #E94A7E !important;
}
:global(.bootstrap) .bg-pink {
  background-color: #E94A7E !important;
}
:global(.bootstrap) .hover-bg-pink:hover {
  background: #E94A7E;
}
:global(.bootstrap) .hover-pink:hover {
  color: #E94A7E !important;
}
:global(.bootstrap) .link-pink:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .pink-links a {
  color: #E94A7E;
  text-decoration: underline;
}
:global(.bootstrap) .pink-links a:hover {
  color: #e31d5e;
}
:global(.bootstrap) .pink-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-red {
  color: #FF0000 !important;
}
:global(.bootstrap) .bg-red {
  background-color: #FF0000 !important;
}
:global(.bootstrap) .hover-bg-red:hover {
  background: #FF0000;
}
:global(.bootstrap) .hover-red:hover {
  color: #FF0000 !important;
}
:global(.bootstrap) .link-red:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .red-links a {
  color: #FF0000;
  text-decoration: underline;
}
:global(.bootstrap) .red-links a:hover {
  color: #cc0000;
}
:global(.bootstrap) .red-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-reddark {
  color: #bc0505 !important;
}
:global(.bootstrap) .bg-reddark {
  background-color: #bc0505 !important;
}
:global(.bootstrap) .hover-bg-reddark:hover {
  background: #bc0505;
}
:global(.bootstrap) .hover-reddark:hover {
  color: #bc0505 !important;
}
:global(.bootstrap) .link-reddark:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .reddark-links a {
  color: #bc0505;
  text-decoration: underline;
}
:global(.bootstrap) .reddark-links a:hover {
  color: #8a0404;
}
:global(.bootstrap) .reddark-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-orange {
  color: #FD964C !important;
}
:global(.bootstrap) .bg-orange {
  background-color: #FD964C !important;
}
:global(.bootstrap) .hover-bg-orange:hover {
  background: #FD964C;
}
:global(.bootstrap) .hover-orange:hover {
  color: #FD964C !important;
}
:global(.bootstrap) .link-orange:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .orange-links a {
  color: #FD964C;
  text-decoration: underline;
}
:global(.bootstrap) .orange-links a:hover {
  color: #fc781a;
}
:global(.bootstrap) .orange-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-yellow {
  color: #FFD700 !important;
}
:global(.bootstrap) .bg-yellow {
  background-color: #FFD700 !important;
}
:global(.bootstrap) .hover-bg-yellow:hover {
  background: #FFD700;
}
:global(.bootstrap) .hover-yellow:hover {
  color: #FFD700 !important;
}
:global(.bootstrap) .link-yellow:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .yellow-links a {
  color: #FFD700;
  text-decoration: underline;
}
:global(.bootstrap) .yellow-links a:hover {
  color: #ccac00;
}
:global(.bootstrap) .yellow-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-yellowdark {
  color: #FFCC00 !important;
}
:global(.bootstrap) .bg-yellowdark {
  background-color: #FFCC00 !important;
}
:global(.bootstrap) .hover-bg-yellowdark:hover {
  background: #FFCC00;
}
:global(.bootstrap) .hover-yellowdark:hover {
  color: #FFCC00 !important;
}
:global(.bootstrap) .link-yellowdark:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .yellowdark-links a {
  color: #FFCC00;
  text-decoration: underline;
}
:global(.bootstrap) .yellowdark-links a:hover {
  color: #cca300;
}
:global(.bootstrap) .yellowdark-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-green {
  color: #70CACA !important;
}
:global(.bootstrap) .bg-green {
  background-color: #70CACA !important;
}
:global(.bootstrap) .hover-bg-green:hover {
  background: #70CACA;
}
:global(.bootstrap) .hover-green:hover {
  color: #70CACA !important;
}
:global(.bootstrap) .link-green:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .green-links a {
  color: #70CACA;
  text-decoration: underline;
}
:global(.bootstrap) .green-links a:hover {
  color: #4bbcbc;
}
:global(.bootstrap) .green-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-teal {
  color: #70CACA !important;
}
:global(.bootstrap) .bg-teal {
  background-color: #70CACA !important;
}
:global(.bootstrap) .hover-bg-teal:hover {
  background: #70CACA;
}
:global(.bootstrap) .hover-teal:hover {
  color: #70CACA !important;
}
:global(.bootstrap) .link-teal:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .teal-links a {
  color: #70CACA;
  text-decoration: underline;
}
:global(.bootstrap) .teal-links a:hover {
  color: #4bbcbc;
}
:global(.bootstrap) .teal-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-cyan {
  color: #70CACA !important;
}
:global(.bootstrap) .bg-cyan {
  background-color: #70CACA !important;
}
:global(.bootstrap) .hover-bg-cyan:hover {
  background: #70CACA;
}
:global(.bootstrap) .hover-cyan:hover {
  color: #70CACA !important;
}
:global(.bootstrap) .link-cyan:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .cyan-links a {
  color: #70CACA;
  text-decoration: underline;
}
:global(.bootstrap) .cyan-links a:hover {
  color: #4bbcbc;
}
:global(.bootstrap) .cyan-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-white {
  color: #fff !important;
}
:global(.bootstrap) .bg-white {
  background-color: #fff !important;
}
:global(.bootstrap) .hover-bg-white:hover {
  background: #fff;
}
:global(.bootstrap) .hover-white:hover {
  color: #fff !important;
}
:global(.bootstrap) .link-white:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .white-links a {
  color: #fff;
  text-decoration: underline;
}
:global(.bootstrap) .white-links a:hover {
  color: #e6e6e6;
}
:global(.bootstrap) .white-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-gray {
  color: #E5E6E1 !important;
}
:global(.bootstrap) .bg-gray {
  background-color: #E5E6E1 !important;
}
:global(.bootstrap) .hover-bg-gray:hover {
  background: #E5E6E1;
}
:global(.bootstrap) .hover-gray:hover {
  color: #E5E6E1 !important;
}
:global(.bootstrap) .link-gray:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .gray-links a {
  color: #E5E6E1;
  text-decoration: underline;
}
:global(.bootstrap) .gray-links a:hover {
  color: #cdcfc5;
}
:global(.bootstrap) .gray-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-gray-dark {
  color: #848484 !important;
}
:global(.bootstrap) .bg-gray-dark {
  background-color: #848484 !important;
}
:global(.bootstrap) .hover-bg-gray-dark:hover {
  background: #848484;
}
:global(.bootstrap) .hover-gray-dark:hover {
  color: #848484 !important;
}
:global(.bootstrap) .link-gray-dark:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) .gray-dark-links a {
  color: #848484;
  text-decoration: underline;
}
:global(.bootstrap) .gray-dark-links a:hover {
  color: #6b6b6b;
}
:global(.bootstrap) .gray-dark-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-twitter {
  color: #0F1419;
}
:global(.bootstrap) .text-twitter:hover {
  color: #050709;
}
:global(.bootstrap) .text-x-twitter {
  color: #0F1419;
}
:global(.bootstrap) .text-x-twitter:hover {
  color: #050709;
}
:global(.bootstrap) .text-twitter-reverse {
  color: #E5E5E7;
}
:global(.bootstrap) .text-twitter-reverse:hover {
  color: #d8d8db;
}
:global(.bootstrap) .text-facebook {
  color: #4267B2;
}
:global(.bootstrap) .text-facebook:hover {
  color: #3b5c9f;
}
:global(.bootstrap) .text-linkedin {
  color: #0077B5;
}
:global(.bootstrap) .text-linkedin:hover {
  color: #00669c;
}
:global(.bootstrap) .text-youtube {
  color: #FF0000;
}
:global(.bootstrap) .text-youtube:hover {
  color: #e60000;
}
:global(.bootstrap) .text-whatsapp {
  color: #25D366;
}
:global(.bootstrap) .text-whatsapp:hover {
  color: #21bd5c;
}
:global(.bootstrap) .primary-links a {
  color: #FFD700;
  text-decoration: underline;
}
:global(.bootstrap) .primary-links a:hover {
  color: #ccac00;
}
:global(.bootstrap) .primary-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .secondary-links a {
  color: #08090D;
  text-decoration: underline;
}
:global(.bootstrap) .secondary-links a:hover {
  color: black;
}
:global(.bootstrap) .secondary-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .success-links a {
  color: #07C960;
  text-decoration: underline;
}
:global(.bootstrap) .success-links a:hover {
  color: #059848;
}
:global(.bootstrap) .success-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .info-links a {
  color: #785CA7;
  text-decoration: underline;
}
:global(.bootstrap) .info-links a:hover {
  color: #604987;
}
:global(.bootstrap) .info-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .warning-links a {
  color: #FD964C;
  text-decoration: underline;
}
:global(.bootstrap) .warning-links a:hover {
  color: #fc781a;
}
:global(.bootstrap) .warning-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .danger-links a {
  color: #bc0505;
  text-decoration: underline;
}
:global(.bootstrap) .danger-links a:hover {
  color: #8a0404;
}
:global(.bootstrap) .danger-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .light-links a {
  color: #F5F5F5;
  text-decoration: underline;
}
:global(.bootstrap) .light-links a:hover {
  color: gainsboro;
}
:global(.bootstrap) .light-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .medium-links a {
  color: #848484;
  text-decoration: underline;
}
:global(.bootstrap) .medium-links a:hover {
  color: #6b6b6b;
}
:global(.bootstrap) .medium-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .dark-links a {
  color: #4D4D4D;
  text-decoration: underline;
}
:global(.bootstrap) .dark-links a:hover {
  color: #343434;
}
:global(.bootstrap) .dark-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .pro-links a {
  color: #07C960;
  text-decoration: underline;
}
:global(.bootstrap) .pro-links a:hover {
  color: #059848;
}
:global(.bootstrap) .pro-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .con-links a {
  color: #bc0505;
  text-decoration: underline;
}
:global(.bootstrap) .con-links a:hover {
  color: #8a0404;
}
:global(.bootstrap) .con-links a:focus-visible {
  outline: none;
}
:global(.bootstrap) .text-primary {
  color: #FFCC00 !important;
}
:global(.bootstrap) .text-primary:hover {
  color: #e6b800 !important;
}
:global(.bootstrap) .hover-bold:hover {
  font-weight: bold;
}
:global(.bootstrap) a:not(.disabled) {
  cursor: pointer;
}
:global(.bootstrap) a.disabled {
  pointer-events: none;
  cursor: text;
}
:global(.bootstrap) a.link-as-text {
  color: inherit;
  text-decoration: none;
}
:global(.bootstrap) a.link-as-text:hover {
  background: inherit;
}
:global(.bootstrap) a.text-secondary {
  text-decoration: underline;
  text-decoration-color: #FFD700;
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
}
:global(.bootstrap) a.text-secondary:hover {
  background: #FFD700;
}
:global(.bootstrap) .border-between > [class*=col-] {
  position: relative;
}
:global(.bootstrap) .border-between > [class*=col-]:not(:last-child):after {
  background: #f3f3f3;
  width: 1px;
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
}
@media (min-width: 576px) {
  :global(.bootstrap) .border-between > [class*=col-] {
    padding: 0 2rem;
  }
}
@media (min-width: 992px) {
  :global(.bootstrap) .border-between > .col-lg-4:nth-child(3n):after {
    width: 0;
    background: unset;
  }
  :global(.bootstrap) .border-between > .col-lg-6:nth-child(2n):after {
    width: 0;
    background: unset;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .border-between > .col-md-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-between > .col-md-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 576px) and (max-width: 813px) {
  :global(.bootstrap) .border-between > .col-sm-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-between > .col-sm-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 0) {
  :global(.bootstrap) .border-xs-between > [class*=col-] {
    position: relative;
  }
  :global(.bootstrap) .border-xs-between > [class*=col-]:not(:last-child):after {
    background: #f3f3f3;
    width: 1px;
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
  }
}
@media (min-width: 0) and (min-width: 576px) {
  :global(.bootstrap) .border-xs-between > [class*=col-] {
    padding: 0 2rem;
  }
}
@media (min-width: 0) and (min-width: 992px) {
  :global(.bootstrap) .border-xs-between > .col-lg-4:nth-child(3n):after {
    width: 0;
    background: unset;
  }
  :global(.bootstrap) .border-xs-between > .col-lg-6:nth-child(2n):after {
    width: 0;
    background: unset;
  }
}
@media (min-width: 0) and (min-width: 813px) {
  :global(.bootstrap) .border-xs-between > .col-md-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-xs-between > .col-md-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 0) and (min-width: 576px) and (max-width: 813px) {
  :global(.bootstrap) .border-xs-between > .col-sm-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-xs-between > .col-sm-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 576px) {
  :global(.bootstrap) .border-sm-between > [class*=col-] {
    position: relative;
  }
  :global(.bootstrap) .border-sm-between > [class*=col-]:not(:last-child):after {
    background: #f3f3f3;
    width: 1px;
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
  }
}
@media (min-width: 576px) and (min-width: 576px) {
  :global(.bootstrap) .border-sm-between > [class*=col-] {
    padding: 0 2rem;
  }
}
@media (min-width: 576px) and (min-width: 992px) {
  :global(.bootstrap) .border-sm-between > .col-lg-4:nth-child(3n):after {
    width: 0;
    background: unset;
  }
  :global(.bootstrap) .border-sm-between > .col-lg-6:nth-child(2n):after {
    width: 0;
    background: unset;
  }
}
@media (min-width: 576px) and (min-width: 813px) {
  :global(.bootstrap) .border-sm-between > .col-md-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-sm-between > .col-md-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 576px) and (min-width: 576px) and (max-width: 813px) {
  :global(.bootstrap) .border-sm-between > .col-sm-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-sm-between > .col-sm-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 813px) {
  :global(.bootstrap) .border-md-between > [class*=col-] {
    position: relative;
  }
  :global(.bootstrap) .border-md-between > [class*=col-]:not(:last-child):after {
    background: #f3f3f3;
    width: 1px;
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
  }
}
@media (min-width: 813px) and (min-width: 576px) {
  :global(.bootstrap) .border-md-between > [class*=col-] {
    padding: 0 2rem;
  }
}
@media (min-width: 813px) and (min-width: 992px) {
  :global(.bootstrap) .border-md-between > .col-lg-4:nth-child(3n):after {
    width: 0;
    background: unset;
  }
  :global(.bootstrap) .border-md-between > .col-lg-6:nth-child(2n):after {
    width: 0;
    background: unset;
  }
}
@media (min-width: 813px) and (min-width: 813px) {
  :global(.bootstrap) .border-md-between > .col-md-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-md-between > .col-md-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 813px) and (min-width: 576px) and (max-width: 813px) {
  :global(.bootstrap) .border-md-between > .col-sm-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-md-between > .col-sm-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 992px) {
  :global(.bootstrap) .border-lg-between > [class*=col-] {
    position: relative;
  }
  :global(.bootstrap) .border-lg-between > [class*=col-]:not(:last-child):after {
    background: #f3f3f3;
    width: 1px;
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
  }
}
@media (min-width: 992px) and (min-width: 576px) {
  :global(.bootstrap) .border-lg-between > [class*=col-] {
    padding: 0 2rem;
  }
}
@media (min-width: 992px) and (min-width: 992px) {
  :global(.bootstrap) .border-lg-between > .col-lg-4:nth-child(3n):after {
    width: 0;
    background: unset;
  }
  :global(.bootstrap) .border-lg-between > .col-lg-6:nth-child(2n):after {
    width: 0;
    background: unset;
  }
}
@media (min-width: 992px) and (min-width: 813px) {
  :global(.bootstrap) .border-lg-between > .col-md-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-lg-between > .col-md-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 992px) and (min-width: 576px) and (max-width: 813px) {
  :global(.bootstrap) .border-lg-between > .col-sm-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-lg-between > .col-sm-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 1367px) {
  :global(.bootstrap) .border-xl-between > [class*=col-] {
    position: relative;
  }
  :global(.bootstrap) .border-xl-between > [class*=col-]:not(:last-child):after {
    background: #f3f3f3;
    width: 1px;
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
  }
}
@media (min-width: 1367px) and (min-width: 576px) {
  :global(.bootstrap) .border-xl-between > [class*=col-] {
    padding: 0 2rem;
  }
}
@media (min-width: 1367px) and (min-width: 992px) {
  :global(.bootstrap) .border-xl-between > .col-lg-4:nth-child(3n):after {
    width: 0;
    background: unset;
  }
  :global(.bootstrap) .border-xl-between > .col-lg-6:nth-child(2n):after {
    width: 0;
    background: unset;
  }
}
@media (min-width: 1367px) and (min-width: 813px) {
  :global(.bootstrap) .border-xl-between > .col-md-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-xl-between > .col-md-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 1367px) and (min-width: 576px) and (max-width: 813px) {
  :global(.bootstrap) .border-xl-between > .col-sm-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-xl-between > .col-sm-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 1400px) {
  :global(.bootstrap) .border-xxl-between > [class*=col-] {
    position: relative;
  }
  :global(.bootstrap) .border-xxl-between > [class*=col-]:not(:last-child):after {
    background: #f3f3f3;
    width: 1px;
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
  }
}
@media (min-width: 1400px) and (min-width: 576px) {
  :global(.bootstrap) .border-xxl-between > [class*=col-] {
    padding: 0 2rem;
  }
}
@media (min-width: 1400px) and (min-width: 992px) {
  :global(.bootstrap) .border-xxl-between > .col-lg-4:nth-child(3n):after {
    width: 0;
    background: unset;
  }
  :global(.bootstrap) .border-xxl-between > .col-lg-6:nth-child(2n):after {
    width: 0;
    background: unset;
  }
}
@media (min-width: 1400px) and (min-width: 813px) {
  :global(.bootstrap) .border-xxl-between > .col-md-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-xxl-between > .col-md-6:nth-child(2n):after {
    width: 0;
  }
}
@media (min-width: 1400px) and (min-width: 576px) and (max-width: 813px) {
  :global(.bootstrap) .border-xxl-between > .col-sm-4:nth-child(3n):after {
    width: 0;
  }
  :global(.bootstrap) .border-xxl-between > .col-sm-6:nth-child(2n):after {
    width: 0;
  }
}
:global(.bootstrap) .overflow-x-auto {
  overflow-x: auto;
}
:global(.bootstrap) .overflow-y-auto {
  overflow-y: auto;
}
:global(.bootstrap) .text-top > * {
  vertical-align: text-top;
}
:global(.bootstrap) .text-bottom > * {
  vertical-align: text-bottom;
}
@media (max-width: 813px) {
  :global(.bootstrap) {
    /* A multi-column layout of lists on desktop should appear as 1 list on mobile */
  }
  :global(.bootstrap) .row [class*=col-md-]:has(> .list-group):not(:last-child) .list-group > .list-group-item:last-child {
    border-bottom-width: 1px;
  }
}
:global(.bootstrap) .shadow-bottom {
  box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.12);
}